import { jsxs as _s, jsx as le, Fragment as Cs } from "react/jsx-runtime";
import { g as ii, c as ks } from "./tailwind-BXrsiEcF.js";
import { forwardRef as Ss } from "react";
function jr(e) {
  const t = [], n = String(e || "");
  let r = n.indexOf(","), u = 0, i = !1;
  for (; !i; ) {
    r === -1 && (r = n.length, i = !0);
    const a = n.slice(u, r).trim();
    (a || !i) && t.push(a), u = r + 1, r = n.indexOf(",", u);
  }
  return t;
}
function ai(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const ys = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Is = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, xs = {};
function Qr(e, t) {
  return (xs.jsx ? Is : ys).test(e);
}
const Ns = /[ \t\n\f\r]/g;
function Os(e) {
  return typeof e == "object" ? e.type === "text" ? $r(e.value) : !1 : $r(e);
}
function $r(e) {
  return e.replace(Ns, "") === "";
}
let Xt = class {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
};
Xt.prototype.property = {};
Xt.prototype.normal = {};
Xt.prototype.space = null;
function si(e, t) {
  const n = {}, r = {};
  let u = -1;
  for (; ++u < e.length; )
    Object.assign(n, e[u].property), Object.assign(r, e[u].normal);
  return new Xt(n, r, t);
}
function Jn(e) {
  return e.toLowerCase();
}
let Pe = class {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
};
Pe.prototype.space = null;
Pe.prototype.boolean = !1;
Pe.prototype.booleanish = !1;
Pe.prototype.overloadedBoolean = !1;
Pe.prototype.number = !1;
Pe.prototype.commaSeparated = !1;
Pe.prototype.spaceSeparated = !1;
Pe.prototype.commaOrSpaceSeparated = !1;
Pe.prototype.mustUseProperty = !1;
Pe.prototype.defined = !1;
let Ls = 0;
const $ = lt(), ce = lt(), li = lt(), P = lt(), ue = lt(), bt = lt(), xe = lt();
function lt() {
  return 2 ** ++Ls;
}
const Zn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: $,
  booleanish: ce,
  commaOrSpaceSeparated: xe,
  commaSeparated: bt,
  number: P,
  overloadedBoolean: li,
  spaceSeparated: ue
}, Symbol.toStringTag, { value: "Module" })), Dn = Object.keys(Zn);
let Tr = class extends Pe {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, u) {
    let i = -1;
    if (super(t, n), Xr(this, "space", u), typeof r == "number")
      for (; ++i < Dn.length; ) {
        const a = Dn[i];
        Xr(this, Dn[i], (r & Zn[a]) === Zn[a]);
      }
  }
};
Tr.prototype.defined = !0;
function Xr(e, t, n) {
  n && (e[t] = n);
}
const Ds = {}.hasOwnProperty;
function St(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (Ds.call(e.properties, r)) {
      const u = e.properties[r], i = new Tr(
        r,
        e.transform(e.attributes || {}, r),
        u,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[Jn(r)] = r, n[Jn(i.attribute)] = r;
    }
  return new Xt(t, n, e.space);
}
const oi = St({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), ci = St({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function hi(e, t) {
  return t in e ? e[t] : t;
}
function fi(e, t) {
  return hi(e, t.toLowerCase());
}
const di = St({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: fi,
  properties: { xmlns: null, xmlnsXLink: null }
}), mi = St({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: ce,
    ariaAutoComplete: null,
    ariaBusy: ce,
    ariaChecked: ce,
    ariaColCount: P,
    ariaColIndex: P,
    ariaColSpan: P,
    ariaControls: ue,
    ariaCurrent: null,
    ariaDescribedBy: ue,
    ariaDetails: null,
    ariaDisabled: ce,
    ariaDropEffect: ue,
    ariaErrorMessage: null,
    ariaExpanded: ce,
    ariaFlowTo: ue,
    ariaGrabbed: ce,
    ariaHasPopup: null,
    ariaHidden: ce,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ue,
    ariaLevel: P,
    ariaLive: null,
    ariaModal: ce,
    ariaMultiLine: ce,
    ariaMultiSelectable: ce,
    ariaOrientation: null,
    ariaOwns: ue,
    ariaPlaceholder: null,
    ariaPosInSet: P,
    ariaPressed: ce,
    ariaReadOnly: ce,
    ariaRelevant: null,
    ariaRequired: ce,
    ariaRoleDescription: ue,
    ariaRowCount: P,
    ariaRowIndex: P,
    ariaRowSpan: P,
    ariaSelected: ce,
    ariaSetSize: P,
    ariaSort: null,
    ariaValueMax: P,
    ariaValueMin: P,
    ariaValueNow: P,
    ariaValueText: null,
    role: null
  }
}), Rs = St({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: fi,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: bt,
    acceptCharset: ue,
    accessKey: ue,
    action: null,
    allow: null,
    allowFullScreen: $,
    allowPaymentRequest: $,
    allowUserMedia: $,
    alt: null,
    as: null,
    async: $,
    autoCapitalize: null,
    autoComplete: ue,
    autoFocus: $,
    autoPlay: $,
    blocking: ue,
    capture: null,
    charSet: null,
    checked: $,
    cite: null,
    className: ue,
    cols: P,
    colSpan: null,
    content: null,
    contentEditable: ce,
    controls: $,
    controlsList: ue,
    coords: P | bt,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: $,
    defer: $,
    dir: null,
    dirName: null,
    disabled: $,
    download: li,
    draggable: ce,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: $,
    formTarget: null,
    headers: ue,
    height: P,
    hidden: $,
    high: P,
    href: null,
    hrefLang: null,
    htmlFor: ue,
    httpEquiv: ue,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: $,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: $,
    itemId: null,
    itemProp: ue,
    itemRef: ue,
    itemScope: $,
    itemType: ue,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: $,
    low: P,
    manifest: null,
    max: null,
    maxLength: P,
    media: null,
    method: null,
    min: null,
    minLength: P,
    multiple: $,
    muted: $,
    name: null,
    nonce: null,
    noModule: $,
    noValidate: $,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: $,
    optimum: P,
    pattern: null,
    ping: ue,
    placeholder: null,
    playsInline: $,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: $,
    referrerPolicy: null,
    rel: ue,
    required: $,
    reversed: $,
    rows: P,
    rowSpan: P,
    sandbox: ue,
    scope: null,
    scoped: $,
    seamless: $,
    selected: $,
    shadowRootClonable: $,
    shadowRootDelegatesFocus: $,
    shadowRootMode: null,
    shape: null,
    size: P,
    sizes: null,
    slot: null,
    span: P,
    spellCheck: ce,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: P,
    step: null,
    style: null,
    tabIndex: P,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: $,
    useMap: null,
    value: ce,
    width: P,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ue,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: P,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: P,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: $,
    // Lists. Use CSS to reduce space between items instead
    declare: $,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: P,
    // `<img>` and `<object>`
    leftMargin: P,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: P,
    // `<body>`
    marginWidth: P,
    // `<body>`
    noResize: $,
    // `<frame>`
    noHref: $,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: $,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: $,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: P,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: ce,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: P,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: P,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: $,
    disableRemotePlayback: $,
    prefix: null,
    property: null,
    results: P,
    security: null,
    unselectable: null
  }
}), Ps = St({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: hi,
  properties: {
    about: xe,
    accentHeight: P,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: P,
    amplitude: P,
    arabicForm: null,
    ascent: P,
    attributeName: null,
    attributeType: null,
    azimuth: P,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: P,
    by: null,
    calcMode: null,
    capHeight: P,
    className: ue,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: P,
    diffuseConstant: P,
    direction: null,
    display: null,
    dur: null,
    divisor: P,
    dominantBaseline: null,
    download: $,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: P,
    enableBackground: null,
    end: null,
    event: null,
    exponent: P,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: P,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: bt,
    g2: bt,
    glyphName: bt,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: P,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: P,
    horizOriginX: P,
    horizOriginY: P,
    id: null,
    ideographic: P,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: P,
    k: P,
    k1: P,
    k2: P,
    k3: P,
    k4: P,
    kernelMatrix: xe,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: P,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: P,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: P,
    overlineThickness: P,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: P,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ue,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: P,
    pointsAtY: P,
    pointsAtZ: P,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: xe,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: xe,
    rev: xe,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: xe,
    requiredFeatures: xe,
    requiredFonts: xe,
    requiredFormats: xe,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: P,
    specularExponent: P,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: P,
    strikethroughThickness: P,
    string: null,
    stroke: null,
    strokeDashArray: xe,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: P,
    strokeOpacity: P,
    strokeWidth: null,
    style: null,
    surfaceScale: P,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: xe,
    tabIndex: P,
    tableValues: null,
    target: null,
    targetX: P,
    targetY: P,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: xe,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: P,
    underlineThickness: P,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: P,
    values: null,
    vAlphabetic: P,
    vMathematical: P,
    vectorEffect: null,
    vHanging: P,
    vIdeographic: P,
    version: null,
    vertAdvY: P,
    vertOriginX: P,
    vertOriginY: P,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: P,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), ws = /^data[-\w.:]+$/i, Gr = /-[a-z]/g, Ms = /[A-Z]/g;
function pi(e, t) {
  const n = Jn(t);
  let r = t, u = Pe;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && ws.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(Gr, Fs);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!Gr.test(i)) {
        let a = i.replace(Ms, Bs);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    u = Tr;
  }
  return new u(r, t);
}
function Bs(e) {
  return "-" + e.toLowerCase();
}
function Fs(e) {
  return e.charAt(1).toUpperCase();
}
const vs = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Ei = si([ci, oi, di, mi, Rs], "html"), Gt = si([ci, oi, di, mi, Ps], "svg");
function Kr(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function gi(e) {
  return e.join(" ").trim();
}
var pt = {}, Rn, Jr;
function Us() {
  if (Jr) return Rn;
  Jr = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, u = /^:\s*/, i = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, a = /^[;\s]*/, l = /^\s+|\s+$/g, o = `
`, c = "/", f = "*", h = "", E = "comment", m = "declaration";
  Rn = function(C, O) {
    if (typeof C != "string")
      throw new TypeError("First argument must be a string");
    if (!C) return [];
    O = O || {};
    var I = 1, k = 1;
    function R(z) {
      var F = z.match(t);
      F && (I += F.length);
      var W = z.lastIndexOf(o);
      k = ~W ? z.length - W : k + z.length;
    }
    function Y() {
      var z = { line: I, column: k };
      return function(F) {
        return F.position = new q(z), te(), F;
      };
    }
    function q(z) {
      this.start = z, this.end = { line: I, column: k }, this.source = O.source;
    }
    q.prototype.content = C;
    function N(z) {
      var F = new Error(
        O.source + ":" + I + ":" + k + ": " + z
      );
      if (F.reason = z, F.filename = O.source, F.line = I, F.column = k, F.source = C, !O.silent) throw F;
    }
    function V(z) {
      var F = z.exec(C);
      if (F) {
        var W = F[0];
        return R(W), C = C.slice(W.length), F;
      }
    }
    function te() {
      V(n);
    }
    function j(z) {
      var F;
      for (z = z || []; F = y(); )
        F !== !1 && z.push(F);
      return z;
    }
    function y() {
      var z = Y();
      if (!(c != C.charAt(0) || f != C.charAt(1))) {
        for (var F = 2; h != C.charAt(F) && (f != C.charAt(F) || c != C.charAt(F + 1)); )
          ++F;
        if (F += 2, h === C.charAt(F - 1))
          return N("End of comment missing");
        var W = C.slice(2, F - 2);
        return k += 2, R(W), C = C.slice(F), k += 2, z({
          type: E,
          comment: W
        });
      }
    }
    function U() {
      var z = Y(), F = V(r);
      if (F) {
        if (y(), !V(u)) return N("property missing ':'");
        var W = V(i), de = z({
          type: m,
          property: A(F[0].replace(e, h)),
          value: W ? A(W[0].replace(e, h)) : h
        });
        return V(a), de;
      }
    }
    function H() {
      var z = [];
      j(z);
      for (var F; F = U(); )
        F !== !1 && (z.push(F), j(z));
      return z;
    }
    return te(), H();
  };
  function A(C) {
    return C ? C.replace(l, h) : h;
  }
  return Rn;
}
var Zr;
function Hs() {
  if (Zr) return pt;
  Zr = 1;
  var e = pt && pt.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(pt, "__esModule", { value: !0 });
  var t = e(Us());
  function n(r, u) {
    var i = null;
    if (!r || typeof r != "string")
      return i;
    var a = (0, t.default)(r), l = typeof u == "function";
    return a.forEach(function(o) {
      if (o.type === "declaration") {
        var c = o.property, f = o.value;
        l ? u(c, f, o) : f && (i = i || {}, i[c] = f);
      }
    }), i;
  }
  return pt.default = n, pt;
}
var zs = Hs();
const eu = /* @__PURE__ */ ii(zs), Ys = eu.default || eu, An = Ti("end"), Ye = Ti("start");
function Ti(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function qs(e) {
  const t = Ye(e), n = An(e);
  if (t && n)
    return { start: t, end: n };
}
function Ut(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? tu(e.position) : "start" in e || "end" in e ? tu(e) : "line" in e || "column" in e ? er(e) : "";
}
function er(e) {
  return nu(e && e.line) + ":" + nu(e && e.column);
}
function tu(e) {
  return er(e && e.start) + "-" + er(e && e.end);
}
function nu(e) {
  return e && typeof e == "number" ? e : 1;
}
class be extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let u = "", i = {}, a = !1;
    if (n && ("line" in n && "column" in n ? i = { place: n } : "start" in n && "end" in n ? i = { place: n } : "type" in n ? i = {
      ancestors: [n],
      place: n.position
    } : i = { ...n }), typeof t == "string" ? u = t : !i.cause && t && (a = !0, u = t.message, i.cause = t), !i.ruleId && !i.source && typeof r == "string") {
      const o = r.indexOf(":");
      o === -1 ? i.ruleId = r : (i.source = r.slice(0, o), i.ruleId = r.slice(o + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const o = i.ancestors[i.ancestors.length - 1];
      o && (i.place = o.position);
    }
    const l = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = u, this.line = l ? l.line : void 0, this.name = Ut(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = a && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
be.prototype.file = "";
be.prototype.name = "";
be.prototype.reason = "";
be.prototype.message = "";
be.prototype.stack = "";
be.prototype.column = void 0;
be.prototype.line = void 0;
be.prototype.ancestors = void 0;
be.prototype.cause = void 0;
be.prototype.fatal = void 0;
be.prototype.place = void 0;
be.prototype.ruleId = void 0;
be.prototype.source = void 0;
const br = {}.hasOwnProperty, Vs = /* @__PURE__ */ new Map(), Ws = /[A-Z]/g, js = /-([a-z])/g, Qs = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), $s = /* @__PURE__ */ new Set(["td", "th"]), bi = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function Xs(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = rl(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = nl(n, t.jsx, t.jsxs);
  }
  const u = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? Gt : Ei,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, i = Ai(u, e, void 0);
  return i && typeof i != "string" ? i : u.create(
    e,
    u.Fragment,
    { children: i || void 0 },
    void 0
  );
}
function Ai(e, t, n) {
  if (t.type === "element")
    return Gs(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return Ks(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return Zs(e, t, n);
  if (t.type === "mdxjsEsm")
    return Js(e, t);
  if (t.type === "root")
    return el(e, t, n);
  if (t.type === "text")
    return tl(e, t);
}
function Gs(e, t, n) {
  const r = e.schema;
  let u = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (u = Gt, e.schema = u), e.ancestors.push(t);
  const i = Ci(e, t.tagName, !1), a = ul(e, t);
  let l = _r(e, t);
  return Qs.has(t.tagName) && (l = l.filter(function(o) {
    return typeof o == "string" ? !Os(o) : !0;
  })), _i(e, a, i, t), Ar(a, l), e.ancestors.pop(), e.schema = r, e.create(t, i, a, n);
}
function Ks(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  jt(e, t.position);
}
function Js(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  jt(e, t.position);
}
function Zs(e, t, n) {
  const r = e.schema;
  let u = r;
  t.name === "svg" && r.space === "html" && (u = Gt, e.schema = u), e.ancestors.push(t);
  const i = t.name === null ? e.Fragment : Ci(e, t.name, !0), a = il(e, t), l = _r(e, t);
  return _i(e, a, i, t), Ar(a, l), e.ancestors.pop(), e.schema = r, e.create(t, i, a, n);
}
function el(e, t, n) {
  const r = {};
  return Ar(r, _r(e, t)), e.create(t, e.Fragment, r, n);
}
function tl(e, t) {
  return t.value;
}
function _i(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function Ar(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function nl(e, t, n) {
  return r;
  function r(u, i, a, l) {
    const c = Array.isArray(a.children) ? n : t;
    return l ? c(i, a, l) : c(i, a);
  }
}
function rl(e, t) {
  return n;
  function n(r, u, i, a) {
    const l = Array.isArray(i.children), o = Ye(r);
    return t(
      u,
      i,
      a,
      l,
      {
        columnNumber: o ? o.column - 1 : void 0,
        fileName: e,
        lineNumber: o ? o.line : void 0
      },
      void 0
    );
  }
}
function ul(e, t) {
  const n = {};
  let r, u;
  for (u in t.properties)
    if (u !== "children" && br.call(t.properties, u)) {
      const i = al(e, u, t.properties[u]);
      if (i) {
        const [a, l] = i;
        e.tableCellAlignToStyle && a === "align" && typeof l == "string" && $s.has(t.tagName) ? r = l : n[a] = l;
      }
    }
  if (r) {
    const i = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    i[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function il(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const i = r.data.estree.body[0];
        i.type;
        const a = i.expression;
        a.type;
        const l = a.properties[0];
        l.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        jt(e, t.position);
    else {
      const u = r.name;
      let i;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const l = r.value.data.estree.body[0];
          l.type, i = e.evaluater.evaluateExpression(l.expression);
        } else
          jt(e, t.position);
      else
        i = r.value === null ? !0 : r.value;
      n[u] = /** @type {Props[keyof Props]} */
      i;
    }
  return n;
}
function _r(e, t) {
  const n = [];
  let r = -1;
  const u = e.passKeys ? /* @__PURE__ */ new Map() : Vs;
  for (; ++r < t.children.length; ) {
    const i = t.children[r];
    let a;
    if (e.passKeys) {
      const o = i.type === "element" ? i.tagName : i.type === "mdxJsxFlowElement" || i.type === "mdxJsxTextElement" ? i.name : void 0;
      if (o) {
        const c = u.get(o) || 0;
        a = o + "-" + c, u.set(o, c + 1);
      }
    }
    const l = Ai(e, i, a);
    l !== void 0 && n.push(l);
  }
  return n;
}
function al(e, t, n) {
  const r = pi(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? ai(n) : gi(n)), r.property === "style") {
      let u = typeof n == "object" ? n : sl(e, String(n));
      return e.stylePropertyNameCase === "css" && (u = ll(u)), ["style", u];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? vs[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function sl(e, t) {
  const n = {};
  try {
    Ys(t, r);
  } catch (u) {
    if (!e.ignoreInvalidStyle) {
      const i = (
        /** @type {Error} */
        u
      ), a = new be("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: i,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw a.file = e.filePath || void 0, a.url = bi + "#cannot-parse-style-attribute", a;
    }
  }
  return n;
  function r(u, i) {
    let a = u;
    a.slice(0, 2) !== "--" && (a.slice(0, 4) === "-ms-" && (a = "ms-" + a.slice(4)), a = a.replace(js, cl)), n[a] = i;
  }
}
function Ci(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const u = t.split(".");
    let i = -1, a;
    for (; ++i < u.length; ) {
      const l = Qr(u[i]) ? { type: "Identifier", name: u[i] } : { type: "Literal", value: u[i] };
      a = a ? {
        type: "MemberExpression",
        object: a,
        property: l,
        computed: !!(i && l.type === "Literal"),
        optional: !1
      } : l;
    }
    r = a;
  } else
    r = Qr(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const u = (
      /** @type {keyof JSX.IntrinsicElements} */
      r.value
    );
    return br.call(e.components, u) ? e.components[u] : u;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  jt(e);
}
function jt(e, t) {
  const n = new be(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = bi + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function ll(e) {
  const t = {};
  let n;
  for (n in e)
    br.call(e, n) && (t[ol(n)] = e[n]);
  return t;
}
function ol(e) {
  let t = e.replace(Ws, hl);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function cl(e, t) {
  return t.toUpperCase();
}
function hl(e) {
  return "-" + e.toLowerCase();
}
const Pn = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, fl = {};
function Cr(e, t) {
  const n = fl, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, u = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return ki(e, r, u);
}
function ki(e, t, n) {
  if (dl(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return ru(e.children, t, n);
  }
  return Array.isArray(e) ? ru(e, t, n) : "";
}
function ru(e, t, n) {
  const r = [];
  let u = -1;
  for (; ++u < e.length; )
    r[u] = ki(e[u], t, n);
  return r.join("");
}
function dl(e) {
  return !!(e && typeof e == "object");
}
const uu = document.createElement("i");
function kr(e) {
  const t = "&" + e + ";";
  uu.innerHTML = t;
  const n = uu.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Re(e, t, n, r) {
  const u = e.length;
  let i = 0, a;
  if (t < 0 ? t = -t > u ? 0 : u + t : t = t > u ? u : t, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(t, n), e.splice(...a);
  else
    for (n && e.splice(t, n); i < r.length; )
      a = r.slice(i, i + 1e4), a.unshift(t, 0), e.splice(...a), i += 1e4, t += 1e4;
}
function Le(e, t) {
  return e.length > 0 ? (Re(e, e.length, 0, t), e) : t;
}
const iu = {}.hasOwnProperty;
function Si(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    ml(t, e[n]);
  return t;
}
function ml(e, t) {
  let n;
  for (n in t) {
    const u = (iu.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let a;
    if (i)
      for (a in i) {
        iu.call(u, a) || (u[a] = []);
        const l = i[a];
        pl(
          // @ts-expect-error Looks like a list.
          u[a],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function pl(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Re(e, 0, 0, r);
}
function yi(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function ve(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const _e = tt(/[A-Za-z]/), Te = tt(/[\dA-Za-z]/), El = tt(/[#-'*+\--9=?A-Z^-~]/);
function dn(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const tr = tt(/\d/), gl = tt(/[\dA-Fa-f]/), Tl = tt(/[!-/:-@[-`{-~]/);
function v(e) {
  return e !== null && e < -2;
}
function re(e) {
  return e !== null && (e < 0 || e === 32);
}
function Z(e) {
  return e === -2 || e === -1 || e === 32;
}
const _n = tt(new RegExp("\\p{P}|\\p{S}", "u")), st = tt(/\s/);
function tt(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function yt(e) {
  const t = [];
  let n = -1, r = 0, u = 0;
  for (; ++n < e.length; ) {
    const i = e.charCodeAt(n);
    let a = "";
    if (i === 37 && Te(e.charCodeAt(n + 1)) && Te(e.charCodeAt(n + 2)))
      u = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (a = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const l = e.charCodeAt(n + 1);
      i < 56320 && l > 56319 && l < 57344 ? (a = String.fromCharCode(i, l), u = 1) : a = "�";
    } else
      a = String.fromCharCode(i);
    a && (t.push(e.slice(r, n), encodeURIComponent(a)), r = n + u + 1, a = ""), u && (n += u, u = 0);
  }
  return t.join("") + e.slice(r);
}
function J(e, t, n, r) {
  const u = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return a;
  function a(o) {
    return Z(o) ? (e.enter(n), l(o)) : t(o);
  }
  function l(o) {
    return Z(o) && i++ < u ? (e.consume(o), l) : (e.exit(n), t(o));
  }
}
const bl = {
  tokenize: Al
};
function Al(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    u
  );
  let n;
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), J(e, t, "linePrefix");
  }
  function u(l) {
    return e.enter("paragraph"), i(l);
  }
  function i(l) {
    const o = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = o), n = o, a(l);
  }
  function a(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return v(l) ? (e.consume(l), e.exit("chunkText"), i) : (e.consume(l), a);
  }
}
const _l = {
  tokenize: Cl
}, au = {
  tokenize: kl
};
function Cl(e) {
  const t = this, n = [];
  let r = 0, u, i, a;
  return l;
  function l(R) {
    if (r < n.length) {
      const Y = n[r];
      return t.containerState = Y[1], e.attempt(
        Y[0].continuation,
        o,
        c
      )(R);
    }
    return c(R);
  }
  function o(R) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, u && k();
      const Y = t.events.length;
      let q = Y, N;
      for (; q--; )
        if (t.events[q][0] === "exit" && t.events[q][1].type === "chunkFlow") {
          N = t.events[q][1].end;
          break;
        }
      I(r);
      let V = Y;
      for (; V < t.events.length; )
        t.events[V][1].end = Object.assign({}, N), V++;
      return Re(
        t.events,
        q + 1,
        0,
        t.events.slice(Y)
      ), t.events.length = V, c(R);
    }
    return l(R);
  }
  function c(R) {
    if (r === n.length) {
      if (!u)
        return E(R);
      if (u.currentConstruct && u.currentConstruct.concrete)
        return A(R);
      t.interrupt = !!(u.currentConstruct && !u._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      au,
      f,
      h
    )(R);
  }
  function f(R) {
    return u && k(), I(r), E(R);
  }
  function h(R) {
    return t.parser.lazy[t.now().line] = r !== n.length, a = t.now().offset, A(R);
  }
  function E(R) {
    return t.containerState = {}, e.attempt(
      au,
      m,
      A
    )(R);
  }
  function m(R) {
    return r++, n.push([t.currentConstruct, t.containerState]), E(R);
  }
  function A(R) {
    if (R === null) {
      u && k(), I(0), e.consume(R);
      return;
    }
    return u = u || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: i,
      _tokenizer: u
    }), C(R);
  }
  function C(R) {
    if (R === null) {
      O(e.exit("chunkFlow"), !0), I(0), e.consume(R);
      return;
    }
    return v(R) ? (e.consume(R), O(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, l) : (e.consume(R), C);
  }
  function O(R, Y) {
    const q = t.sliceStream(R);
    if (Y && q.push(null), R.previous = i, i && (i.next = R), i = R, u.defineSkip(R.start), u.write(q), t.parser.lazy[R.start.line]) {
      let N = u.events.length;
      for (; N--; )
        if (
          // The token starts before the line ending…
          u.events[N][1].start.offset < a && // …and either is not ended yet…
          (!u.events[N][1].end || // …or ends after it.
          u.events[N][1].end.offset > a)
        )
          return;
      const V = t.events.length;
      let te = V, j, y;
      for (; te--; )
        if (t.events[te][0] === "exit" && t.events[te][1].type === "chunkFlow") {
          if (j) {
            y = t.events[te][1].end;
            break;
          }
          j = !0;
        }
      for (I(r), N = V; N < t.events.length; )
        t.events[N][1].end = Object.assign({}, y), N++;
      Re(
        t.events,
        te + 1,
        0,
        t.events.slice(V)
      ), t.events.length = N;
    }
  }
  function I(R) {
    let Y = n.length;
    for (; Y-- > R; ) {
      const q = n[Y];
      t.containerState = q[1], q[0].exit.call(t, e);
    }
    n.length = R;
  }
  function k() {
    u.write([null]), i = void 0, u = void 0, t.containerState._closeFlow = void 0;
  }
}
function kl(e, t, n) {
  return J(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function mn(e) {
  if (e === null || re(e) || st(e))
    return 1;
  if (_n(e))
    return 2;
}
function Cn(e, t, n) {
  const r = [];
  let u = -1;
  for (; ++u < e.length; ) {
    const i = e[u].resolveAll;
    i && !r.includes(i) && (t = i(t, n), r.push(i));
  }
  return t;
}
const nr = {
  name: "attention",
  tokenize: yl,
  resolveAll: Sl
};
function Sl(e, t) {
  let n = -1, r, u, i, a, l, o, c, f;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          o = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const h = Object.assign({}, e[r][1].end), E = Object.assign({}, e[n][1].start);
          su(h, -o), su(E, o), a = {
            type: o > 1 ? "strongSequence" : "emphasisSequence",
            start: h,
            end: Object.assign({}, e[r][1].end)
          }, l = {
            type: o > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: E
          }, i = {
            type: o > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, u = {
            type: o > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, l.end)
          }, e[r][1].end = Object.assign({}, a.start), e[n][1].start = Object.assign({}, l.end), c = [], e[r][1].end.offset - e[r][1].start.offset && (c = Le(c, [["enter", e[r][1], t], ["exit", e[r][1], t]])), c = Le(c, [["enter", u, t], ["enter", a, t], ["exit", a, t], ["enter", i, t]]), c = Le(c, Cn(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), c = Le(c, [["exit", i, t], ["enter", l, t], ["exit", l, t], ["exit", u, t]]), e[n][1].end.offset - e[n][1].start.offset ? (f = 2, c = Le(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : f = 0, Re(e, r - 1, n - r + 3, c), n = r + c.length - f - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function yl(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, u = mn(r);
  let i;
  return a;
  function a(o) {
    return i = o, e.enter("attentionSequence"), l(o);
  }
  function l(o) {
    if (o === i)
      return e.consume(o), l;
    const c = e.exit("attentionSequence"), f = mn(o), h = !f || f === 2 && u || n.includes(o), E = !u || u === 2 && f || n.includes(r);
    return c._open = !!(i === 42 ? h : h && (u || !E)), c._close = !!(i === 42 ? E : E && (f || !h)), t(o);
  }
}
function su(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Il = {
  name: "autolink",
  tokenize: xl
};
function xl(e, t, n) {
  let r = 0;
  return u;
  function u(m) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(m) {
    return _e(m) ? (e.consume(m), a) : m === 64 ? n(m) : c(m);
  }
  function a(m) {
    return m === 43 || m === 45 || m === 46 || Te(m) ? (r = 1, l(m)) : c(m);
  }
  function l(m) {
    return m === 58 ? (e.consume(m), r = 0, o) : (m === 43 || m === 45 || m === 46 || Te(m)) && r++ < 32 ? (e.consume(m), l) : (r = 0, c(m));
  }
  function o(m) {
    return m === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : m === null || m === 32 || m === 60 || dn(m) ? n(m) : (e.consume(m), o);
  }
  function c(m) {
    return m === 64 ? (e.consume(m), f) : El(m) ? (e.consume(m), c) : n(m);
  }
  function f(m) {
    return Te(m) ? h(m) : n(m);
  }
  function h(m) {
    return m === 46 ? (e.consume(m), r = 0, f) : m === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : E(m);
  }
  function E(m) {
    if ((m === 45 || Te(m)) && r++ < 63) {
      const A = m === 45 ? E : h;
      return e.consume(m), A;
    }
    return n(m);
  }
}
const Kt = {
  tokenize: Nl,
  partial: !0
};
function Nl(e, t, n) {
  return r;
  function r(i) {
    return Z(i) ? J(e, u, "linePrefix")(i) : u(i);
  }
  function u(i) {
    return i === null || v(i) ? t(i) : n(i);
  }
}
const Ii = {
  name: "blockQuote",
  tokenize: Ol,
  continuation: {
    tokenize: Ll
  },
  exit: Dl
};
function Ol(e, t, n) {
  const r = this;
  return u;
  function u(a) {
    if (a === 62) {
      const l = r.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(a), e.exit("blockQuoteMarker"), i;
    }
    return n(a);
  }
  function i(a) {
    return Z(a) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(a), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(a));
  }
}
function Ll(e, t, n) {
  const r = this;
  return u;
  function u(a) {
    return Z(a) ? J(e, i, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a) : i(a);
  }
  function i(a) {
    return e.attempt(Ii, t, n)(a);
  }
}
function Dl(e) {
  e.exit("blockQuote");
}
const xi = {
  name: "characterEscape",
  tokenize: Rl
};
function Rl(e, t, n) {
  return r;
  function r(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), u;
  }
  function u(i) {
    return Tl(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const Ni = {
  name: "characterReference",
  tokenize: Pl
};
function Pl(e, t, n) {
  const r = this;
  let u = 0, i, a;
  return l;
  function l(h) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), o;
  }
  function o(h) {
    return h === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(h), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), i = 31, a = Te, f(h));
  }
  function c(h) {
    return h === 88 || h === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(h), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, a = gl, f) : (e.enter("characterReferenceValue"), i = 7, a = tr, f(h));
  }
  function f(h) {
    if (h === 59 && u) {
      const E = e.exit("characterReferenceValue");
      return a === Te && !kr(r.sliceSerialize(E)) ? n(h) : (e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return a(h) && u++ < i ? (e.consume(h), f) : n(h);
  }
}
const lu = {
  tokenize: Ml,
  partial: !0
}, ou = {
  name: "codeFenced",
  tokenize: wl,
  concrete: !0
};
function wl(e, t, n) {
  const r = this, u = {
    tokenize: q,
    partial: !0
  };
  let i = 0, a = 0, l;
  return o;
  function o(N) {
    return c(N);
  }
  function c(N) {
    const V = r.events[r.events.length - 1];
    return i = V && V[1].type === "linePrefix" ? V[2].sliceSerialize(V[1], !0).length : 0, l = N, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), f(N);
  }
  function f(N) {
    return N === l ? (a++, e.consume(N), f) : a < 3 ? n(N) : (e.exit("codeFencedFenceSequence"), Z(N) ? J(e, h, "whitespace")(N) : h(N));
  }
  function h(N) {
    return N === null || v(N) ? (e.exit("codeFencedFence"), r.interrupt ? t(N) : e.check(lu, C, Y)(N)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), E(N));
  }
  function E(N) {
    return N === null || v(N) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), h(N)) : Z(N) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), J(e, m, "whitespace")(N)) : N === 96 && N === l ? n(N) : (e.consume(N), E);
  }
  function m(N) {
    return N === null || v(N) ? h(N) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), A(N));
  }
  function A(N) {
    return N === null || v(N) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), h(N)) : N === 96 && N === l ? n(N) : (e.consume(N), A);
  }
  function C(N) {
    return e.attempt(u, Y, O)(N);
  }
  function O(N) {
    return e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), I;
  }
  function I(N) {
    return i > 0 && Z(N) ? J(e, k, "linePrefix", i + 1)(N) : k(N);
  }
  function k(N) {
    return N === null || v(N) ? e.check(lu, C, Y)(N) : (e.enter("codeFlowValue"), R(N));
  }
  function R(N) {
    return N === null || v(N) ? (e.exit("codeFlowValue"), k(N)) : (e.consume(N), R);
  }
  function Y(N) {
    return e.exit("codeFenced"), t(N);
  }
  function q(N, V, te) {
    let j = 0;
    return y;
    function y(W) {
      return N.enter("lineEnding"), N.consume(W), N.exit("lineEnding"), U;
    }
    function U(W) {
      return N.enter("codeFencedFence"), Z(W) ? J(N, H, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : H(W);
    }
    function H(W) {
      return W === l ? (N.enter("codeFencedFenceSequence"), z(W)) : te(W);
    }
    function z(W) {
      return W === l ? (j++, N.consume(W), z) : j >= a ? (N.exit("codeFencedFenceSequence"), Z(W) ? J(N, F, "whitespace")(W) : F(W)) : te(W);
    }
    function F(W) {
      return W === null || v(W) ? (N.exit("codeFencedFence"), V(W)) : te(W);
    }
  }
}
function Ml(e, t, n) {
  const r = this;
  return u;
  function u(a) {
    return a === null ? n(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i);
  }
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
const wn = {
  name: "codeIndented",
  tokenize: Fl
}, Bl = {
  tokenize: vl,
  partial: !0
};
function Fl(e, t, n) {
  const r = this;
  return u;
  function u(c) {
    return e.enter("codeIndented"), J(e, i, "linePrefix", 5)(c);
  }
  function i(c) {
    const f = r.events[r.events.length - 1];
    return f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? a(c) : n(c);
  }
  function a(c) {
    return c === null ? o(c) : v(c) ? e.attempt(Bl, a, o)(c) : (e.enter("codeFlowValue"), l(c));
  }
  function l(c) {
    return c === null || v(c) ? (e.exit("codeFlowValue"), a(c)) : (e.consume(c), l);
  }
  function o(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function vl(e, t, n) {
  const r = this;
  return u;
  function u(a) {
    return r.parser.lazy[r.now().line] ? n(a) : v(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), u) : J(e, i, "linePrefix", 5)(a);
  }
  function i(a) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(a) : v(a) ? u(a) : n(a);
  }
}
const Ul = {
  name: "codeText",
  tokenize: Yl,
  resolve: Hl,
  previous: zl
};
function Hl(e) {
  let t = e.length - 4, n = 3, r, u;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    u === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (u = r) : (r === t || e[r][1].type === "lineEnding") && (e[u][1].type = "codeTextData", r !== u + 2 && (e[u][1].end = e[r - 1][1].end, e.splice(u + 2, r - u - 2), t -= r - u - 2, r = u + 2), u = void 0);
  return e;
}
function zl(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Yl(e, t, n) {
  let r = 0, u, i;
  return a;
  function a(h) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(h);
  }
  function l(h) {
    return h === 96 ? (e.consume(h), r++, l) : (e.exit("codeTextSequence"), o(h));
  }
  function o(h) {
    return h === null ? n(h) : h === 32 ? (e.enter("space"), e.consume(h), e.exit("space"), o) : h === 96 ? (i = e.enter("codeTextSequence"), u = 0, f(h)) : v(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), o) : (e.enter("codeTextData"), c(h));
  }
  function c(h) {
    return h === null || h === 32 || h === 96 || v(h) ? (e.exit("codeTextData"), o(h)) : (e.consume(h), c);
  }
  function f(h) {
    return h === 96 ? (e.consume(h), u++, f) : u === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(h)) : (i.type = "codeTextData", c(h));
  }
}
class ql {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const u = n || 0;
    this.setCursor(Math.trunc(t));
    const i = this.right.splice(this.right.length - u, Number.POSITIVE_INFINITY);
    return r && wt(this.left, r), i.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), wt(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), wt(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        wt(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        wt(this.left, n.reverse());
      }
  }
}
function wt(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Oi(e) {
  const t = {};
  let n = -1, r, u, i, a, l, o, c;
  const f = new ql(e);
  for (; ++n < f.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = f.get(n), n && r[1].type === "chunkFlow" && f.get(n - 1)[1].type === "listItemPrefix" && (o = r[1]._tokenizer.events, i = 0, i < o.length && o[i][1].type === "lineEndingBlank" && (i += 2), i < o.length && o[i][1].type === "content"))
      for (; ++i < o.length && o[i][1].type !== "content"; )
        o[i][1].type === "chunkText" && (o[i][1]._isInFirstContentOfListItem = !0, i++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, Vl(f, n)), n = t[n], c = !0);
    else if (r[1]._container) {
      for (i = n, u = void 0; i-- && (a = f.get(i), a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (u && (f.get(u)[1].type = "lineEndingBlank"), a[1].type = "lineEnding", u = i);
      u && (r[1].end = Object.assign({}, f.get(u)[1].start), l = f.slice(u, n), l.unshift(r), f.splice(u, n - u + 1, l));
    }
  }
  return Re(e, 0, Number.POSITIVE_INFINITY, f.slice(0)), !c;
}
function Vl(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let u = t - 1;
  const i = [], a = n._tokenizer || r.parser[n.contentType](n.start), l = a.events, o = [], c = {};
  let f, h, E = -1, m = n, A = 0, C = 0;
  const O = [C];
  for (; m; ) {
    for (; e.get(++u)[1] !== m; )
      ;
    i.push(u), m._tokenizer || (f = r.sliceStream(m), m.next || f.push(null), h && a.defineSkip(m.start), m._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(f), m._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), h = m, m = m.next;
  }
  for (m = n; ++E < l.length; )
    // Find a void token that includes a break.
    l[E][0] === "exit" && l[E - 1][0] === "enter" && l[E][1].type === l[E - 1][1].type && l[E][1].start.line !== l[E][1].end.line && (C = E + 1, O.push(C), m._tokenizer = void 0, m.previous = void 0, m = m.next);
  for (a.events = [], m ? (m._tokenizer = void 0, m.previous = void 0) : O.pop(), E = O.length; E--; ) {
    const I = l.slice(O[E], O[E + 1]), k = i.pop();
    o.push([k, k + I.length - 1]), e.splice(k, 2, I);
  }
  for (o.reverse(), E = -1; ++E < o.length; )
    c[A + o[E][0]] = A + o[E][1], A += o[E][1] - o[E][0] - 1;
  return c;
}
const Wl = {
  tokenize: $l,
  resolve: Ql
}, jl = {
  tokenize: Xl,
  partial: !0
};
function Ql(e) {
  return Oi(e), e;
}
function $l(e, t) {
  let n;
  return r;
  function r(l) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), u(l);
  }
  function u(l) {
    return l === null ? i(l) : v(l) ? e.check(jl, a, i)(l) : (e.consume(l), u);
  }
  function i(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function a(l) {
    return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, u;
  }
}
function Xl(e, t, n) {
  const r = this;
  return u;
  function u(a) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), J(e, i, "linePrefix");
  }
  function i(a) {
    if (a === null || v(a))
      return n(a);
    const l = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(a) : e.interrupt(r.parser.constructs.flow, n, t)(a);
  }
}
function Li(e, t, n, r, u, i, a, l, o) {
  const c = o || Number.POSITIVE_INFINITY;
  let f = 0;
  return h;
  function h(I) {
    return I === 60 ? (e.enter(r), e.enter(u), e.enter(i), e.consume(I), e.exit(i), E) : I === null || I === 32 || I === 41 || dn(I) ? n(I) : (e.enter(r), e.enter(a), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), C(I));
  }
  function E(I) {
    return I === 62 ? (e.enter(i), e.consume(I), e.exit(i), e.exit(u), e.exit(r), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), m(I));
  }
  function m(I) {
    return I === 62 ? (e.exit("chunkString"), e.exit(l), E(I)) : I === null || I === 60 || v(I) ? n(I) : (e.consume(I), I === 92 ? A : m);
  }
  function A(I) {
    return I === 60 || I === 62 || I === 92 ? (e.consume(I), m) : m(I);
  }
  function C(I) {
    return !f && (I === null || I === 41 || re(I)) ? (e.exit("chunkString"), e.exit(l), e.exit(a), e.exit(r), t(I)) : f < c && I === 40 ? (e.consume(I), f++, C) : I === 41 ? (e.consume(I), f--, C) : I === null || I === 32 || I === 40 || dn(I) ? n(I) : (e.consume(I), I === 92 ? O : C);
  }
  function O(I) {
    return I === 40 || I === 41 || I === 92 ? (e.consume(I), C) : C(I);
  }
}
function Di(e, t, n, r, u, i) {
  const a = this;
  let l = 0, o;
  return c;
  function c(m) {
    return e.enter(r), e.enter(u), e.consume(m), e.exit(u), e.enter(i), f;
  }
  function f(m) {
    return l > 999 || m === null || m === 91 || m === 93 && !o || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    m === 94 && !l && "_hiddenFootnoteSupport" in a.parser.constructs ? n(m) : m === 93 ? (e.exit(i), e.enter(u), e.consume(m), e.exit(u), e.exit(r), t) : v(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), f) : (e.enter("chunkString", {
      contentType: "string"
    }), h(m));
  }
  function h(m) {
    return m === null || m === 91 || m === 93 || v(m) || l++ > 999 ? (e.exit("chunkString"), f(m)) : (e.consume(m), o || (o = !Z(m)), m === 92 ? E : h);
  }
  function E(m) {
    return m === 91 || m === 92 || m === 93 ? (e.consume(m), l++, h) : h(m);
  }
}
function Ri(e, t, n, r, u, i) {
  let a;
  return l;
  function l(E) {
    return E === 34 || E === 39 || E === 40 ? (e.enter(r), e.enter(u), e.consume(E), e.exit(u), a = E === 40 ? 41 : E, o) : n(E);
  }
  function o(E) {
    return E === a ? (e.enter(u), e.consume(E), e.exit(u), e.exit(r), t) : (e.enter(i), c(E));
  }
  function c(E) {
    return E === a ? (e.exit(i), o(a)) : E === null ? n(E) : v(E) ? (e.enter("lineEnding"), e.consume(E), e.exit("lineEnding"), J(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), f(E));
  }
  function f(E) {
    return E === a || E === null || v(E) ? (e.exit("chunkString"), c(E)) : (e.consume(E), E === 92 ? h : f);
  }
  function h(E) {
    return E === a || E === 92 ? (e.consume(E), f) : f(E);
  }
}
function Ht(e, t) {
  let n;
  return r;
  function r(u) {
    return v(u) ? (e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), n = !0, r) : Z(u) ? J(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(u) : t(u);
  }
}
const Gl = {
  name: "definition",
  tokenize: Jl
}, Kl = {
  tokenize: Zl,
  partial: !0
};
function Jl(e, t, n) {
  const r = this;
  let u;
  return i;
  function i(m) {
    return e.enter("definition"), a(m);
  }
  function a(m) {
    return Di.call(
      r,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(m);
  }
  function l(m) {
    return u = ve(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), m === 58 ? (e.enter("definitionMarker"), e.consume(m), e.exit("definitionMarker"), o) : n(m);
  }
  function o(m) {
    return re(m) ? Ht(e, c)(m) : c(m);
  }
  function c(m) {
    return Li(
      e,
      f,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(m);
  }
  function f(m) {
    return e.attempt(Kl, h, h)(m);
  }
  function h(m) {
    return Z(m) ? J(e, E, "whitespace")(m) : E(m);
  }
  function E(m) {
    return m === null || v(m) ? (e.exit("definition"), r.parser.defined.push(u), t(m)) : n(m);
  }
}
function Zl(e, t, n) {
  return r;
  function r(l) {
    return re(l) ? Ht(e, u)(l) : n(l);
  }
  function u(l) {
    return Ri(e, i, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function i(l) {
    return Z(l) ? J(e, a, "whitespace")(l) : a(l);
  }
  function a(l) {
    return l === null || v(l) ? t(l) : n(l);
  }
}
const eo = {
  name: "hardBreakEscape",
  tokenize: to
};
function to(e, t, n) {
  return r;
  function r(i) {
    return e.enter("hardBreakEscape"), e.consume(i), u;
  }
  function u(i) {
    return v(i) ? (e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const no = {
  name: "headingAtx",
  tokenize: uo,
  resolve: ro
};
function ro(e, t) {
  let n = e.length - 2, r = 3, u, i;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (u = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, i = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Re(e, r, n - r + 1, [["enter", u, t], ["enter", i, t], ["exit", i, t], ["exit", u, t]])), e;
}
function uo(e, t, n) {
  let r = 0;
  return u;
  function u(f) {
    return e.enter("atxHeading"), i(f);
  }
  function i(f) {
    return e.enter("atxHeadingSequence"), a(f);
  }
  function a(f) {
    return f === 35 && r++ < 6 ? (e.consume(f), a) : f === null || re(f) ? (e.exit("atxHeadingSequence"), l(f)) : n(f);
  }
  function l(f) {
    return f === 35 ? (e.enter("atxHeadingSequence"), o(f)) : f === null || v(f) ? (e.exit("atxHeading"), t(f)) : Z(f) ? J(e, l, "whitespace")(f) : (e.enter("atxHeadingText"), c(f));
  }
  function o(f) {
    return f === 35 ? (e.consume(f), o) : (e.exit("atxHeadingSequence"), l(f));
  }
  function c(f) {
    return f === null || f === 35 || re(f) ? (e.exit("atxHeadingText"), l(f)) : (e.consume(f), c);
  }
}
const io = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], cu = ["pre", "script", "style", "textarea"], ao = {
  name: "htmlFlow",
  tokenize: co,
  resolveTo: oo,
  concrete: !0
}, so = {
  tokenize: fo,
  partial: !0
}, lo = {
  tokenize: ho,
  partial: !0
};
function oo(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function co(e, t, n) {
  const r = this;
  let u, i, a, l, o;
  return c;
  function c(b) {
    return f(b);
  }
  function f(b) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(b), h;
  }
  function h(b) {
    return b === 33 ? (e.consume(b), E) : b === 47 ? (e.consume(b), i = !0, C) : b === 63 ? (e.consume(b), u = 3, r.interrupt ? t : T) : _e(b) ? (e.consume(b), a = String.fromCharCode(b), O) : n(b);
  }
  function E(b) {
    return b === 45 ? (e.consume(b), u = 2, m) : b === 91 ? (e.consume(b), u = 5, l = 0, A) : _e(b) ? (e.consume(b), u = 4, r.interrupt ? t : T) : n(b);
  }
  function m(b) {
    return b === 45 ? (e.consume(b), r.interrupt ? t : T) : n(b);
  }
  function A(b) {
    const Be = "CDATA[";
    return b === Be.charCodeAt(l++) ? (e.consume(b), l === Be.length ? r.interrupt ? t : H : A) : n(b);
  }
  function C(b) {
    return _e(b) ? (e.consume(b), a = String.fromCharCode(b), O) : n(b);
  }
  function O(b) {
    if (b === null || b === 47 || b === 62 || re(b)) {
      const Be = b === 47, nt = a.toLowerCase();
      return !Be && !i && cu.includes(nt) ? (u = 1, r.interrupt ? t(b) : H(b)) : io.includes(a.toLowerCase()) ? (u = 6, Be ? (e.consume(b), I) : r.interrupt ? t(b) : H(b)) : (u = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(b) : i ? k(b) : R(b));
    }
    return b === 45 || Te(b) ? (e.consume(b), a += String.fromCharCode(b), O) : n(b);
  }
  function I(b) {
    return b === 62 ? (e.consume(b), r.interrupt ? t : H) : n(b);
  }
  function k(b) {
    return Z(b) ? (e.consume(b), k) : y(b);
  }
  function R(b) {
    return b === 47 ? (e.consume(b), y) : b === 58 || b === 95 || _e(b) ? (e.consume(b), Y) : Z(b) ? (e.consume(b), R) : y(b);
  }
  function Y(b) {
    return b === 45 || b === 46 || b === 58 || b === 95 || Te(b) ? (e.consume(b), Y) : q(b);
  }
  function q(b) {
    return b === 61 ? (e.consume(b), N) : Z(b) ? (e.consume(b), q) : R(b);
  }
  function N(b) {
    return b === null || b === 60 || b === 61 || b === 62 || b === 96 ? n(b) : b === 34 || b === 39 ? (e.consume(b), o = b, V) : Z(b) ? (e.consume(b), N) : te(b);
  }
  function V(b) {
    return b === o ? (e.consume(b), o = null, j) : b === null || v(b) ? n(b) : (e.consume(b), V);
  }
  function te(b) {
    return b === null || b === 34 || b === 39 || b === 47 || b === 60 || b === 61 || b === 62 || b === 96 || re(b) ? q(b) : (e.consume(b), te);
  }
  function j(b) {
    return b === 47 || b === 62 || Z(b) ? R(b) : n(b);
  }
  function y(b) {
    return b === 62 ? (e.consume(b), U) : n(b);
  }
  function U(b) {
    return b === null || v(b) ? H(b) : Z(b) ? (e.consume(b), U) : n(b);
  }
  function H(b) {
    return b === 45 && u === 2 ? (e.consume(b), de) : b === 60 && u === 1 ? (e.consume(b), Ee) : b === 62 && u === 4 ? (e.consume(b), Me) : b === 63 && u === 3 ? (e.consume(b), T) : b === 93 && u === 5 ? (e.consume(b), Ve) : v(b) && (u === 6 || u === 7) ? (e.exit("htmlFlowData"), e.check(so, We, z)(b)) : b === null || v(b) ? (e.exit("htmlFlowData"), z(b)) : (e.consume(b), H);
  }
  function z(b) {
    return e.check(lo, F, We)(b);
  }
  function F(b) {
    return e.enter("lineEnding"), e.consume(b), e.exit("lineEnding"), W;
  }
  function W(b) {
    return b === null || v(b) ? z(b) : (e.enter("htmlFlowData"), H(b));
  }
  function de(b) {
    return b === 45 ? (e.consume(b), T) : H(b);
  }
  function Ee(b) {
    return b === 47 ? (e.consume(b), a = "", we) : H(b);
  }
  function we(b) {
    if (b === 62) {
      const Be = a.toLowerCase();
      return cu.includes(Be) ? (e.consume(b), Me) : H(b);
    }
    return _e(b) && a.length < 8 ? (e.consume(b), a += String.fromCharCode(b), we) : H(b);
  }
  function Ve(b) {
    return b === 93 ? (e.consume(b), T) : H(b);
  }
  function T(b) {
    return b === 62 ? (e.consume(b), Me) : b === 45 && u === 2 ? (e.consume(b), T) : H(b);
  }
  function Me(b) {
    return b === null || v(b) ? (e.exit("htmlFlowData"), We(b)) : (e.consume(b), Me);
  }
  function We(b) {
    return e.exit("htmlFlow"), t(b);
  }
}
function ho(e, t, n) {
  const r = this;
  return u;
  function u(a) {
    return v(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i) : n(a);
  }
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
function fo(e, t, n) {
  return r;
  function r(u) {
    return e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), e.attempt(Kt, t, n);
  }
}
const mo = {
  name: "htmlText",
  tokenize: po
};
function po(e, t, n) {
  const r = this;
  let u, i, a;
  return l;
  function l(T) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(T), o;
  }
  function o(T) {
    return T === 33 ? (e.consume(T), c) : T === 47 ? (e.consume(T), q) : T === 63 ? (e.consume(T), R) : _e(T) ? (e.consume(T), te) : n(T);
  }
  function c(T) {
    return T === 45 ? (e.consume(T), f) : T === 91 ? (e.consume(T), i = 0, A) : _e(T) ? (e.consume(T), k) : n(T);
  }
  function f(T) {
    return T === 45 ? (e.consume(T), m) : n(T);
  }
  function h(T) {
    return T === null ? n(T) : T === 45 ? (e.consume(T), E) : v(T) ? (a = h, Ee(T)) : (e.consume(T), h);
  }
  function E(T) {
    return T === 45 ? (e.consume(T), m) : h(T);
  }
  function m(T) {
    return T === 62 ? de(T) : T === 45 ? E(T) : h(T);
  }
  function A(T) {
    const Me = "CDATA[";
    return T === Me.charCodeAt(i++) ? (e.consume(T), i === Me.length ? C : A) : n(T);
  }
  function C(T) {
    return T === null ? n(T) : T === 93 ? (e.consume(T), O) : v(T) ? (a = C, Ee(T)) : (e.consume(T), C);
  }
  function O(T) {
    return T === 93 ? (e.consume(T), I) : C(T);
  }
  function I(T) {
    return T === 62 ? de(T) : T === 93 ? (e.consume(T), I) : C(T);
  }
  function k(T) {
    return T === null || T === 62 ? de(T) : v(T) ? (a = k, Ee(T)) : (e.consume(T), k);
  }
  function R(T) {
    return T === null ? n(T) : T === 63 ? (e.consume(T), Y) : v(T) ? (a = R, Ee(T)) : (e.consume(T), R);
  }
  function Y(T) {
    return T === 62 ? de(T) : R(T);
  }
  function q(T) {
    return _e(T) ? (e.consume(T), N) : n(T);
  }
  function N(T) {
    return T === 45 || Te(T) ? (e.consume(T), N) : V(T);
  }
  function V(T) {
    return v(T) ? (a = V, Ee(T)) : Z(T) ? (e.consume(T), V) : de(T);
  }
  function te(T) {
    return T === 45 || Te(T) ? (e.consume(T), te) : T === 47 || T === 62 || re(T) ? j(T) : n(T);
  }
  function j(T) {
    return T === 47 ? (e.consume(T), de) : T === 58 || T === 95 || _e(T) ? (e.consume(T), y) : v(T) ? (a = j, Ee(T)) : Z(T) ? (e.consume(T), j) : de(T);
  }
  function y(T) {
    return T === 45 || T === 46 || T === 58 || T === 95 || Te(T) ? (e.consume(T), y) : U(T);
  }
  function U(T) {
    return T === 61 ? (e.consume(T), H) : v(T) ? (a = U, Ee(T)) : Z(T) ? (e.consume(T), U) : j(T);
  }
  function H(T) {
    return T === null || T === 60 || T === 61 || T === 62 || T === 96 ? n(T) : T === 34 || T === 39 ? (e.consume(T), u = T, z) : v(T) ? (a = H, Ee(T)) : Z(T) ? (e.consume(T), H) : (e.consume(T), F);
  }
  function z(T) {
    return T === u ? (e.consume(T), u = void 0, W) : T === null ? n(T) : v(T) ? (a = z, Ee(T)) : (e.consume(T), z);
  }
  function F(T) {
    return T === null || T === 34 || T === 39 || T === 60 || T === 61 || T === 96 ? n(T) : T === 47 || T === 62 || re(T) ? j(T) : (e.consume(T), F);
  }
  function W(T) {
    return T === 47 || T === 62 || re(T) ? j(T) : n(T);
  }
  function de(T) {
    return T === 62 ? (e.consume(T), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(T);
  }
  function Ee(T) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), we;
  }
  function we(T) {
    return Z(T) ? J(e, Ve, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(T) : Ve(T);
  }
  function Ve(T) {
    return e.enter("htmlTextData"), a(T);
  }
}
const Sr = {
  name: "labelEnd",
  tokenize: _o,
  resolveTo: Ao,
  resolveAll: bo
}, Eo = {
  tokenize: Co
}, go = {
  tokenize: ko
}, To = {
  tokenize: So
};
function bo(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function Ao(e, t) {
  let n = e.length, r = 0, u, i, a, l;
  for (; n--; )
    if (u = e[n][1], i) {
      if (u.type === "link" || u.type === "labelLink" && u._inactive)
        break;
      e[n][0] === "enter" && u.type === "labelLink" && (u._inactive = !0);
    } else if (a) {
      if (e[n][0] === "enter" && (u.type === "labelImage" || u.type === "labelLink") && !u._balanced && (i = n, u.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else u.type === "labelEnd" && (a = n);
  const o = {
    type: e[i][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, c = {
    type: "label",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[a][1].end)
  }, f = {
    type: "labelText",
    start: Object.assign({}, e[i + r + 2][1].end),
    end: Object.assign({}, e[a - 2][1].start)
  };
  return l = [["enter", o, t], ["enter", c, t]], l = Le(l, e.slice(i + 1, i + r + 3)), l = Le(l, [["enter", f, t]]), l = Le(l, Cn(t.parser.constructs.insideSpan.null, e.slice(i + r + 4, a - 3), t)), l = Le(l, [["exit", f, t], e[a - 2], e[a - 1], ["exit", c, t]]), l = Le(l, e.slice(a + 1)), l = Le(l, [["exit", o, t]]), Re(e, i, e.length, l), e;
}
function _o(e, t, n) {
  const r = this;
  let u = r.events.length, i, a;
  for (; u--; )
    if ((r.events[u][1].type === "labelImage" || r.events[u][1].type === "labelLink") && !r.events[u][1]._balanced) {
      i = r.events[u][1];
      break;
    }
  return l;
  function l(E) {
    return i ? i._inactive ? h(E) : (a = r.parser.defined.includes(ve(r.sliceSerialize({
      start: i.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(E), e.exit("labelMarker"), e.exit("labelEnd"), o) : n(E);
  }
  function o(E) {
    return E === 40 ? e.attempt(Eo, f, a ? f : h)(E) : E === 91 ? e.attempt(go, f, a ? c : h)(E) : a ? f(E) : h(E);
  }
  function c(E) {
    return e.attempt(To, f, h)(E);
  }
  function f(E) {
    return t(E);
  }
  function h(E) {
    return i._balanced = !0, n(E);
  }
}
function Co(e, t, n) {
  return r;
  function r(h) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), u;
  }
  function u(h) {
    return re(h) ? Ht(e, i)(h) : i(h);
  }
  function i(h) {
    return h === 41 ? f(h) : Li(e, a, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(h);
  }
  function a(h) {
    return re(h) ? Ht(e, o)(h) : f(h);
  }
  function l(h) {
    return n(h);
  }
  function o(h) {
    return h === 34 || h === 39 || h === 40 ? Ri(e, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(h) : f(h);
  }
  function c(h) {
    return re(h) ? Ht(e, f)(h) : f(h);
  }
  function f(h) {
    return h === 41 ? (e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), e.exit("resource"), t) : n(h);
  }
}
function ko(e, t, n) {
  const r = this;
  return u;
  function u(l) {
    return Di.call(r, e, i, a, "reference", "referenceMarker", "referenceString")(l);
  }
  function i(l) {
    return r.parser.defined.includes(ve(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(l) : n(l);
  }
  function a(l) {
    return n(l);
  }
}
function So(e, t, n) {
  return r;
  function r(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), u;
  }
  function u(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const yo = {
  name: "labelStartImage",
  tokenize: Io,
  resolveAll: Sr.resolveAll
};
function Io(e, t, n) {
  const r = this;
  return u;
  function u(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), i;
  }
  function i(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), a) : n(l);
  }
  function a(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(l) : t(l);
  }
}
const xo = {
  name: "labelStartLink",
  tokenize: No,
  resolveAll: Sr.resolveAll
};
function No(e, t, n) {
  const r = this;
  return u;
  function u(a) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const Mn = {
  name: "lineEnding",
  tokenize: Oo
};
function Oo(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), J(e, t, "linePrefix");
  }
}
const cn = {
  name: "thematicBreak",
  tokenize: Lo
};
function Lo(e, t, n) {
  let r = 0, u;
  return i;
  function i(c) {
    return e.enter("thematicBreak"), a(c);
  }
  function a(c) {
    return u = c, l(c);
  }
  function l(c) {
    return c === u ? (e.enter("thematicBreakSequence"), o(c)) : r >= 3 && (c === null || v(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function o(c) {
    return c === u ? (e.consume(c), r++, o) : (e.exit("thematicBreakSequence"), Z(c) ? J(e, l, "whitespace")(c) : l(c));
  }
}
const ke = {
  name: "list",
  tokenize: Po,
  continuation: {
    tokenize: wo
  },
  exit: Bo
}, Do = {
  tokenize: Fo,
  partial: !0
}, Ro = {
  tokenize: Mo,
  partial: !0
};
function Po(e, t, n) {
  const r = this, u = r.events[r.events.length - 1];
  let i = u && u[1].type === "linePrefix" ? u[2].sliceSerialize(u[1], !0).length : 0, a = 0;
  return l;
  function l(m) {
    const A = r.containerState.type || (m === 42 || m === 43 || m === 45 ? "listUnordered" : "listOrdered");
    if (A === "listUnordered" ? !r.containerState.marker || m === r.containerState.marker : tr(m)) {
      if (r.containerState.type || (r.containerState.type = A, e.enter(A, {
        _container: !0
      })), A === "listUnordered")
        return e.enter("listItemPrefix"), m === 42 || m === 45 ? e.check(cn, n, c)(m) : c(m);
      if (!r.interrupt || m === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), o(m);
    }
    return n(m);
  }
  function o(m) {
    return tr(m) && ++a < 10 ? (e.consume(m), o) : (!r.interrupt || a < 2) && (r.containerState.marker ? m === r.containerState.marker : m === 41 || m === 46) ? (e.exit("listItemValue"), c(m)) : n(m);
  }
  function c(m) {
    return e.enter("listItemMarker"), e.consume(m), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || m, e.check(
      Kt,
      // Can’t be empty when interrupting.
      r.interrupt ? n : f,
      e.attempt(Do, E, h)
    );
  }
  function f(m) {
    return r.containerState.initialBlankLine = !0, i++, E(m);
  }
  function h(m) {
    return Z(m) ? (e.enter("listItemPrefixWhitespace"), e.consume(m), e.exit("listItemPrefixWhitespace"), E) : n(m);
  }
  function E(m) {
    return r.containerState.size = i + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(m);
  }
}
function wo(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Kt, u, i);
  function u(l) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, J(e, t, "listItemIndent", r.containerState.size + 1)(l);
  }
  function i(l) {
    return r.containerState.furtherBlankLines || !Z(l) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(l)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(Ro, t, a)(l));
  }
  function a(l) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, J(e, e.attempt(ke, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function Mo(e, t, n) {
  const r = this;
  return J(e, u, "listItemIndent", r.containerState.size + 1);
  function u(i) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? t(i) : n(i);
  }
}
function Bo(e) {
  e.exit(this.containerState.type);
}
function Fo(e, t, n) {
  const r = this;
  return J(e, u, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function u(i) {
    const a = r.events[r.events.length - 1];
    return !Z(i) && a && a[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const hu = {
  name: "setextUnderline",
  tokenize: Uo,
  resolveTo: vo
};
function vo(e, t) {
  let n = e.length, r, u, i;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (u = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
  const a = {
    type: "setextHeading",
    start: Object.assign({}, e[u][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[u][1].type = "setextHeadingText", i ? (e.splice(u, 0, ["enter", a, t]), e.splice(i + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[i][1].end)) : e[r][1] = a, e.push(["exit", a, t]), e;
}
function Uo(e, t, n) {
  const r = this;
  let u;
  return i;
  function i(c) {
    let f = r.events.length, h;
    for (; f--; )
      if (r.events[f][1].type !== "lineEnding" && r.events[f][1].type !== "linePrefix" && r.events[f][1].type !== "content") {
        h = r.events[f][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || h) ? (e.enter("setextHeadingLine"), u = c, a(c)) : n(c);
  }
  function a(c) {
    return e.enter("setextHeadingLineSequence"), l(c);
  }
  function l(c) {
    return c === u ? (e.consume(c), l) : (e.exit("setextHeadingLineSequence"), Z(c) ? J(e, o, "lineSuffix")(c) : o(c));
  }
  function o(c) {
    return c === null || v(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const Ho = {
  tokenize: zo
};
function zo(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Kt,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      u,
      J(
        e,
        e.attempt(
          this.parser.constructs.flow,
          u,
          e.attempt(Wl, u)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function u(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const Yo = {
  resolveAll: wi()
}, qo = Pi("string"), Vo = Pi("text");
function Pi(e) {
  return {
    tokenize: t,
    resolveAll: wi(
      e === "text" ? Wo : void 0
    )
  };
  function t(n) {
    const r = this, u = this.parser.constructs[e], i = n.attempt(u, a, l);
    return a;
    function a(f) {
      return c(f) ? i(f) : l(f);
    }
    function l(f) {
      if (f === null) {
        n.consume(f);
        return;
      }
      return n.enter("data"), n.consume(f), o;
    }
    function o(f) {
      return c(f) ? (n.exit("data"), i(f)) : (n.consume(f), o);
    }
    function c(f) {
      if (f === null)
        return !0;
      const h = u[f];
      let E = -1;
      if (h)
        for (; ++E < h.length; ) {
          const m = h[E];
          if (!m.previous || m.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function wi(e) {
  return t;
  function t(n, r) {
    let u = -1, i;
    for (; ++u <= n.length; )
      i === void 0 ? n[u] && n[u][1].type === "data" && (i = u, u++) : (!n[u] || n[u][1].type !== "data") && (u !== i + 2 && (n[i][1].end = n[u - 1][1].end, n.splice(i + 2, u - i - 2), u = i + 2), i = void 0);
    return e ? e(n, r) : n;
  }
}
function Wo(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], u = t.sliceStream(r);
      let i = u.length, a = -1, l = 0, o;
      for (; i--; ) {
        const c = u[i];
        if (typeof c == "string") {
          for (a = c.length; c.charCodeAt(a - 1) === 32; )
            l++, a--;
          if (a) break;
          a = -1;
        } else if (c === -2)
          o = !0, l++;
        else if (c !== -1) {
          i++;
          break;
        }
      }
      if (l) {
        const c = {
          type: n === e.length || o || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - l,
            offset: r.end.offset - l,
            _index: r.start._index + i,
            _bufferIndex: i ? a : r.start._bufferIndex + a
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, c.start), r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(
          n,
          0,
          ["enter", c, t],
          ["exit", c, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function jo(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const u = {}, i = [];
  let a = [], l = [];
  const o = {
    consume: k,
    enter: R,
    exit: Y,
    attempt: V(q),
    check: V(N),
    interrupt: V(N, {
      interrupt: !0
    })
  }, c = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: m,
    sliceSerialize: E,
    now: A,
    defineSkip: C,
    write: h
  };
  let f = t.tokenize.call(c, o);
  return t.resolveAll && i.push(t), c;
  function h(U) {
    return a = Le(a, U), O(), a[a.length - 1] !== null ? [] : (te(t, 0), c.events = Cn(i, c.events, c), c.events);
  }
  function E(U, H) {
    return $o(m(U), H);
  }
  function m(U) {
    return Qo(a, U);
  }
  function A() {
    const { line: U, column: H, offset: z, _index: F, _bufferIndex: W } = r;
    return {
      line: U,
      column: H,
      offset: z,
      _index: F,
      _bufferIndex: W
    };
  }
  function C(U) {
    u[U.line] = U.column, y();
  }
  function O() {
    let U;
    for (; r._index < a.length; ) {
      const H = a[r._index];
      if (typeof H == "string")
        for (U = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === U && r._bufferIndex < H.length; )
          I(H.charCodeAt(r._bufferIndex));
      else
        I(H);
    }
  }
  function I(U) {
    f = f(U);
  }
  function k(U) {
    v(U) ? (r.line++, r.column = 1, r.offset += U === -3 ? 2 : 1, y()) : U !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === a[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = U;
  }
  function R(U, H) {
    const z = H || {};
    return z.type = U, z.start = A(), c.events.push(["enter", z, c]), l.push(z), z;
  }
  function Y(U) {
    const H = l.pop();
    return H.end = A(), c.events.push(["exit", H, c]), H;
  }
  function q(U, H) {
    te(U, H.from);
  }
  function N(U, H) {
    H.restore();
  }
  function V(U, H) {
    return z;
    function z(F, W, de) {
      let Ee, we, Ve, T;
      return Array.isArray(F) ? We(F) : "tokenize" in F ? (
        // @ts-expect-error Looks like a construct.
        We([F])
      ) : Me(F);
      function Me(ge) {
        return Dt;
        function Dt(Ge) {
          const ft = Ge !== null && ge[Ge], dt = Ge !== null && ge.null, rn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ft) ? ft : ft ? [ft] : [],
            ...Array.isArray(dt) ? dt : dt ? [dt] : []
          ];
          return We(rn)(Ge);
        }
      }
      function We(ge) {
        return Ee = ge, we = 0, ge.length === 0 ? de : b(ge[we]);
      }
      function b(ge) {
        return Dt;
        function Dt(Ge) {
          return T = j(), Ve = ge, ge.partial || (c.currentConstruct = ge), ge.name && c.parser.constructs.disable.null.includes(ge.name) ? nt() : ge.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            H ? Object.assign(Object.create(c), H) : c,
            o,
            Be,
            nt
          )(Ge);
        }
      }
      function Be(ge) {
        return U(Ve, T), W;
      }
      function nt(ge) {
        return T.restore(), ++we < Ee.length ? b(Ee[we]) : de;
      }
    }
  }
  function te(U, H) {
    U.resolveAll && !i.includes(U) && i.push(U), U.resolve && Re(
      c.events,
      H,
      c.events.length - H,
      U.resolve(c.events.slice(H), c)
    ), U.resolveTo && (c.events = U.resolveTo(c.events, c));
  }
  function j() {
    const U = A(), H = c.previous, z = c.currentConstruct, F = c.events.length, W = Array.from(l);
    return {
      restore: de,
      from: F
    };
    function de() {
      r = U, c.previous = H, c.currentConstruct = z, c.events.length = F, l = W, y();
    }
  }
  function y() {
    r.line in u && r.column < 2 && (r.column = u[r.line], r.offset += u[r.line] - 1);
  }
}
function Qo(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, u = t.end._index, i = t.end._bufferIndex;
  let a;
  if (n === u)
    a = [e[n].slice(r, i)];
  else {
    if (a = e.slice(n, u), r > -1) {
      const l = a[0];
      typeof l == "string" ? a[0] = l.slice(r) : a.shift();
    }
    i > 0 && a.push(e[u].slice(0, i));
  }
  return a;
}
function $o(e, t) {
  let n = -1;
  const r = [];
  let u;
  for (; ++n < e.length; ) {
    const i = e[n];
    let a;
    if (typeof i == "string")
      a = i;
    else
      switch (i) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && u) continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(i);
      }
    u = i === -2, r.push(a);
  }
  return r.join("");
}
const Xo = {
  42: ke,
  43: ke,
  45: ke,
  48: ke,
  49: ke,
  50: ke,
  51: ke,
  52: ke,
  53: ke,
  54: ke,
  55: ke,
  56: ke,
  57: ke,
  62: Ii
}, Go = {
  91: Gl
}, Ko = {
  [-2]: wn,
  [-1]: wn,
  32: wn
}, Jo = {
  35: no,
  42: cn,
  45: [hu, cn],
  60: ao,
  61: hu,
  95: cn,
  96: ou,
  126: ou
}, Zo = {
  38: Ni,
  92: xi
}, ec = {
  [-5]: Mn,
  [-4]: Mn,
  [-3]: Mn,
  33: yo,
  38: Ni,
  42: nr,
  60: [Il, mo],
  91: xo,
  92: [eo, xi],
  93: Sr,
  95: nr,
  96: Ul
}, tc = {
  null: [nr, Yo]
}, nc = {
  null: [42, 95]
}, rc = {
  null: []
}, uc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: nc,
  contentInitial: Go,
  disable: rc,
  document: Xo,
  flow: Jo,
  flowInitial: Ko,
  insideSpan: tc,
  string: Zo,
  text: ec
}, Symbol.toStringTag, { value: "Module" }));
function ic(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    Si([uc, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: u(bl),
    document: u(_l),
    flow: u(Ho),
    string: u(qo),
    text: u(Vo)
  };
  return r;
  function u(i) {
    return a;
    function a(l) {
      return jo(r, i, l);
    }
  }
}
function ac(e) {
  for (; !Oi(e); )
    ;
  return e;
}
const fu = /[\0\t\n\r]/g;
function sc() {
  let e = 1, t = "", n = !0, r;
  return u;
  function u(i, a, l) {
    const o = [];
    let c, f, h, E, m;
    for (i = t + (typeof i == "string" ? i.toString() : new TextDecoder(a || void 0).decode(i)), h = 0, t = "", n && (i.charCodeAt(0) === 65279 && h++, n = void 0); h < i.length; ) {
      if (fu.lastIndex = h, c = fu.exec(i), E = c && c.index !== void 0 ? c.index : i.length, m = i.charCodeAt(E), !c) {
        t = i.slice(h);
        break;
      }
      if (m === 10 && h === E && r)
        o.push(-3), r = void 0;
      else
        switch (r && (o.push(-5), r = void 0), h < E && (o.push(i.slice(h, E)), e += E - h), m) {
          case 0: {
            o.push(65533), e++;
            break;
          }
          case 9: {
            for (f = Math.ceil(e / 4) * 4, o.push(-2); e++ < f; ) o.push(-1);
            break;
          }
          case 10: {
            o.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      h = E + 1;
    }
    return l && (r && o.push(-5), t && o.push(t), o.push(null)), o;
  }
}
const lc = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function oc(e) {
  return e.replace(lc, cc);
}
function cc(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const u = n.charCodeAt(1), i = u === 120 || u === 88;
    return yi(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return kr(n) || e;
}
const Mi = {}.hasOwnProperty;
function hc(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), fc(n)(ac(ic(n).document().write(sc()(e, t, !0))));
}
function fc(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: i(Vr),
      autolinkProtocol: j,
      autolinkEmail: j,
      atxHeading: i(zr),
      blockQuote: i(dt),
      characterEscape: j,
      characterReference: j,
      codeFenced: i(rn),
      codeFencedFenceInfo: a,
      codeFencedFenceMeta: a,
      codeIndented: i(rn, a),
      codeText: i(fs, a),
      codeTextData: j,
      data: j,
      codeFlowValue: j,
      definition: i(ds),
      definitionDestinationString: a,
      definitionLabelString: a,
      definitionTitleString: a,
      emphasis: i(ms),
      hardBreakEscape: i(Yr),
      hardBreakTrailing: i(Yr),
      htmlFlow: i(qr, a),
      htmlFlowData: j,
      htmlText: i(qr, a),
      htmlTextData: j,
      image: i(ps),
      label: a,
      link: i(Vr),
      listItem: i(Es),
      listItemValue: E,
      listOrdered: i(Wr, h),
      listUnordered: i(Wr),
      paragraph: i(gs),
      reference: b,
      referenceString: a,
      resourceDestinationString: a,
      resourceTitleString: a,
      setextHeading: i(zr),
      strong: i(Ts),
      thematicBreak: i(As)
    },
    exit: {
      atxHeading: o(),
      atxHeadingSequence: q,
      autolink: o(),
      autolinkEmail: ft,
      autolinkProtocol: Ge,
      blockQuote: o(),
      characterEscapeValue: y,
      characterReferenceMarkerHexadecimal: nt,
      characterReferenceMarkerNumeric: nt,
      characterReferenceValue: ge,
      characterReference: Dt,
      codeFenced: o(O),
      codeFencedFence: C,
      codeFencedFenceInfo: m,
      codeFencedFenceMeta: A,
      codeFlowValue: y,
      codeIndented: o(I),
      codeText: o(W),
      codeTextData: y,
      data: y,
      definition: o(),
      definitionDestinationString: Y,
      definitionLabelString: k,
      definitionTitleString: R,
      emphasis: o(),
      hardBreakEscape: o(H),
      hardBreakTrailing: o(H),
      htmlFlow: o(z),
      htmlFlowData: y,
      htmlText: o(F),
      htmlTextData: y,
      image: o(Ee),
      label: Ve,
      labelText: we,
      lineEnding: U,
      link: o(de),
      listItem: o(),
      listOrdered: o(),
      listUnordered: o(),
      paragraph: o(),
      referenceString: Be,
      resourceDestinationString: T,
      resourceTitleString: Me,
      resource: We,
      setextHeading: o(te),
      setextHeadingLineSequence: V,
      setextHeadingText: N,
      strong: o(),
      thematicBreak: o()
    }
  };
  Bi(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(x) {
    let B = {
      type: "root",
      children: []
    };
    const Q = {
      stack: [B],
      tokenStack: [],
      config: t,
      enter: l,
      exit: c,
      buffer: a,
      resume: f,
      data: n
    }, ee = [];
    let ne = -1;
    for (; ++ne < x.length; )
      if (x[ne][1].type === "listOrdered" || x[ne][1].type === "listUnordered")
        if (x[ne][0] === "enter")
          ee.push(ne);
        else {
          const Fe = ee.pop();
          ne = u(x, Fe, ne);
        }
    for (ne = -1; ++ne < x.length; ) {
      const Fe = t[x[ne][0]];
      Mi.call(Fe, x[ne][1].type) && Fe[x[ne][1].type].call(Object.assign({
        sliceSerialize: x[ne][2].sliceSerialize
      }, Q), x[ne][1]);
    }
    if (Q.tokenStack.length > 0) {
      const Fe = Q.tokenStack[Q.tokenStack.length - 1];
      (Fe[1] || du).call(Q, void 0, Fe[0]);
    }
    for (B.position = {
      start: Ke(x.length > 0 ? x[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Ke(x.length > 0 ? x[x.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, ne = -1; ++ne < t.transforms.length; )
      B = t.transforms[ne](B) || B;
    return B;
  }
  function u(x, B, Q) {
    let ee = B - 1, ne = -1, Fe = !1, rt, je, Rt, Pt;
    for (; ++ee <= Q; ) {
      const Ie = x[ee];
      switch (Ie[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Ie[0] === "enter" ? ne++ : ne--, Pt = void 0;
          break;
        }
        case "lineEndingBlank": {
          Ie[0] === "enter" && (rt && !Pt && !ne && !Rt && (Rt = ee), Pt = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Pt = void 0;
      }
      if (!ne && Ie[0] === "enter" && Ie[1].type === "listItemPrefix" || ne === -1 && Ie[0] === "exit" && (Ie[1].type === "listUnordered" || Ie[1].type === "listOrdered")) {
        if (rt) {
          let mt = ee;
          for (je = void 0; mt--; ) {
            const Qe = x[mt];
            if (Qe[1].type === "lineEnding" || Qe[1].type === "lineEndingBlank") {
              if (Qe[0] === "exit") continue;
              je && (x[je][1].type = "lineEndingBlank", Fe = !0), Qe[1].type = "lineEnding", je = mt;
            } else if (!(Qe[1].type === "linePrefix" || Qe[1].type === "blockQuotePrefix" || Qe[1].type === "blockQuotePrefixWhitespace" || Qe[1].type === "blockQuoteMarker" || Qe[1].type === "listItemIndent")) break;
          }
          Rt && (!je || Rt < je) && (rt._spread = !0), rt.end = Object.assign({}, je ? x[je][1].start : Ie[1].end), x.splice(je || ee, 0, ["exit", rt, Ie[2]]), ee++, Q++;
        }
        if (Ie[1].type === "listItemPrefix") {
          const mt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Ie[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          rt = mt, x.splice(ee, 0, ["enter", mt, Ie[2]]), ee++, Q++, Rt = void 0, Pt = !0;
        }
      }
    }
    return x[B][1]._spread = Fe, Q;
  }
  function i(x, B) {
    return Q;
    function Q(ee) {
      l.call(this, x(ee), ee), B && B.call(this, ee);
    }
  }
  function a() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(x, B, Q) {
    this.stack[this.stack.length - 1].children.push(x), this.stack.push(x), this.tokenStack.push([B, Q]), x.position = {
      start: Ke(B.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function o(x) {
    return B;
    function B(Q) {
      x && x.call(this, Q), c.call(this, Q);
    }
  }
  function c(x, B) {
    const Q = this.stack.pop(), ee = this.tokenStack.pop();
    if (ee)
      ee[0].type !== x.type && (B ? B.call(this, x, ee[0]) : (ee[1] || du).call(this, x, ee[0]));
    else throw new Error("Cannot close `" + x.type + "` (" + Ut({
      start: x.start,
      end: x.end
    }) + "): it’s not open");
    Q.position.end = Ke(x.end);
  }
  function f() {
    return Cr(this.stack.pop());
  }
  function h() {
    this.data.expectingFirstListItemValue = !0;
  }
  function E(x) {
    if (this.data.expectingFirstListItemValue) {
      const B = this.stack[this.stack.length - 2];
      B.start = Number.parseInt(this.sliceSerialize(x), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function m() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.lang = x;
  }
  function A() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.meta = x;
  }
  function C() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function O() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = x.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function I() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = x.replace(/(\r?\n|\r)$/g, "");
  }
  function k(x) {
    const B = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.label = B, Q.identifier = ve(this.sliceSerialize(x)).toLowerCase();
  }
  function R() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = x;
  }
  function Y() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = x;
  }
  function q(x) {
    const B = this.stack[this.stack.length - 1];
    if (!B.depth) {
      const Q = this.sliceSerialize(x).length;
      B.depth = Q;
    }
  }
  function N() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function V(x) {
    const B = this.stack[this.stack.length - 1];
    B.depth = this.sliceSerialize(x).codePointAt(0) === 61 ? 1 : 2;
  }
  function te() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function j(x) {
    const Q = this.stack[this.stack.length - 1].children;
    let ee = Q[Q.length - 1];
    (!ee || ee.type !== "text") && (ee = bs(), ee.position = {
      start: Ke(x.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Q.push(ee)), this.stack.push(ee);
  }
  function y(x) {
    const B = this.stack.pop();
    B.value += this.sliceSerialize(x), B.position.end = Ke(x.end);
  }
  function U(x) {
    const B = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Q = B.children[B.children.length - 1];
      Q.position.end = Ke(x.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(B.type) && (j.call(this, x), y.call(this, x));
  }
  function H() {
    this.data.atHardBreak = !0;
  }
  function z() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = x;
  }
  function F() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = x;
  }
  function W() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = x;
  }
  function de() {
    const x = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      x.type += "Reference", x.referenceType = B, delete x.url, delete x.title;
    } else
      delete x.identifier, delete x.label;
    this.data.referenceType = void 0;
  }
  function Ee() {
    const x = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      x.type += "Reference", x.referenceType = B, delete x.url, delete x.title;
    } else
      delete x.identifier, delete x.label;
    this.data.referenceType = void 0;
  }
  function we(x) {
    const B = this.sliceSerialize(x), Q = this.stack[this.stack.length - 2];
    Q.label = oc(B), Q.identifier = ve(B).toLowerCase();
  }
  function Ve() {
    const x = this.stack[this.stack.length - 1], B = this.resume(), Q = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Q.type === "link") {
      const ee = x.children;
      Q.children = ee;
    } else
      Q.alt = B;
  }
  function T() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = x;
  }
  function Me() {
    const x = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = x;
  }
  function We() {
    this.data.inReference = void 0;
  }
  function b() {
    this.data.referenceType = "collapsed";
  }
  function Be(x) {
    const B = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.label = B, Q.identifier = ve(this.sliceSerialize(x)).toLowerCase(), this.data.referenceType = "full";
  }
  function nt(x) {
    this.data.characterReferenceType = x.type;
  }
  function ge(x) {
    const B = this.sliceSerialize(x), Q = this.data.characterReferenceType;
    let ee;
    Q ? (ee = yi(B, Q === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ee = kr(B);
    const ne = this.stack[this.stack.length - 1];
    ne.value += ee;
  }
  function Dt(x) {
    const B = this.stack.pop();
    B.position.end = Ke(x.end);
  }
  function Ge(x) {
    y.call(this, x);
    const B = this.stack[this.stack.length - 1];
    B.url = this.sliceSerialize(x);
  }
  function ft(x) {
    y.call(this, x);
    const B = this.stack[this.stack.length - 1];
    B.url = "mailto:" + this.sliceSerialize(x);
  }
  function dt() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function rn() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function fs() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function ds() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function ms() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function zr() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Yr() {
    return {
      type: "break"
    };
  }
  function qr() {
    return {
      type: "html",
      value: ""
    };
  }
  function ps() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Vr() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Wr(x) {
    return {
      type: "list",
      ordered: x.type === "listOrdered",
      start: null,
      spread: x._spread,
      children: []
    };
  }
  function Es(x) {
    return {
      type: "listItem",
      spread: x._spread,
      checked: null,
      children: []
    };
  }
  function gs() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Ts() {
    return {
      type: "strong",
      children: []
    };
  }
  function bs() {
    return {
      type: "text",
      value: ""
    };
  }
  function As() {
    return {
      type: "thematicBreak"
    };
  }
}
function Ke(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Bi(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Bi(e, r) : dc(e, r);
  }
}
function dc(e, t) {
  let n;
  for (n in t)
    if (Mi.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function du(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ut({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Ut({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Ut({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function mc(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return hc(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function pc(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Ec(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function gc(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let u = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (u.data = { meta: t.meta }), e.patch(t, u), u = e.applyData(t, u), u = { type: "element", tagName: "pre", properties: {}, children: [u] }, e.patch(t, u), u;
}
function Tc(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function bc(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Ac(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), u = yt(r.toLowerCase()), i = e.footnoteOrder.indexOf(r);
  let a, l = e.footnoteCounts.get(r);
  l === void 0 ? (l = 0, e.footnoteOrder.push(r), a = e.footnoteOrder.length) : a = i + 1, l += 1, e.footnoteCounts.set(r, l);
  const o = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + u,
      id: n + "fnref-" + u + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(a) }]
  };
  e.patch(t, o);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [o]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function _c(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Cc(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function Fi(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const u = e.all(t), i = u[0];
  i && i.type === "text" ? i.value = "[" + i.value : u.unshift({ type: "text", value: "[" });
  const a = u[u.length - 1];
  return a && a.type === "text" ? a.value += r : u.push({ type: "text", value: r }), u;
}
function kc(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Fi(e, t);
  const u = { src: yt(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (u.title = r.title);
  const i = { type: "element", tagName: "img", properties: u, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function Sc(e, t) {
  const n = { src: yt(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function yc(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Ic(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Fi(e, t);
  const u = { href: yt(r.url || "") };
  r.title !== null && r.title !== void 0 && (u.title = r.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: u,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function xc(e, t) {
  const n = { href: yt(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Nc(e, t, n) {
  const r = e.all(t), u = n ? Oc(n) : vi(t), i = {}, a = [];
  if (typeof t.checked == "boolean") {
    const f = r[0];
    let h;
    f && f.type === "element" && f.tagName === "p" ? h = f : (h = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(h)), h.children.length > 0 && h.children.unshift({ type: "text", value: " " }), h.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < r.length; ) {
    const f = r[l];
    (u || l !== 0 || f.type !== "element" || f.tagName !== "p") && a.push({ type: "text", value: `
` }), f.type === "element" && f.tagName === "p" && !u ? a.push(...f.children) : a.push(f);
  }
  const o = r[r.length - 1];
  o && (u || o.type !== "element" || o.tagName !== "p") && a.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: i, children: a };
  return e.patch(t, c), e.applyData(t, c);
}
function Oc(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = vi(n[r]);
  }
  return t;
}
function vi(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function Lc(e, t) {
  const n = {}, r = e.all(t);
  let u = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++u < r.length; ) {
    const a = r[u];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Dc(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Rc(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Pc(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function wc(e, t) {
  const n = e.all(t), r = n.shift(), u = [];
  if (r) {
    const a = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], a), u.push(a);
  }
  if (n.length > 0) {
    const a = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, l = Ye(t.children[1]), o = An(t.children[t.children.length - 1]);
    l && o && (a.position = { start: l, end: o }), u.push(a);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Mc(e, t, n) {
  const r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, l = a ? a.length : t.children.length;
  let o = -1;
  const c = [];
  for (; ++o < l; ) {
    const h = t.children[o], E = {}, m = a ? a[o] : void 0;
    m && (E.align = m);
    let A = { type: "element", tagName: i, properties: E, children: [] };
    h && (A.children = e.all(h), e.patch(h, A), A = e.applyData(h, A)), c.push(A);
  }
  const f = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, f), e.applyData(t, f);
}
function Bc(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const mu = 9, pu = 32;
function Fc(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), u = 0;
  const i = [];
  for (; r; )
    i.push(
      Eu(t.slice(u, r.index), u > 0, !0),
      r[0]
    ), u = r.index + r[0].length, r = n.exec(t);
  return i.push(Eu(t.slice(u), u > 0, !1)), i.join("");
}
function Eu(e, t, n) {
  let r = 0, u = e.length;
  if (t) {
    let i = e.codePointAt(r);
    for (; i === mu || i === pu; )
      r++, i = e.codePointAt(r);
  }
  if (n) {
    let i = e.codePointAt(u - 1);
    for (; i === mu || i === pu; )
      u--, i = e.codePointAt(u - 1);
  }
  return u > r ? e.slice(r, u) : "";
}
function vc(e, t) {
  const n = { type: "text", value: Fc(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Uc(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Hc = {
  blockquote: pc,
  break: Ec,
  code: gc,
  delete: Tc,
  emphasis: bc,
  footnoteReference: Ac,
  heading: _c,
  html: Cc,
  imageReference: kc,
  image: Sc,
  inlineCode: yc,
  linkReference: Ic,
  link: xc,
  listItem: Nc,
  list: Lc,
  paragraph: Dc,
  // @ts-expect-error: root is different, but hard to type.
  root: Rc,
  strong: Pc,
  table: wc,
  tableCell: Bc,
  tableRow: Mc,
  text: vc,
  thematicBreak: Uc,
  toml: un,
  yaml: un,
  definition: un,
  footnoteDefinition: un
};
function un() {
}
const Ui = -1, kn = 0, pn = 1, En = 2, yr = 3, Ir = 4, xr = 5, Nr = 6, Hi = 7, zi = 8, gu = typeof self == "object" ? self : globalThis, zc = (e, t) => {
  const n = (u, i) => (e.set(i, u), u), r = (u) => {
    if (e.has(u))
      return e.get(u);
    const [i, a] = t[u];
    switch (i) {
      case kn:
      case Ui:
        return n(a, u);
      case pn: {
        const l = n([], u);
        for (const o of a)
          l.push(r(o));
        return l;
      }
      case En: {
        const l = n({}, u);
        for (const [o, c] of a)
          l[r(o)] = r(c);
        return l;
      }
      case yr:
        return n(new Date(a), u);
      case Ir: {
        const { source: l, flags: o } = a;
        return n(new RegExp(l, o), u);
      }
      case xr: {
        const l = n(/* @__PURE__ */ new Map(), u);
        for (const [o, c] of a)
          l.set(r(o), r(c));
        return l;
      }
      case Nr: {
        const l = n(/* @__PURE__ */ new Set(), u);
        for (const o of a)
          l.add(r(o));
        return l;
      }
      case Hi: {
        const { name: l, message: o } = a;
        return n(new gu[l](o), u);
      }
      case zi:
        return n(BigInt(a), u);
      case "BigInt":
        return n(Object(BigInt(a)), u);
    }
    return n(new gu[i](a), u);
  };
  return r;
}, Tu = (e) => zc(/* @__PURE__ */ new Map(), e)(0), Et = "", { toString: Yc } = {}, { keys: qc } = Object, Mt = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [kn, t];
  const n = Yc.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [pn, Et];
    case "Object":
      return [En, Et];
    case "Date":
      return [yr, Et];
    case "RegExp":
      return [Ir, Et];
    case "Map":
      return [xr, Et];
    case "Set":
      return [Nr, Et];
  }
  return n.includes("Array") ? [pn, n] : n.includes("Error") ? [Hi, n] : [En, n];
}, an = ([e, t]) => e === kn && (t === "function" || t === "symbol"), Vc = (e, t, n, r) => {
  const u = (a, l) => {
    const o = r.push(a) - 1;
    return n.set(l, o), o;
  }, i = (a) => {
    if (n.has(a))
      return n.get(a);
    let [l, o] = Mt(a);
    switch (l) {
      case kn: {
        let f = a;
        switch (o) {
          case "bigint":
            l = zi, f = a.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + o);
            f = null;
            break;
          case "undefined":
            return u([Ui], a);
        }
        return u([l, f], a);
      }
      case pn: {
        if (o)
          return u([o, [...a]], a);
        const f = [], h = u([l, f], a);
        for (const E of a)
          f.push(i(E));
        return h;
      }
      case En: {
        if (o)
          switch (o) {
            case "BigInt":
              return u([o, a.toString()], a);
            case "Boolean":
            case "Number":
            case "String":
              return u([o, a.valueOf()], a);
          }
        if (t && "toJSON" in a)
          return i(a.toJSON());
        const f = [], h = u([l, f], a);
        for (const E of qc(a))
          (e || !an(Mt(a[E]))) && f.push([i(E), i(a[E])]);
        return h;
      }
      case yr:
        return u([l, a.toISOString()], a);
      case Ir: {
        const { source: f, flags: h } = a;
        return u([l, { source: f, flags: h }], a);
      }
      case xr: {
        const f = [], h = u([l, f], a);
        for (const [E, m] of a)
          (e || !(an(Mt(E)) || an(Mt(m)))) && f.push([i(E), i(m)]);
        return h;
      }
      case Nr: {
        const f = [], h = u([l, f], a);
        for (const E of a)
          (e || !an(Mt(E))) && f.push(i(E));
        return h;
      }
    }
    const { message: c } = a;
    return u([l, { name: o, message: c }], a);
  };
  return i;
}, bu = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return Vc(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, Ct = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? Tu(bu(e, t)) : structuredClone(e)
) : (e, t) => Tu(bu(e, t));
function Wc(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function jc(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function Qc(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || Wc, r = e.options.footnoteBackLabel || jc, u = e.options.footnoteLabel || "Footnotes", i = e.options.footnoteLabelTagName || "h2", a = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let o = -1;
  for (; ++o < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[o]
    );
    if (!c)
      continue;
    const f = e.all(c), h = String(c.identifier).toUpperCase(), E = yt(h.toLowerCase());
    let m = 0;
    const A = [], C = e.footnoteCounts.get(h);
    for (; C !== void 0 && ++m <= C; ) {
      A.length > 0 && A.push({ type: "text", value: " " });
      let k = typeof n == "string" ? n : n(o, m);
      typeof k == "string" && (k = { type: "text", value: k }), A.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + E + (m > 1 ? "-" + m : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(o, m),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(k) ? k : [k]
      });
    }
    const O = f[f.length - 1];
    if (O && O.type === "element" && O.tagName === "p") {
      const k = O.children[O.children.length - 1];
      k && k.type === "text" ? k.value += " " : O.children.push({ type: "text", value: " " }), O.children.push(...A);
    } else
      f.push(...A);
    const I = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + E },
      children: e.wrap(f, !0)
    };
    e.patch(c, I), l.push(I);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: i,
          properties: {
            ...Ct(a),
            id: "footnote-label"
          },
          children: [{ type: "text", value: u }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Sn = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return Kc;
    if (typeof e == "function")
      return yn(e);
    if (typeof e == "object")
      return Array.isArray(e) ? $c(e) : Xc(e);
    if (typeof e == "string")
      return Gc(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function $c(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Sn(e[n]);
  return yn(r);
  function r(...u) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].apply(this, u)) return !0;
    return !1;
  }
}
function Xc(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return yn(n);
  function n(r) {
    const u = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in e)
      if (u[i] !== t[i]) return !1;
    return !0;
  }
}
function Gc(e) {
  return yn(t);
  function t(n) {
    return n && n.type === e;
  }
}
function yn(e) {
  return t;
  function t(n, r, u) {
    return !!(Jc(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      u || void 0
    ));
  }
}
function Kc() {
  return !0;
}
function Jc(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Yi = [], Zc = !0, rr = !1, e0 = "skip";
function qi(e, t, n, r) {
  let u;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : u = t;
  const i = Sn(u), a = r ? -1 : 1;
  l(e, void 0, [])();
  function l(o, c, f) {
    const h = (
      /** @type {Record<string, unknown>} */
      o && typeof o == "object" ? o : {}
    );
    if (typeof h.type == "string") {
      const m = (
        // `hast`
        typeof h.tagName == "string" ? h.tagName : (
          // `xast`
          typeof h.name == "string" ? h.name : void 0
        )
      );
      Object.defineProperty(E, "name", {
        value: "node (" + (o.type + (m ? "<" + m + ">" : "")) + ")"
      });
    }
    return E;
    function E() {
      let m = Yi, A, C, O;
      if ((!t || i(o, c, f[f.length - 1] || void 0)) && (m = t0(n(o, f)), m[0] === rr))
        return m;
      if ("children" in o && o.children) {
        const I = (
          /** @type {UnistParent} */
          o
        );
        if (I.children && m[0] !== e0)
          for (C = (r ? I.children.length : -1) + a, O = f.concat(I); C > -1 && C < I.children.length; ) {
            const k = I.children[C];
            if (A = l(k, C, O)(), A[0] === rr)
              return A;
            C = typeof A[1] == "number" ? A[1] : C + a;
          }
      }
      return m;
    }
  }
}
function t0(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Zc, e] : e == null ? Yi : [e];
}
function In(e, t, n, r) {
  let u, i, a;
  typeof t == "function" && typeof n != "function" ? (i = void 0, a = t, u = n) : (i = t, a = n, u = r), qi(e, i, l, u);
  function l(o, c) {
    const f = c[c.length - 1], h = f ? f.children.indexOf(o) : void 0;
    return a(o, h, f);
  }
}
const ur = {}.hasOwnProperty, n0 = {};
function r0(e, t) {
  const n = t || n0, r = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = { ...Hc, ...n.handlers }, l = {
    all: c,
    applyData: i0,
    definitionById: r,
    footnoteById: u,
    footnoteCounts: i,
    footnoteOrder: [],
    handlers: a,
    one: o,
    options: n,
    patch: u0,
    wrap: s0
  };
  return In(e, function(f) {
    if (f.type === "definition" || f.type === "footnoteDefinition") {
      const h = f.type === "definition" ? r : u, E = String(f.identifier).toUpperCase();
      h.has(E) || h.set(E, f);
    }
  }), l;
  function o(f, h) {
    const E = f.type, m = l.handlers[E];
    if (ur.call(l.handlers, E) && m)
      return m(l, f, h);
    if (l.options.passThrough && l.options.passThrough.includes(E)) {
      if ("children" in f) {
        const { children: C, ...O } = f, I = Ct(O);
        return I.children = l.all(f), I;
      }
      return Ct(f);
    }
    return (l.options.unknownHandler || a0)(l, f, h);
  }
  function c(f) {
    const h = [];
    if ("children" in f) {
      const E = f.children;
      let m = -1;
      for (; ++m < E.length; ) {
        const A = l.one(E[m], f);
        if (A) {
          if (m && E[m - 1].type === "break" && (!Array.isArray(A) && A.type === "text" && (A.value = Au(A.value)), !Array.isArray(A) && A.type === "element")) {
            const C = A.children[0];
            C && C.type === "text" && (C.value = Au(C.value));
          }
          Array.isArray(A) ? h.push(...A) : h.push(A);
        }
      }
    }
    return h;
  }
}
function u0(e, t) {
  e.position && (t.position = qs(e));
}
function i0(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, u = e.data.hChildren, i = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const a = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: a };
      }
    n.type === "element" && i && Object.assign(n.properties, Ct(i)), "children" in n && n.children && u !== null && u !== void 0 && (n.children = u);
  }
  return n;
}
function a0(e, t) {
  const n = t.data || {}, r = "value" in t && !(ur.call(n, "hProperties") || ur.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function s0(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function Au(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function _u(e, t) {
  const n = r0(e, t), r = n.one(e, void 0), u = Qc(n), i = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return u && i.children.push({ type: "text", value: `
` }, u), i;
}
function l0(e, t) {
  return e && "run" in e ? async function(n, r) {
    const u = (
      /** @type {HastRoot} */
      _u(n, { file: r, ...t })
    );
    await e.run(u, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      _u(n, { file: r, ...t || e })
    );
  };
}
function Cu(e) {
  if (e)
    throw e;
}
var Bn, ku;
function o0() {
  if (ku) return Bn;
  ku = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, u = function(c) {
    return typeof Array.isArray == "function" ? Array.isArray(c) : t.call(c) === "[object Array]";
  }, i = function(c) {
    if (!c || t.call(c) !== "[object Object]")
      return !1;
    var f = e.call(c, "constructor"), h = c.constructor && c.constructor.prototype && e.call(c.constructor.prototype, "isPrototypeOf");
    if (c.constructor && !f && !h)
      return !1;
    var E;
    for (E in c)
      ;
    return typeof E > "u" || e.call(c, E);
  }, a = function(c, f) {
    n && f.name === "__proto__" ? n(c, f.name, {
      enumerable: !0,
      configurable: !0,
      value: f.newValue,
      writable: !0
    }) : c[f.name] = f.newValue;
  }, l = function(c, f) {
    if (f === "__proto__")
      if (e.call(c, f)) {
        if (r)
          return r(c, f).value;
      } else return;
    return c[f];
  };
  return Bn = function o() {
    var c, f, h, E, m, A, C = arguments[0], O = 1, I = arguments.length, k = !1;
    for (typeof C == "boolean" && (k = C, C = arguments[1] || {}, O = 2), (C == null || typeof C != "object" && typeof C != "function") && (C = {}); O < I; ++O)
      if (c = arguments[O], c != null)
        for (f in c)
          h = l(C, f), E = l(c, f), C !== E && (k && E && (i(E) || (m = u(E))) ? (m ? (m = !1, A = h && u(h) ? h : []) : A = h && i(h) ? h : {}, a(C, { name: f, newValue: o(k, A, E) })) : typeof E < "u" && a(C, { name: f, newValue: E }));
    return C;
  }, Bn;
}
var c0 = o0();
const Fn = /* @__PURE__ */ ii(c0);
function ir(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function h0() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...u) {
    let i = -1;
    const a = u.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    l(null, ...u);
    function l(o, ...c) {
      const f = e[++i];
      let h = -1;
      if (o) {
        a(o);
        return;
      }
      for (; ++h < u.length; )
        (c[h] === null || c[h] === void 0) && (c[h] = u[h]);
      u = c, f ? f0(f, l)(...c) : a(null, ...c);
    }
  }
  function r(u) {
    if (typeof u != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + u
      );
    return e.push(u), t;
  }
}
function f0(e, t) {
  let n;
  return r;
  function r(...a) {
    const l = e.length > a.length;
    let o;
    l && a.push(u);
    try {
      o = e.apply(this, a);
    } catch (c) {
      const f = (
        /** @type {Error} */
        c
      );
      if (l && n)
        throw f;
      return u(f);
    }
    l || (o && o.then && typeof o.then == "function" ? o.then(i, u) : o instanceof Error ? u(o) : i(o));
  }
  function u(a, ...l) {
    n || (n = !0, t(a, ...l));
  }
  function i(a) {
    u(null, a);
  }
}
const He = { basename: d0, dirname: m0, extname: p0, join: E0, sep: "/" };
function d0(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Jt(e);
  let n = 0, r = -1, u = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; u--; )
      if (e.codePointAt(u) === 47) {
        if (i) {
          n = u + 1;
          break;
        }
      } else r < 0 && (i = !0, r = u + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, l = t.length - 1;
  for (; u--; )
    if (e.codePointAt(u) === 47) {
      if (i) {
        n = u + 1;
        break;
      }
    } else
      a < 0 && (i = !0, a = u + 1), l > -1 && (e.codePointAt(u) === t.codePointAt(l--) ? l < 0 && (r = u) : (l = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function m0(e) {
  if (Jt(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function p0(e) {
  Jt(e);
  let t = e.length, n = -1, r = 0, u = -1, i = 0, a;
  for (; t--; ) {
    const l = e.codePointAt(t);
    if (l === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), l === 46 ? u < 0 ? u = t : i !== 1 && (i = 1) : u > -1 && (i = -1);
  }
  return u < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && u === n - 1 && u === r + 1 ? "" : e.slice(u, n);
}
function E0(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Jt(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : g0(n);
}
function g0(e) {
  Jt(e);
  const t = e.codePointAt(0) === 47;
  let n = T0(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function T0(e, t) {
  let n = "", r = 0, u = -1, i = 0, a = -1, l, o;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      l = e.codePointAt(a);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(u === a - 1 || i === 1)) if (u !== a - 1 && i === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (o = n.lastIndexOf("/"), o !== n.length - 1) {
              o < 0 ? (n = "", r = 0) : (n = n.slice(0, o), r = n.length - 1 - n.lastIndexOf("/")), u = a, i = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, u = a, i = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(u + 1, a) : n = e.slice(u + 1, a), r = a - u - 1;
      u = a, i = 0;
    } else l === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function Jt(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const b0 = { cwd: A0 };
function A0() {
  return "/";
}
function ar(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function _0(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!ar(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return C0(e);
}
function C0(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const u = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw u.code = "ERR_INVALID_FILE_URL_PATH", u;
      }
    }
  return decodeURIComponent(t);
}
const vn = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Vi {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? ar(t) ? n = { path: t } : typeof t == "string" || k0(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : b0.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < vn.length; ) {
      const i = vn[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let u;
    for (u in n)
      vn.includes(u) || (this[u] = n[u]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? He.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Hn(t, "basename"), Un(t, "basename"), this.path = He.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? He.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Su(this.basename, "dirname"), this.path = He.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? He.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (Un(t, "extname"), Su(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = He.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    ar(t) && (t = _0(t)), Hn(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? He.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Hn(t, "stem"), Un(t, "stem"), this.path = He.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const u = this.message(t, n, r);
    throw u.fatal = !0, u;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const u = this.message(t, n, r);
    return u.fatal = void 0, u;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const u = new be(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (u.name = this.path + ":" + u.name, u.file = this.path), u.fatal = !1, this.messages.push(u), u;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function Un(e, t) {
  if (e && e.includes(He.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + He.sep + "`"
    );
}
function Hn(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Su(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function k0(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const S0 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), u = r[e], i = function() {
      return u.apply(i, arguments);
    };
    return Object.setPrototypeOf(i, r), i;
  }
), y0 = {}.hasOwnProperty;
class Or extends S0 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = h0();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Or()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(Fn(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (qn("data", this.frozen), this.namespace[t] = n, this) : y0.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (qn("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const u = n.call(t, ...r);
      typeof u == "function" && this.transformers.use(u);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = sn(t), r = this.parser || this.Parser;
    return zn("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), zn("process", this.parser || this.Parser), Yn("process", this.compiler || this.Compiler), n ? u(void 0, n) : new Promise(u);
    function u(i, a) {
      const l = sn(t), o = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(l)
      );
      r.run(o, l, function(f, h, E) {
        if (f || !h || !E)
          return c(f);
        const m = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          h
        ), A = r.stringify(m, E);
        N0(A) ? E.value = A : E.result = A, c(
          f,
          /** @type {VFileWithOutput<CompileResult>} */
          E
        );
      });
      function c(f, h) {
        f || !h ? a(f) : i ? i(h) : n(void 0, h);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), zn("processSync", this.parser || this.Parser), Yn("processSync", this.compiler || this.Compiler), this.process(t, u), Iu("processSync", "process", n), r;
    function u(i, a) {
      n = !0, Cu(i), r = a;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    yu(t), this.freeze();
    const u = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? i(void 0, r) : new Promise(i);
    function i(a, l) {
      const o = sn(n);
      u.run(t, o, c);
      function c(f, h, E) {
        const m = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          h || t
        );
        f ? l(f) : a ? a(m) : r(void 0, m, E);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, u;
    return this.run(t, n, i), Iu("runSync", "run", r), u;
    function i(a, l) {
      Cu(a), u = l, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = sn(n), u = this.compiler || this.Compiler;
    return Yn("stringify", u), yu(t), u(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, u = this.namespace;
    if (qn("use", this.frozen), t != null) if (typeof t == "function")
      o(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? l(t) : a(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function i(c) {
      if (typeof c == "function")
        o(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [f, ...h] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          o(f, h);
        } else
          a(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function a(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(c.plugins), c.settings && (u.settings = Fn(!0, u.settings, c.settings));
    }
    function l(c) {
      let f = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++f < c.length; ) {
          const h = c[f];
          i(h);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function o(c, f) {
      let h = -1, E = -1;
      for (; ++h < r.length; )
        if (r[h][0] === c) {
          E = h;
          break;
        }
      if (E === -1)
        r.push([c, ...f]);
      else if (f.length > 0) {
        let [m, ...A] = f;
        const C = r[E][1];
        ir(C) && ir(m) && (m = Fn(!0, C, m)), r[E] = [c, m, ...A];
      }
    }
  }
}
const I0 = new Or().freeze();
function zn(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Yn(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function qn(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function yu(e) {
  if (!ir(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Iu(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function sn(e) {
  return x0(e) ? e : new Vi(e);
}
function x0(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function N0(e) {
  return typeof e == "string" || O0(e);
}
function O0(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const L0 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", xu = [], Nu = { allowDangerousHtml: !0 }, D0 = /^(https?|ircs?|mailto|xmpp)$/i, R0 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function P0(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", u = e.className, i = e.components, a = e.disallowedElements, l = e.rehypePlugins || xu, o = e.remarkPlugins || xu, c = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Nu } : Nu, f = e.skipHtml, h = e.unwrapDisallowed, E = e.urlTransform || w0, m = I0().use(mc).use(o).use(l0, c).use(l), A = new Vi();
  typeof r == "string" && (A.value = r);
  for (const k of R0)
    Object.hasOwn(e, k.from) && ("" + k.from + (k.to ? "use `" + k.to + "` instead" : "remove it") + L0 + k.id, void 0);
  const C = m.parse(A);
  let O = m.runSync(C, A);
  return u && (O = {
    type: "element",
    tagName: "div",
    properties: { className: u },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      O.type === "root" ? O.children : [O]
    )
  }), In(O, I), Xs(O, {
    Fragment: Cs,
    components: i,
    ignoreInvalidStyle: !0,
    jsx: le,
    jsxs: _s,
    passKeys: !0,
    passNode: !0
  });
  function I(k, R, Y) {
    if (k.type === "raw" && Y && typeof R == "number")
      return f ? Y.children.splice(R, 1) : Y.children[R] = { type: "text", value: k.value }, R;
    if (k.type === "element") {
      let q;
      for (q in Pn)
        if (Object.hasOwn(Pn, q) && Object.hasOwn(k.properties, q)) {
          const N = k.properties[q], V = Pn[q];
          (V === null || V.includes(k.tagName)) && (k.properties[q] = E(String(N || ""), q, k));
        }
    }
    if (k.type === "element") {
      let q = t ? !t.includes(k.tagName) : a ? a.includes(k.tagName) : !1;
      if (!q && n && typeof R == "number" && (q = !n(k, R, Y)), q && Y && typeof R == "number")
        return h && k.children ? Y.children.splice(R, 1, ...k.children) : Y.children.splice(R, 1), R;
    }
  }
}
function w0(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), u = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    u > -1 && t > u || n > -1 && t > n || r > -1 && t > r || // It is a protocol, it should be allowed.
    D0.test(e.slice(0, t)) ? e : ""
  );
}
function Ou(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, u = n.indexOf(t);
  for (; u !== -1; )
    r++, u = n.indexOf(t, u + t.length);
  return r;
}
function M0(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function B0(e, t, n) {
  const u = Sn((n || {}).ignore || []), i = F0(t);
  let a = -1;
  for (; ++a < i.length; )
    qi(e, "text", l);
  function l(c, f) {
    let h = -1, E;
    for (; ++h < f.length; ) {
      const m = f[h], A = E ? E.children : void 0;
      if (u(
        m,
        A ? A.indexOf(m) : void 0,
        E
      ))
        return;
      E = m;
    }
    if (E)
      return o(c, f);
  }
  function o(c, f) {
    const h = f[f.length - 1], E = i[a][0], m = i[a][1];
    let A = 0;
    const O = h.children.indexOf(c);
    let I = !1, k = [];
    E.lastIndex = 0;
    let R = E.exec(c.value);
    for (; R; ) {
      const Y = R.index, q = {
        index: R.index,
        input: R.input,
        stack: [...f, c]
      };
      let N = m(...R, q);
      if (typeof N == "string" && (N = N.length > 0 ? { type: "text", value: N } : void 0), N === !1 ? E.lastIndex = Y + 1 : (A !== Y && k.push({
        type: "text",
        value: c.value.slice(A, Y)
      }), Array.isArray(N) ? k.push(...N) : N && k.push(N), A = Y + R[0].length, I = !0), !E.global)
        break;
      R = E.exec(c.value);
    }
    return I ? (A < c.value.length && k.push({ type: "text", value: c.value.slice(A) }), h.children.splice(O, 1, ...k)) : k = [c], O + k.length;
  }
}
function F0(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length; ) {
    const u = n[r];
    t.push([v0(u[0]), U0(u[1])]);
  }
  return t;
}
function v0(e) {
  return typeof e == "string" ? new RegExp(M0(e), "g") : e;
}
function U0(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const Vn = "phrasing", Wn = ["autolink", "link", "image", "label"];
function H0() {
  return {
    transforms: [Q0],
    enter: {
      literalAutolink: Y0,
      literalAutolinkEmail: jn,
      literalAutolinkHttp: jn,
      literalAutolinkWww: jn
    },
    exit: {
      literalAutolink: j0,
      literalAutolinkEmail: W0,
      literalAutolinkHttp: q0,
      literalAutolinkWww: V0
    }
  };
}
function z0() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: Vn,
        notInConstruct: Wn
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: Vn,
        notInConstruct: Wn
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: Vn,
        notInConstruct: Wn
      }
    ]
  };
}
function Y0(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function jn(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function q0(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function V0(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function W0(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function j0(e) {
  this.exit(e);
}
function Q0(e) {
  B0(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, $0],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), X0]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function $0(e, t, n, r, u) {
  let i = "";
  if (!Wi(u) || (/^w/i.test(t) && (n = t + n, t = "", i = "http://"), !G0(n)))
    return !1;
  const a = K0(n + r);
  if (!a[0]) return !1;
  const l = {
    type: "link",
    title: null,
    url: i + t + a[0],
    children: [{ type: "text", value: t + a[0] }]
  };
  return a[1] ? [l, { type: "text", value: a[1] }] : l;
}
function X0(e, t, n, r) {
  return (
    // Not an expected previous character.
    !Wi(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function G0(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function K0(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const u = Ou(e, "(");
  let i = Ou(e, ")");
  for (; r !== -1 && u > i; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), i++;
  return [e, n];
}
function Wi(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || st(n) || _n(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
ji.peek = lh;
function J0() {
  return {
    enter: {
      gfmFootnoteDefinition: eh,
      gfmFootnoteDefinitionLabelString: th,
      gfmFootnoteCall: uh,
      gfmFootnoteCallString: ih
    },
    exit: {
      gfmFootnoteDefinition: rh,
      gfmFootnoteDefinitionLabelString: nh,
      gfmFootnoteCall: sh,
      gfmFootnoteCallString: ah
    }
  };
}
function Z0() {
  return {
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["phrasing", "label", "reference"] }],
    handlers: { footnoteDefinition: oh, footnoteReference: ji }
  };
}
function eh(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function th() {
  this.buffer();
}
function nh(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.label = t, n.identifier = ve(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function rh(e) {
  this.exit(e);
}
function uh(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function ih() {
  this.buffer();
}
function ah(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.label = t, n.identifier = ve(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function sh(e) {
  this.exit(e);
}
function ji(e, t, n, r) {
  const u = n.createTracker(r);
  let i = u.move("[^");
  const a = n.enter("footnoteReference"), l = n.enter("reference");
  return i += u.move(
    n.safe(n.associationId(e), {
      ...u.current(),
      before: i,
      after: "]"
    })
  ), l(), a(), i += u.move("]"), i;
}
function lh() {
  return "[";
}
function oh(e, t, n, r) {
  const u = n.createTracker(r);
  let i = u.move("[^");
  const a = n.enter("footnoteDefinition"), l = n.enter("label");
  return i += u.move(
    n.safe(n.associationId(e), {
      ...u.current(),
      before: i,
      after: "]"
    })
  ), l(), i += u.move(
    "]:" + (e.children && e.children.length > 0 ? " " : "")
  ), u.shift(4), i += u.move(
    n.indentLines(n.containerFlow(e, u.current()), ch)
  ), a(), i;
}
function ch(e, t, n) {
  return t === 0 ? e : (n ? "" : "    ") + e;
}
const hh = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
Qi.peek = Eh;
function fh() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: mh },
    exit: { strikethrough: ph }
  };
}
function dh() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: hh
      }
    ],
    handlers: { delete: Qi }
  };
}
function mh(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function ph(e) {
  this.exit(e);
}
function Qi(e, t, n, r) {
  const u = n.createTracker(r), i = n.enter("strikethrough");
  let a = u.move("~~");
  return a += n.containerPhrasing(e, {
    ...u.current(),
    before: a,
    after: "~"
  }), a += u.move("~~"), i(), a;
}
function Eh() {
  return "~";
}
function gh(e, t = {}) {
  const n = (t.align || []).concat(), r = t.stringLength || bh, u = [], i = [], a = [], l = [];
  let o = 0, c = -1;
  for (; ++c < e.length; ) {
    const A = [], C = [];
    let O = -1;
    for (e[c].length > o && (o = e[c].length); ++O < e[c].length; ) {
      const I = Th(e[c][O]);
      if (t.alignDelimiters !== !1) {
        const k = r(I);
        C[O] = k, (l[O] === void 0 || k > l[O]) && (l[O] = k);
      }
      A.push(I);
    }
    i[c] = A, a[c] = C;
  }
  let f = -1;
  if (typeof n == "object" && "length" in n)
    for (; ++f < o; )
      u[f] = Lu(n[f]);
  else {
    const A = Lu(n);
    for (; ++f < o; )
      u[f] = A;
  }
  f = -1;
  const h = [], E = [];
  for (; ++f < o; ) {
    const A = u[f];
    let C = "", O = "";
    A === 99 ? (C = ":", O = ":") : A === 108 ? C = ":" : A === 114 && (O = ":");
    let I = t.alignDelimiters === !1 ? 1 : Math.max(
      1,
      l[f] - C.length - O.length
    );
    const k = C + "-".repeat(I) + O;
    t.alignDelimiters !== !1 && (I = C.length + I + O.length, I > l[f] && (l[f] = I), E[f] = I), h[f] = k;
  }
  i.splice(1, 0, h), a.splice(1, 0, E), c = -1;
  const m = [];
  for (; ++c < i.length; ) {
    const A = i[c], C = a[c];
    f = -1;
    const O = [];
    for (; ++f < o; ) {
      const I = A[f] || "";
      let k = "", R = "";
      if (t.alignDelimiters !== !1) {
        const Y = l[f] - (C[f] || 0), q = u[f];
        q === 114 ? k = " ".repeat(Y) : q === 99 ? Y % 2 ? (k = " ".repeat(Y / 2 + 0.5), R = " ".repeat(Y / 2 - 0.5)) : (k = " ".repeat(Y / 2), R = k) : R = " ".repeat(Y);
      }
      t.delimiterStart !== !1 && !f && O.push("|"), t.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(t.alignDelimiters === !1 && I === "") && (t.delimiterStart !== !1 || f) && O.push(" "), t.alignDelimiters !== !1 && O.push(k), O.push(I), t.alignDelimiters !== !1 && O.push(R), t.padding !== !1 && O.push(" "), (t.delimiterEnd !== !1 || f !== o - 1) && O.push("|");
    }
    m.push(
      t.delimiterEnd === !1 ? O.join("").replace(/ +$/, "") : O.join("")
    );
  }
  return m.join(`
`);
}
function Th(e) {
  return e == null ? "" : String(e);
}
function bh(e) {
  return e.length;
}
function Lu(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
const Du = {}.hasOwnProperty;
function $i(e, t) {
  const n = t || {};
  function r(u, ...i) {
    let a = r.invalid;
    const l = r.handlers;
    if (u && Du.call(u, e)) {
      const o = String(u[e]);
      a = Du.call(l, o) ? l[o] : r.unknown;
    }
    if (a)
      return a.call(this, u, ...i);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
function Ah(e, t, n, r) {
  const u = n.enter("blockquote"), i = n.createTracker(r);
  i.move("> "), i.shift(2);
  const a = n.indentLines(
    n.containerFlow(e, i.current()),
    _h
  );
  return u(), a;
}
function _h(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function Ch(e, t) {
  return Ru(e, t.inConstruct, !0) && !Ru(e, t.notInConstruct, !1);
}
function Ru(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function Pu(e, t, n, r) {
  let u = -1;
  for (; ++u < n.unsafe.length; )
    if (n.unsafe[u].character === `
` && Ch(n.stack, n.unsafe[u]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function Xi(e, t) {
  const n = String(e);
  let r = n.indexOf(t), u = r, i = 0, a = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === u ? ++i > a && (a = i) : i = 1, u = r + t.length, r = n.indexOf(t, u);
  return a;
}
function kh(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function Sh(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function yh(e, t, n, r) {
  const u = Sh(n), i = e.value || "", a = u === "`" ? "GraveAccent" : "Tilde";
  if (kh(e, n)) {
    const h = n.enter("codeIndented"), E = n.indentLines(i, Ih);
    return h(), E;
  }
  const l = n.createTracker(r), o = u.repeat(Math.max(Xi(i, u) + 1, 3)), c = n.enter("codeFenced");
  let f = l.move(o);
  if (e.lang) {
    const h = n.enter(`codeFencedLang${a}`);
    f += l.move(
      n.safe(e.lang, {
        before: f,
        after: " ",
        encode: ["`"],
        ...l.current()
      })
    ), h();
  }
  if (e.lang && e.meta) {
    const h = n.enter(`codeFencedMeta${a}`);
    f += l.move(" "), f += l.move(
      n.safe(e.meta, {
        before: f,
        after: `
`,
        encode: ["`"],
        ...l.current()
      })
    ), h();
  }
  return f += l.move(`
`), i && (f += l.move(i + `
`)), f += l.move(o), c(), f;
}
function Ih(e, t, n) {
  return (n ? "" : "    ") + e;
}
function Lr(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function xh(e, t, n, r) {
  const u = Lr(n), i = u === '"' ? "Quote" : "Apostrophe", a = n.enter("definition");
  let l = n.enter("label");
  const o = n.createTracker(r);
  let c = o.move("[");
  return c += o.move(
    n.safe(n.associationId(e), {
      before: c,
      after: "]",
      ...o.current()
    })
  ), c += o.move("]: "), l(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), c += o.move("<"), c += o.move(
    n.safe(e.url, { before: c, after: ">", ...o.current() })
  ), c += o.move(">")) : (l = n.enter("destinationRaw"), c += o.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : `
`,
      ...o.current()
    })
  )), l(), e.title && (l = n.enter(`title${i}`), c += o.move(" " + u), c += o.move(
    n.safe(e.title, {
      before: c,
      after: u,
      ...o.current()
    })
  ), c += o.move(u), l()), a(), c;
}
function Nh(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
Gi.peek = Oh;
function Gi(e, t, n, r) {
  const u = Nh(n), i = n.enter("emphasis"), a = n.createTracker(r);
  let l = a.move(u);
  return l += a.move(
    n.containerPhrasing(e, {
      before: l,
      after: u,
      ...a.current()
    })
  ), l += a.move(u), i(), l;
}
function Oh(e, t, n) {
  return n.options.emphasis || "*";
}
function Lh(e, t) {
  let n = !1;
  return In(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, rr;
  }), !!((!e.depth || e.depth < 3) && Cr(e) && (t.options.setext || n));
}
function Dh(e, t, n, r) {
  const u = Math.max(Math.min(6, e.depth || 1), 1), i = n.createTracker(r);
  if (Lh(e, n)) {
    const f = n.enter("headingSetext"), h = n.enter("phrasing"), E = n.containerPhrasing(e, {
      ...i.current(),
      before: `
`,
      after: `
`
    });
    return h(), f(), E + `
` + (u === 1 ? "=" : "-").repeat(
      // The whole size…
      E.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(E.lastIndexOf("\r"), E.lastIndexOf(`
`)) + 1)
    );
  }
  const a = "#".repeat(u), l = n.enter("headingAtx"), o = n.enter("phrasing");
  i.move(a + " ");
  let c = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...i.current()
  });
  return /^[\t ]/.test(c) && (c = "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";" + c.slice(1)), c = c ? a + " " + c : a, n.options.closeAtx && (c += " " + a), o(), l(), c;
}
Ki.peek = Rh;
function Ki(e) {
  return e.value || "";
}
function Rh() {
  return "<";
}
Ji.peek = Ph;
function Ji(e, t, n, r) {
  const u = Lr(n), i = u === '"' ? "Quote" : "Apostrophe", a = n.enter("image");
  let l = n.enter("label");
  const o = n.createTracker(r);
  let c = o.move("![");
  return c += o.move(
    n.safe(e.alt, { before: c, after: "]", ...o.current() })
  ), c += o.move("]("), l(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), c += o.move("<"), c += o.move(
    n.safe(e.url, { before: c, after: ">", ...o.current() })
  ), c += o.move(">")) : (l = n.enter("destinationRaw"), c += o.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...o.current()
    })
  )), l(), e.title && (l = n.enter(`title${i}`), c += o.move(" " + u), c += o.move(
    n.safe(e.title, {
      before: c,
      after: u,
      ...o.current()
    })
  ), c += o.move(u), l()), c += o.move(")"), a(), c;
}
function Ph() {
  return "!";
}
Zi.peek = wh;
function Zi(e, t, n, r) {
  const u = e.referenceType, i = n.enter("imageReference");
  let a = n.enter("label");
  const l = n.createTracker(r);
  let o = l.move("![");
  const c = n.safe(e.alt, {
    before: o,
    after: "]",
    ...l.current()
  });
  o += l.move(c + "]["), a();
  const f = n.stack;
  n.stack = [], a = n.enter("reference");
  const h = n.safe(n.associationId(e), {
    before: o,
    after: "]",
    ...l.current()
  });
  return a(), n.stack = f, i(), u === "full" || !c || c !== h ? o += l.move(h + "]") : u === "shortcut" ? o = o.slice(0, -1) : o += l.move("]"), o;
}
function wh() {
  return "!";
}
ea.peek = Mh;
function ea(e, t, n) {
  let r = e.value || "", u = "`", i = -1;
  for (; new RegExp("(^|[^`])" + u + "([^`]|$)").test(r); )
    u += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++i < n.unsafe.length; ) {
    const a = n.unsafe[i], l = n.compilePattern(a);
    let o;
    if (a.atBreak)
      for (; o = l.exec(r); ) {
        let c = o.index;
        r.charCodeAt(c) === 10 && r.charCodeAt(c - 1) === 13 && c--, r = r.slice(0, c) + " " + r.slice(o.index + 1);
      }
  }
  return u + r + u;
}
function Mh() {
  return "`";
}
function ta(e, t) {
  const n = Cr(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
na.peek = Bh;
function na(e, t, n, r) {
  const u = Lr(n), i = u === '"' ? "Quote" : "Apostrophe", a = n.createTracker(r);
  let l, o;
  if (ta(e, n)) {
    const f = n.stack;
    n.stack = [], l = n.enter("autolink");
    let h = a.move("<");
    return h += a.move(
      n.containerPhrasing(e, {
        before: h,
        after: ">",
        ...a.current()
      })
    ), h += a.move(">"), l(), n.stack = f, h;
  }
  l = n.enter("link"), o = n.enter("label");
  let c = a.move("[");
  return c += a.move(
    n.containerPhrasing(e, {
      before: c,
      after: "](",
      ...a.current()
    })
  ), c += a.move("]("), o(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (o = n.enter("destinationLiteral"), c += a.move("<"), c += a.move(
    n.safe(e.url, { before: c, after: ">", ...a.current() })
  ), c += a.move(">")) : (o = n.enter("destinationRaw"), c += a.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...a.current()
    })
  )), o(), e.title && (o = n.enter(`title${i}`), c += a.move(" " + u), c += a.move(
    n.safe(e.title, {
      before: c,
      after: u,
      ...a.current()
    })
  ), c += a.move(u), o()), c += a.move(")"), l(), c;
}
function Bh(e, t, n) {
  return ta(e, n) ? "<" : "[";
}
ra.peek = Fh;
function ra(e, t, n, r) {
  const u = e.referenceType, i = n.enter("linkReference");
  let a = n.enter("label");
  const l = n.createTracker(r);
  let o = l.move("[");
  const c = n.containerPhrasing(e, {
    before: o,
    after: "]",
    ...l.current()
  });
  o += l.move(c + "]["), a();
  const f = n.stack;
  n.stack = [], a = n.enter("reference");
  const h = n.safe(n.associationId(e), {
    before: o,
    after: "]",
    ...l.current()
  });
  return a(), n.stack = f, i(), u === "full" || !c || c !== h ? o += l.move(h + "]") : u === "shortcut" ? o = o.slice(0, -1) : o += l.move("]"), o;
}
function Fh() {
  return "[";
}
function Dr(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function vh(e) {
  const t = Dr(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function Uh(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function ua(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function Hh(e, t, n, r) {
  const u = n.enter("list"), i = n.bulletCurrent;
  let a = e.ordered ? Uh(n) : Dr(n);
  const l = e.ordered ? a === "." ? ")" : "." : vh(n);
  let o = t && n.bulletLastUsed ? a === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const f = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (a === "*" || a === "-") && // Empty first list item:
      f && (!f.children || !f.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (o = !0), ua(n) === a && f
    ) {
      let h = -1;
      for (; ++h < e.children.length; ) {
        const E = e.children[h];
        if (E && E.type === "listItem" && E.children && E.children[0] && E.children[0].type === "thematicBreak") {
          o = !0;
          break;
        }
      }
    }
  }
  o && (a = l), n.bulletCurrent = a;
  const c = n.containerFlow(e, r);
  return n.bulletLastUsed = a, n.bulletCurrent = i, u(), c;
}
function zh(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function Yh(e, t, n, r) {
  const u = zh(n);
  let i = n.bulletCurrent || Dr(n);
  t && t.type === "list" && t.ordered && (i = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + i);
  let a = i.length + 1;
  (u === "tab" || u === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (a = Math.ceil(a / 4) * 4);
  const l = n.createTracker(r);
  l.move(i + " ".repeat(a - i.length)), l.shift(a);
  const o = n.enter("listItem"), c = n.indentLines(
    n.containerFlow(e, l.current()),
    f
  );
  return o(), c;
  function f(h, E, m) {
    return E ? (m ? "" : " ".repeat(a)) + h : (m ? i : i + " ".repeat(a - i.length)) + h;
  }
}
function qh(e, t, n, r) {
  const u = n.enter("paragraph"), i = n.enter("phrasing"), a = n.containerPhrasing(e, r);
  return i(), u(), a;
}
const Vh = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  Sn([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function Wh(e, t, n, r) {
  return (e.children.some(function(a) {
    return Vh(a);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function jh(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
ia.peek = Qh;
function ia(e, t, n, r) {
  const u = jh(n), i = n.enter("strong"), a = n.createTracker(r);
  let l = a.move(u + u);
  return l += a.move(
    n.containerPhrasing(e, {
      before: l,
      after: u,
      ...a.current()
    })
  ), l += a.move(u + u), i(), l;
}
function Qh(e, t, n) {
  return n.options.strong || "*";
}
function $h(e, t, n, r) {
  return n.safe(e.value, r);
}
function Xh(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function Gh(e, t, n) {
  const r = (ua(n) + (n.options.ruleSpaces ? " " : "")).repeat(Xh(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const aa = {
  blockquote: Ah,
  break: Pu,
  code: yh,
  definition: xh,
  emphasis: Gi,
  hardBreak: Pu,
  heading: Dh,
  html: Ki,
  image: Ji,
  imageReference: Zi,
  inlineCode: ea,
  link: na,
  linkReference: ra,
  list: Hh,
  listItem: Yh,
  paragraph: qh,
  root: Wh,
  strong: ia,
  text: $h,
  thematicBreak: Gh
};
function Kh() {
  return {
    enter: {
      table: Jh,
      tableData: wu,
      tableHeader: wu,
      tableRow: ef
    },
    exit: {
      codeText: tf,
      table: Zh,
      tableData: Qn,
      tableHeader: Qn,
      tableRow: Qn
    }
  };
}
function Jh(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function Zh(e) {
  this.exit(e), this.data.inTable = void 0;
}
function ef(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Qn(e) {
  this.exit(e);
}
function wu(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function tf(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, nf));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function nf(e, t) {
  return t === "|" ? t : e;
}
function rf(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, u = t.stringLength, i = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: E,
      table: a,
      tableCell: o,
      tableRow: l
    }
  };
  function a(m, A, C, O) {
    return c(f(m, C, O), m.align);
  }
  function l(m, A, C, O) {
    const I = h(m, C, O), k = c([I]);
    return k.slice(0, k.indexOf(`
`));
  }
  function o(m, A, C, O) {
    const I = C.enter("tableCell"), k = C.enter("phrasing"), R = C.containerPhrasing(m, {
      ...O,
      before: i,
      after: i
    });
    return k(), I(), R;
  }
  function c(m, A) {
    return gh(m, {
      align: A,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: u
    });
  }
  function f(m, A, C) {
    const O = m.children;
    let I = -1;
    const k = [], R = A.enter("table");
    for (; ++I < O.length; )
      k[I] = h(O[I], A, C);
    return R(), k;
  }
  function h(m, A, C) {
    const O = m.children;
    let I = -1;
    const k = [], R = A.enter("tableRow");
    for (; ++I < O.length; )
      k[I] = o(O[I], m, A, C);
    return R(), k;
  }
  function E(m, A, C) {
    let O = aa.inlineCode(m, A, C);
    return C.stack.includes("tableCell") && (O = O.replace(/\|/g, "\\$&")), O;
  }
}
function uf() {
  return {
    exit: {
      taskListCheckValueChecked: Mu,
      taskListCheckValueUnchecked: Mu,
      paragraph: sf
    }
  };
}
function af() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: lf }
  };
}
function Mu(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function sf(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const u = t.children;
      let i = -1, a;
      for (; ++i < u.length; ) {
        const l = u[i];
        if (l.type === "paragraph") {
          a = l;
          break;
        }
      }
      a === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function lf(e, t, n, r) {
  const u = e.children[0], i = typeof e.checked == "boolean" && u && u.type === "paragraph", a = "[" + (e.checked ? "x" : " ") + "] ", l = n.createTracker(r);
  i && l.move(a);
  let o = aa.listItem(e, t, n, {
    ...r,
    ...l.current()
  });
  return i && (o = o.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, c)), o;
  function c(f) {
    return f + a;
  }
}
function of() {
  return [
    H0(),
    J0(),
    fh(),
    Kh(),
    uf()
  ];
}
function cf(e) {
  return {
    extensions: [
      z0(),
      Z0(),
      dh(),
      rf(e),
      af()
    ]
  };
}
const hf = {
  tokenize: gf,
  partial: !0
}, sa = {
  tokenize: Tf,
  partial: !0
}, la = {
  tokenize: bf,
  partial: !0
}, oa = {
  tokenize: Af,
  partial: !0
}, ff = {
  tokenize: _f,
  partial: !0
}, ca = {
  name: "wwwAutolink",
  tokenize: pf,
  previous: fa
}, ha = {
  name: "protocolAutolink",
  tokenize: Ef,
  previous: da
}, Xe = {
  name: "emailAutolink",
  tokenize: mf,
  previous: ma
}, qe = {};
function df() {
  return {
    text: qe
  };
}
let ut = 48;
for (; ut < 123; )
  qe[ut] = Xe, ut++, ut === 58 ? ut = 65 : ut === 91 && (ut = 97);
qe[43] = Xe;
qe[45] = Xe;
qe[46] = Xe;
qe[95] = Xe;
qe[72] = [Xe, ha];
qe[104] = [Xe, ha];
qe[87] = [Xe, ca];
qe[119] = [Xe, ca];
function mf(e, t, n) {
  const r = this;
  let u, i;
  return a;
  function a(h) {
    return !sr(h) || !ma.call(r, r.previous) || Rr(r.events) ? n(h) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), l(h));
  }
  function l(h) {
    return sr(h) ? (e.consume(h), l) : h === 64 ? (e.consume(h), o) : n(h);
  }
  function o(h) {
    return h === 46 ? e.check(ff, f, c)(h) : h === 45 || h === 95 || Te(h) ? (i = !0, e.consume(h), o) : f(h);
  }
  function c(h) {
    return e.consume(h), u = !0, o;
  }
  function f(h) {
    return i && u && _e(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(h)) : n(h);
  }
}
function pf(e, t, n) {
  const r = this;
  return u;
  function u(a) {
    return a !== 87 && a !== 119 || !fa.call(r, r.previous) || Rr(r.events) ? n(a) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(hf, e.attempt(sa, e.attempt(la, i), n), n)(a));
  }
  function i(a) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(a);
  }
}
function Ef(e, t, n) {
  const r = this;
  let u = "", i = !1;
  return a;
  function a(h) {
    return (h === 72 || h === 104) && da.call(r, r.previous) && !Rr(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), u += String.fromCodePoint(h), e.consume(h), l) : n(h);
  }
  function l(h) {
    if (_e(h) && u.length < 5)
      return u += String.fromCodePoint(h), e.consume(h), l;
    if (h === 58) {
      const E = u.toLowerCase();
      if (E === "http" || E === "https")
        return e.consume(h), o;
    }
    return n(h);
  }
  function o(h) {
    return h === 47 ? (e.consume(h), i ? c : (i = !0, o)) : n(h);
  }
  function c(h) {
    return h === null || dn(h) || re(h) || st(h) || _n(h) ? n(h) : e.attempt(sa, e.attempt(la, f), n)(h);
  }
  function f(h) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(h);
  }
}
function gf(e, t, n) {
  let r = 0;
  return u;
  function u(a) {
    return (a === 87 || a === 119) && r < 3 ? (r++, e.consume(a), u) : a === 46 && r === 3 ? (e.consume(a), i) : n(a);
  }
  function i(a) {
    return a === null ? n(a) : t(a);
  }
}
function Tf(e, t, n) {
  let r, u, i;
  return a;
  function a(c) {
    return c === 46 || c === 95 ? e.check(oa, o, l)(c) : c === null || re(c) || st(c) || c !== 45 && _n(c) ? o(c) : (i = !0, e.consume(c), a);
  }
  function l(c) {
    return c === 95 ? r = !0 : (u = r, r = void 0), e.consume(c), a;
  }
  function o(c) {
    return u || r || !i ? n(c) : t(c);
  }
}
function bf(e, t) {
  let n = 0, r = 0;
  return u;
  function u(a) {
    return a === 40 ? (n++, e.consume(a), u) : a === 41 && r < n ? i(a) : a === 33 || a === 34 || a === 38 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 60 || a === 63 || a === 93 || a === 95 || a === 126 ? e.check(oa, t, i)(a) : a === null || re(a) || st(a) ? t(a) : (e.consume(a), u);
  }
  function i(a) {
    return a === 41 && r++, e.consume(a), u;
  }
}
function Af(e, t, n) {
  return r;
  function r(l) {
    return l === 33 || l === 34 || l === 39 || l === 41 || l === 42 || l === 44 || l === 46 || l === 58 || l === 59 || l === 63 || l === 95 || l === 126 ? (e.consume(l), r) : l === 38 ? (e.consume(l), i) : l === 93 ? (e.consume(l), u) : (
      // `<` is an end.
      l === 60 || // So is whitespace.
      l === null || re(l) || st(l) ? t(l) : n(l)
    );
  }
  function u(l) {
    return l === null || l === 40 || l === 91 || re(l) || st(l) ? t(l) : r(l);
  }
  function i(l) {
    return _e(l) ? a(l) : n(l);
  }
  function a(l) {
    return l === 59 ? (e.consume(l), r) : _e(l) ? (e.consume(l), a) : n(l);
  }
}
function _f(e, t, n) {
  return r;
  function r(i) {
    return e.consume(i), u;
  }
  function u(i) {
    return Te(i) ? n(i) : t(i);
  }
}
function fa(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || re(e);
}
function da(e) {
  return !_e(e);
}
function ma(e) {
  return !(e === 47 || sr(e));
}
function sr(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Te(e);
}
function Rr(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const Cf = {
  tokenize: Lf,
  partial: !0
};
function kf() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: xf,
        continuation: {
          tokenize: Nf
        },
        exit: Of
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: If
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: Sf,
        resolveTo: yf
      }
    }
  };
}
function Sf(e, t, n) {
  const r = this;
  let u = r.events.length;
  const i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a;
  for (; u--; ) {
    const o = r.events[u][1];
    if (o.type === "labelImage") {
      a = o;
      break;
    }
    if (o.type === "gfmFootnoteCall" || o.type === "labelLink" || o.type === "label" || o.type === "image" || o.type === "link")
      break;
  }
  return l;
  function l(o) {
    if (!a || !a._balanced)
      return n(o);
    const c = ve(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }));
    return c.codePointAt(0) !== 94 || !i.includes(c.slice(1)) ? n(o) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(o), e.exit("gfmFootnoteCallLabelMarker"), t(o));
  }
}
function yf(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, u = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  u.end.column++, u.end.offset++, u.end._bufferIndex++;
  const i = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, u.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, a = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, i.start),
    end: Object.assign({}, i.end)
  }, l = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", u, t],
    ["exit", u, t],
    // Everything in between.
    ["enter", i, t],
    ["enter", a, t],
    ["exit", a, t],
    ["exit", i, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...l), e;
}
function If(e, t, n) {
  const r = this, u = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i = 0, a;
  return l;
  function l(h) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(h), e.exit("gfmFootnoteCallLabelMarker"), o;
  }
  function o(h) {
    return h !== 94 ? n(h) : (e.enter("gfmFootnoteCallMarker"), e.consume(h), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", c);
  }
  function c(h) {
    if (
      // Too long.
      i > 999 || // Closing brace with nothing.
      h === 93 && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      h === null || h === 91 || re(h)
    )
      return n(h);
    if (h === 93) {
      e.exit("chunkString");
      const E = e.exit("gfmFootnoteCallString");
      return u.includes(ve(r.sliceSerialize(E))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(h), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(h);
    }
    return re(h) || (a = !0), i++, e.consume(h), h === 92 ? f : c;
  }
  function f(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), i++, c) : c(h);
  }
}
function xf(e, t, n) {
  const r = this, u = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i, a = 0, l;
  return o;
  function o(A) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(A), e.exit("gfmFootnoteDefinitionLabelMarker"), c;
  }
  function c(A) {
    return A === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(A), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", f) : n(A);
  }
  function f(A) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      A === 93 && !l || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      A === null || A === 91 || re(A)
    )
      return n(A);
    if (A === 93) {
      e.exit("chunkString");
      const C = e.exit("gfmFootnoteDefinitionLabelString");
      return i = ve(r.sliceSerialize(C)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(A), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), E;
    }
    return re(A) || (l = !0), a++, e.consume(A), A === 92 ? h : f;
  }
  function h(A) {
    return A === 91 || A === 92 || A === 93 ? (e.consume(A), a++, f) : f(A);
  }
  function E(A) {
    return A === 58 ? (e.enter("definitionMarker"), e.consume(A), e.exit("definitionMarker"), u.includes(i) || u.push(i), J(e, m, "gfmFootnoteDefinitionWhitespace")) : n(A);
  }
  function m(A) {
    return t(A);
  }
}
function Nf(e, t, n) {
  return e.check(Kt, t, e.attempt(Cf, t, n));
}
function Of(e) {
  e.exit("gfmFootnoteDefinition");
}
function Lf(e, t, n) {
  const r = this;
  return J(e, u, "gfmFootnoteDefinitionIndent", 5);
  function u(i) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "gfmFootnoteDefinitionIndent" && a[2].sliceSerialize(a[1], !0).length === 4 ? t(i) : n(i);
  }
}
function Df(e) {
  let n = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: i,
    resolveAll: u
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function u(a, l) {
    let o = -1;
    for (; ++o < a.length; )
      if (a[o][0] === "enter" && a[o][1].type === "strikethroughSequenceTemporary" && a[o][1]._close) {
        let c = o;
        for (; c--; )
          if (a[c][0] === "exit" && a[c][1].type === "strikethroughSequenceTemporary" && a[c][1]._open && // If the sizes are the same:
          a[o][1].end.offset - a[o][1].start.offset === a[c][1].end.offset - a[c][1].start.offset) {
            a[o][1].type = "strikethroughSequence", a[c][1].type = "strikethroughSequence";
            const f = {
              type: "strikethrough",
              start: Object.assign({}, a[c][1].start),
              end: Object.assign({}, a[o][1].end)
            }, h = {
              type: "strikethroughText",
              start: Object.assign({}, a[c][1].end),
              end: Object.assign({}, a[o][1].start)
            }, E = [["enter", f, l], ["enter", a[c][1], l], ["exit", a[c][1], l], ["enter", h, l]], m = l.parser.constructs.insideSpan.null;
            m && Re(E, E.length, 0, Cn(m, a.slice(c + 1, o), l)), Re(E, E.length, 0, [["exit", h, l], ["enter", a[o][1], l], ["exit", a[o][1], l], ["exit", f, l]]), Re(a, c - 1, o - c + 3, E), o = c + E.length - 2;
            break;
          }
      }
    for (o = -1; ++o < a.length; )
      a[o][1].type === "strikethroughSequenceTemporary" && (a[o][1].type = "data");
    return a;
  }
  function i(a, l, o) {
    const c = this.previous, f = this.events;
    let h = 0;
    return E;
    function E(A) {
      return c === 126 && f[f.length - 1][1].type !== "characterEscape" ? o(A) : (a.enter("strikethroughSequenceTemporary"), m(A));
    }
    function m(A) {
      const C = mn(c);
      if (A === 126)
        return h > 1 ? o(A) : (a.consume(A), h++, m);
      if (h < 2 && !n) return o(A);
      const O = a.exit("strikethroughSequenceTemporary"), I = mn(A);
      return O._open = !I || I === 2 && !!C, O._close = !C || C === 2 && !!I, l(A);
    }
  }
}
class Rf {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, r) {
    Pf(this, t, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(i, a) {
      return i[0] - a[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    r.push([...t]), t.length = 0;
    let u = r.pop();
    for (; u; )
      t.push(...u), u = r.pop();
    this.map.length = 0;
  }
}
function Pf(e, t, n, r) {
  let u = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; u < e.map.length; ) {
      if (e.map[u][0] === t) {
        e.map[u][1] += n, e.map[u][2].push(...r);
        return;
      }
      u += 1;
    }
    e.map.push([t, n, r]);
  }
}
function wf(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const u = e[t];
    if (n) {
      if (u[0] === "enter")
        u[1].type === "tableContent" && r.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (u[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const i = r.length - 1;
          r[i] = r[i] === "left" ? "center" : "right";
        }
      } else if (u[1].type === "tableDelimiterRow")
        break;
    } else u[0] === "enter" && u[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
function Mf() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: Bf,
        resolveAll: Ff
      }
    }
  };
}
function Bf(e, t, n) {
  const r = this;
  let u = 0, i = 0, a;
  return l;
  function l(y) {
    let U = r.events.length - 1;
    for (; U > -1; ) {
      const F = r.events[U][1].type;
      if (F === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      F === "linePrefix") U--;
      else break;
    }
    const H = U > -1 ? r.events[U][1].type : null, z = H === "tableHead" || H === "tableRow" ? N : o;
    return z === N && r.parser.lazy[r.now().line] ? n(y) : z(y);
  }
  function o(y) {
    return e.enter("tableHead"), e.enter("tableRow"), c(y);
  }
  function c(y) {
    return y === 124 || (a = !0, i += 1), f(y);
  }
  function f(y) {
    return y === null ? n(y) : v(y) ? i > 1 ? (i = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), m) : n(y) : Z(y) ? J(e, f, "whitespace")(y) : (i += 1, a && (a = !1, u += 1), y === 124 ? (e.enter("tableCellDivider"), e.consume(y), e.exit("tableCellDivider"), a = !0, f) : (e.enter("data"), h(y)));
  }
  function h(y) {
    return y === null || y === 124 || re(y) ? (e.exit("data"), f(y)) : (e.consume(y), y === 92 ? E : h);
  }
  function E(y) {
    return y === 92 || y === 124 ? (e.consume(y), h) : h(y);
  }
  function m(y) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(y) : (e.enter("tableDelimiterRow"), a = !1, Z(y) ? J(e, A, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(y) : A(y));
  }
  function A(y) {
    return y === 45 || y === 58 ? O(y) : y === 124 ? (a = !0, e.enter("tableCellDivider"), e.consume(y), e.exit("tableCellDivider"), C) : q(y);
  }
  function C(y) {
    return Z(y) ? J(e, O, "whitespace")(y) : O(y);
  }
  function O(y) {
    return y === 58 ? (i += 1, a = !0, e.enter("tableDelimiterMarker"), e.consume(y), e.exit("tableDelimiterMarker"), I) : y === 45 ? (i += 1, I(y)) : y === null || v(y) ? Y(y) : q(y);
  }
  function I(y) {
    return y === 45 ? (e.enter("tableDelimiterFiller"), k(y)) : q(y);
  }
  function k(y) {
    return y === 45 ? (e.consume(y), k) : y === 58 ? (a = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(y), e.exit("tableDelimiterMarker"), R) : (e.exit("tableDelimiterFiller"), R(y));
  }
  function R(y) {
    return Z(y) ? J(e, Y, "whitespace")(y) : Y(y);
  }
  function Y(y) {
    return y === 124 ? A(y) : y === null || v(y) ? !a || u !== i ? q(y) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(y)) : q(y);
  }
  function q(y) {
    return n(y);
  }
  function N(y) {
    return e.enter("tableRow"), V(y);
  }
  function V(y) {
    return y === 124 ? (e.enter("tableCellDivider"), e.consume(y), e.exit("tableCellDivider"), V) : y === null || v(y) ? (e.exit("tableRow"), t(y)) : Z(y) ? J(e, V, "whitespace")(y) : (e.enter("data"), te(y));
  }
  function te(y) {
    return y === null || y === 124 || re(y) ? (e.exit("data"), V(y)) : (e.consume(y), y === 92 ? j : te);
  }
  function j(y) {
    return y === 92 || y === 124 ? (e.consume(y), te) : te(y);
  }
}
function Ff(e, t) {
  let n = -1, r = !0, u = 0, i = [0, 0, 0, 0], a = [0, 0, 0, 0], l = !1, o = 0, c, f, h;
  const E = new Rf();
  for (; ++n < e.length; ) {
    const m = e[n], A = m[1];
    m[0] === "enter" ? A.type === "tableHead" ? (l = !1, o !== 0 && (Bu(E, t, o, c, f), f = void 0, o = 0), c = {
      type: "table",
      start: Object.assign({}, A.start),
      // Note: correct end is set later.
      end: Object.assign({}, A.end)
    }, E.add(n, 0, [["enter", c, t]])) : A.type === "tableRow" || A.type === "tableDelimiterRow" ? (r = !0, h = void 0, i = [0, 0, 0, 0], a = [0, n + 1, 0, 0], l && (l = !1, f = {
      type: "tableBody",
      start: Object.assign({}, A.start),
      // Note: correct end is set later.
      end: Object.assign({}, A.end)
    }, E.add(n, 0, [["enter", f, t]])), u = A.type === "tableDelimiterRow" ? 2 : f ? 3 : 1) : u && (A.type === "data" || A.type === "tableDelimiterMarker" || A.type === "tableDelimiterFiller") ? (r = !1, a[2] === 0 && (i[1] !== 0 && (a[0] = a[1], h = ln(E, t, i, u, void 0, h), i = [0, 0, 0, 0]), a[2] = n)) : A.type === "tableCellDivider" && (r ? r = !1 : (i[1] !== 0 && (a[0] = a[1], h = ln(E, t, i, u, void 0, h)), i = a, a = [i[1], n, 0, 0])) : A.type === "tableHead" ? (l = !0, o = n) : A.type === "tableRow" || A.type === "tableDelimiterRow" ? (o = n, i[1] !== 0 ? (a[0] = a[1], h = ln(E, t, i, u, n, h)) : a[1] !== 0 && (h = ln(E, t, a, u, n, h)), u = 0) : u && (A.type === "data" || A.type === "tableDelimiterMarker" || A.type === "tableDelimiterFiller") && (a[3] = n);
  }
  for (o !== 0 && Bu(E, t, o, c, f), E.consume(t.events), n = -1; ++n < t.events.length; ) {
    const m = t.events[n];
    m[0] === "enter" && m[1].type === "table" && (m[1]._align = wf(t.events, n));
  }
  return e;
}
function ln(e, t, n, r, u, i) {
  const a = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", l = "tableContent";
  n[0] !== 0 && (i.end = Object.assign({}, gt(t.events, n[0])), e.add(n[0], 0, [["exit", i, t]]));
  const o = gt(t.events, n[1]);
  if (i = {
    type: a,
    start: Object.assign({}, o),
    // Note: correct end is set later.
    end: Object.assign({}, o)
  }, e.add(n[1], 0, [["enter", i, t]]), n[2] !== 0) {
    const c = gt(t.events, n[2]), f = gt(t.events, n[3]), h = {
      type: l,
      start: Object.assign({}, c),
      end: Object.assign({}, f)
    };
    if (e.add(n[2], 0, [["enter", h, t]]), r !== 2) {
      const E = t.events[n[2]], m = t.events[n[3]];
      if (E[1].end = Object.assign({}, m[1].end), E[1].type = "chunkText", E[1].contentType = "text", n[3] > n[2] + 1) {
        const A = n[2] + 1, C = n[3] - n[2] - 1;
        e.add(A, C, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", h, t]]);
  }
  return u !== void 0 && (i.end = Object.assign({}, gt(t.events, u)), e.add(u, 0, [["exit", i, t]]), i = void 0), i;
}
function Bu(e, t, n, r, u) {
  const i = [], a = gt(t.events, n);
  u && (u.end = Object.assign({}, a), i.push(["exit", u, t])), r.end = Object.assign({}, a), i.push(["exit", r, t]), e.add(n + 1, 0, i);
}
function gt(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const vf = {
  name: "tasklistCheck",
  tokenize: Hf
};
function Uf() {
  return {
    text: {
      91: vf
    }
  };
}
function Hf(e, t, n) {
  const r = this;
  return u;
  function u(o) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(o) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(o), e.exit("taskListCheckMarker"), i)
    );
  }
  function i(o) {
    return re(o) ? (e.enter("taskListCheckValueUnchecked"), e.consume(o), e.exit("taskListCheckValueUnchecked"), a) : o === 88 || o === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(o), e.exit("taskListCheckValueChecked"), a) : n(o);
  }
  function a(o) {
    return o === 93 ? (e.enter("taskListCheckMarker"), e.consume(o), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), l) : n(o);
  }
  function l(o) {
    return v(o) ? t(o) : Z(o) ? e.check({
      tokenize: zf
    }, t, n)(o) : n(o);
  }
}
function zf(e, t, n) {
  return J(e, r, "whitespace");
  function r(u) {
    return u === null ? n(u) : t(u);
  }
}
function Yf(e) {
  return Si([
    df(),
    kf(),
    Df(e),
    Mf(),
    Uf()
  ]);
}
const qf = {};
function Vf(e) {
  const t = (
    /** @type {Processor} */
    this
  ), n = e || qf, r = t.data(), u = r.micromarkExtensions || (r.micromarkExtensions = []), i = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), a = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  u.push(Yf(n)), i.push(of()), a.push(cf(n));
}
function Wf() {
  return {
    enter: {
      mathFlow: e,
      mathFlowFenceMeta: t,
      mathText: i
    },
    exit: {
      mathFlow: u,
      mathFlowFence: r,
      mathFlowFenceMeta: n,
      mathFlowValue: l,
      mathText: a,
      mathTextData: l
    }
  };
  function e(o) {
    const c = {
      type: "element",
      tagName: "code",
      properties: { className: ["language-math", "math-display"] },
      children: []
    };
    this.enter(
      {
        type: "math",
        meta: null,
        value: "",
        data: { hName: "pre", hChildren: [c] }
      },
      o
    );
  }
  function t() {
    this.buffer();
  }
  function n() {
    const o = this.resume(), c = this.stack[this.stack.length - 1];
    c.type, c.meta = o;
  }
  function r() {
    this.data.mathFlowInside || (this.buffer(), this.data.mathFlowInside = !0);
  }
  function u(o) {
    const c = this.resume().replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), f = this.stack[this.stack.length - 1];
    f.type, this.exit(o), f.value = c;
    const h = (
      /** @type {HastElement} */
      f.data.hChildren[0]
    );
    h.type, h.tagName, h.children.push({ type: "text", value: c }), this.data.mathFlowInside = void 0;
  }
  function i(o) {
    this.enter(
      {
        type: "inlineMath",
        value: "",
        data: {
          hName: "code",
          hProperties: { className: ["language-math", "math-inline"] },
          hChildren: []
        }
      },
      o
    ), this.buffer();
  }
  function a(o) {
    const c = this.resume(), f = this.stack[this.stack.length - 1];
    f.type, this.exit(o), f.value = c, /** @type {Array<HastElementContent>} */
    // @ts-expect-error: we defined it in `enterMathFlow`.
    f.data.hChildren.push({ type: "text", value: c });
  }
  function l(o) {
    this.config.enter.data.call(this, o), this.config.exit.data.call(this, o);
  }
}
function jf(e) {
  let t = (e || {}).singleDollarTextMath;
  return t == null && (t = !0), r.peek = u, {
    unsafe: [
      { character: "\r", inConstruct: "mathFlowMeta" },
      { character: `
`, inConstruct: "mathFlowMeta" },
      {
        character: "$",
        after: t ? void 0 : "\\$",
        inConstruct: "phrasing"
      },
      { character: "$", inConstruct: "mathFlowMeta" },
      { atBreak: !0, character: "$", after: "\\$" }
    ],
    handlers: { math: n, inlineMath: r }
  };
  function n(i, a, l, o) {
    const c = i.value || "", f = l.createTracker(o), h = "$".repeat(Math.max(Xi(c, "$") + 1, 2)), E = l.enter("mathFlow");
    let m = f.move(h);
    if (i.meta) {
      const A = l.enter("mathFlowMeta");
      m += f.move(
        l.safe(i.meta, {
          after: `
`,
          before: m,
          encode: ["$"],
          ...f.current()
        })
      ), A();
    }
    return m += f.move(`
`), c && (m += f.move(c + `
`)), m += f.move(h), E(), m;
  }
  function r(i, a, l) {
    let o = i.value || "", c = 1;
    for (t || c++; new RegExp("(^|[^$])" + "\\$".repeat(c) + "([^$]|$)").test(o); )
      c++;
    const f = "$".repeat(c);
    // Contains non-space.
    /[^ \r\n]/.test(o) && // Starts with space and ends with space.
    (/^[ \r\n]/.test(o) && /[ \r\n]$/.test(o) || // Starts or ends with dollar.
    /^\$|\$$/.test(o)) && (o = " " + o + " ");
    let h = -1;
    for (; ++h < l.unsafe.length; ) {
      const E = l.unsafe[h];
      if (!E.atBreak) continue;
      const m = l.compilePattern(E);
      let A;
      for (; A = m.exec(o); ) {
        let C = A.index;
        o.codePointAt(C) === 10 && o.codePointAt(C - 1) === 13 && C--, o = o.slice(0, C) + " " + o.slice(A.index + 1);
      }
    }
    return f + o + f;
  }
  function u() {
    return "$";
  }
}
const Qf = {
  tokenize: $f,
  concrete: !0,
  name: "mathFlow"
}, Fu = {
  tokenize: Xf,
  partial: !0
};
function $f(e, t, n) {
  const r = this, u = r.events[r.events.length - 1], i = u && u[1].type === "linePrefix" ? u[2].sliceSerialize(u[1], !0).length : 0;
  let a = 0;
  return l;
  function l(k) {
    return e.enter("mathFlow"), e.enter("mathFlowFence"), e.enter("mathFlowFenceSequence"), o(k);
  }
  function o(k) {
    return k === 36 ? (e.consume(k), a++, o) : a < 2 ? n(k) : (e.exit("mathFlowFenceSequence"), J(e, c, "whitespace")(k));
  }
  function c(k) {
    return k === null || v(k) ? h(k) : (e.enter("mathFlowFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), f(k));
  }
  function f(k) {
    return k === null || v(k) ? (e.exit("chunkString"), e.exit("mathFlowFenceMeta"), h(k)) : k === 36 ? n(k) : (e.consume(k), f);
  }
  function h(k) {
    return e.exit("mathFlowFence"), r.interrupt ? t(k) : e.attempt(Fu, E, O)(k);
  }
  function E(k) {
    return e.attempt({
      tokenize: I,
      partial: !0
    }, O, m)(k);
  }
  function m(k) {
    return (i ? J(e, A, "linePrefix", i + 1) : A)(k);
  }
  function A(k) {
    return k === null ? O(k) : v(k) ? e.attempt(Fu, E, O)(k) : (e.enter("mathFlowValue"), C(k));
  }
  function C(k) {
    return k === null || v(k) ? (e.exit("mathFlowValue"), A(k)) : (e.consume(k), C);
  }
  function O(k) {
    return e.exit("mathFlow"), t(k);
  }
  function I(k, R, Y) {
    let q = 0;
    return J(k, N, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function N(j) {
      return k.enter("mathFlowFence"), k.enter("mathFlowFenceSequence"), V(j);
    }
    function V(j) {
      return j === 36 ? (q++, k.consume(j), V) : q < a ? Y(j) : (k.exit("mathFlowFenceSequence"), J(k, te, "whitespace")(j));
    }
    function te(j) {
      return j === null || v(j) ? (k.exit("mathFlowFence"), R(j)) : Y(j);
    }
  }
}
function Xf(e, t, n) {
  const r = this;
  return u;
  function u(a) {
    return a === null ? t(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i);
  }
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
function Gf(e) {
  let n = (e || {}).singleDollarTextMath;
  return n == null && (n = !0), {
    tokenize: r,
    resolve: Kf,
    previous: Jf,
    name: "mathText"
  };
  function r(u, i, a) {
    let l = 0, o, c;
    return f;
    function f(C) {
      return u.enter("mathText"), u.enter("mathTextSequence"), h(C);
    }
    function h(C) {
      return C === 36 ? (u.consume(C), l++, h) : l < 2 && !n ? a(C) : (u.exit("mathTextSequence"), E(C));
    }
    function E(C) {
      return C === null ? a(C) : C === 36 ? (c = u.enter("mathTextSequence"), o = 0, A(C)) : C === 32 ? (u.enter("space"), u.consume(C), u.exit("space"), E) : v(C) ? (u.enter("lineEnding"), u.consume(C), u.exit("lineEnding"), E) : (u.enter("mathTextData"), m(C));
    }
    function m(C) {
      return C === null || C === 32 || C === 36 || v(C) ? (u.exit("mathTextData"), E(C)) : (u.consume(C), m);
    }
    function A(C) {
      return C === 36 ? (u.consume(C), o++, A) : o === l ? (u.exit("mathTextSequence"), u.exit("mathText"), i(C)) : (c.type = "mathTextData", m(C));
    }
  }
}
function Kf(e) {
  let t = e.length - 4, n = 3, r, u;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "mathTextData") {
        e[t][1].type = "mathTextPadding", e[n][1].type = "mathTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    u === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (u = r) : (r === t || e[r][1].type === "lineEnding") && (e[u][1].type = "mathTextData", r !== u + 2 && (e[u][1].end = e[r - 1][1].end, e.splice(u + 2, r - u - 2), t -= r - u - 2, r = u + 2), u = void 0);
  return e;
}
function Jf(e) {
  return e !== 36 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Zf(e) {
  return {
    flow: {
      36: Qf
    },
    text: {
      36: Gf(e)
    }
  };
}
const ed = {};
function td(e) {
  const t = (
    /** @type {Processor} */
    this
  ), n = e || ed, r = t.data(), u = r.micromarkExtensions || (r.micromarkExtensions = []), i = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), a = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  u.push(Zf(n)), i.push(Wf()), a.push(jf(n));
}
let Zt = class {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
};
Zt.prototype.normal = {};
Zt.prototype.property = {};
Zt.prototype.space = void 0;
function pa(e, t) {
  const n = {}, r = {};
  for (const u of e)
    Object.assign(n, u.property), Object.assign(r, u.normal);
  return new Zt(n, r, t);
}
function Qt(e) {
  return e.toLowerCase();
}
let Se = class {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
};
Se.prototype.attribute = "";
Se.prototype.booleanish = !1;
Se.prototype.boolean = !1;
Se.prototype.commaOrSpaceSeparated = !1;
Se.prototype.commaSeparated = !1;
Se.prototype.defined = !1;
Se.prototype.mustUseProperty = !1;
Se.prototype.number = !1;
Se.prototype.overloadedBoolean = !1;
Se.prototype.property = "";
Se.prototype.spaceSeparated = !1;
Se.prototype.space = void 0;
let nd = 0;
const X = ot(), he = ot(), lr = ot(), w = ot(), ie = ot(), At = ot(), Ne = ot();
function ot() {
  return 2 ** ++nd;
}
const or = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: X,
  booleanish: he,
  commaOrSpaceSeparated: Ne,
  commaSeparated: At,
  number: w,
  overloadedBoolean: lr,
  spaceSeparated: ie
}, Symbol.toStringTag, { value: "Module" })), $n = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(or)
);
let Pr = class extends Se {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, u) {
    let i = -1;
    if (super(t, n), vu(this, "space", u), typeof r == "number")
      for (; ++i < $n.length; ) {
        const a = $n[i];
        vu(this, $n[i], (r & or[a]) === or[a]);
      }
  }
};
Pr.prototype.defined = !0;
function vu(e, t, n) {
  n && (e[t] = n);
}
function It(e) {
  const t = {}, n = {};
  for (const [r, u] of Object.entries(e.properties)) {
    const i = new Pr(
      r,
      e.transform(e.attributes || {}, r),
      u,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[Qt(r)] = r, n[Qt(i.attribute)] = r;
  }
  return new Zt(t, n, e.space);
}
const Ea = It({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: he,
    ariaAutoComplete: null,
    ariaBusy: he,
    ariaChecked: he,
    ariaColCount: w,
    ariaColIndex: w,
    ariaColSpan: w,
    ariaControls: ie,
    ariaCurrent: null,
    ariaDescribedBy: ie,
    ariaDetails: null,
    ariaDisabled: he,
    ariaDropEffect: ie,
    ariaErrorMessage: null,
    ariaExpanded: he,
    ariaFlowTo: ie,
    ariaGrabbed: he,
    ariaHasPopup: null,
    ariaHidden: he,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ie,
    ariaLevel: w,
    ariaLive: null,
    ariaModal: he,
    ariaMultiLine: he,
    ariaMultiSelectable: he,
    ariaOrientation: null,
    ariaOwns: ie,
    ariaPlaceholder: null,
    ariaPosInSet: w,
    ariaPressed: he,
    ariaReadOnly: he,
    ariaRelevant: null,
    ariaRequired: he,
    ariaRoleDescription: ie,
    ariaRowCount: w,
    ariaRowIndex: w,
    ariaRowSpan: w,
    ariaSelected: he,
    ariaSetSize: w,
    ariaSort: null,
    ariaValueMax: w,
    ariaValueMin: w,
    ariaValueNow: w,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function ga(e, t) {
  return t in e ? e[t] : t;
}
function Ta(e, t) {
  return ga(e, t.toLowerCase());
}
const rd = It({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: At,
    acceptCharset: ie,
    accessKey: ie,
    action: null,
    allow: null,
    allowFullScreen: X,
    allowPaymentRequest: X,
    allowUserMedia: X,
    alt: null,
    as: null,
    async: X,
    autoCapitalize: null,
    autoComplete: ie,
    autoFocus: X,
    autoPlay: X,
    blocking: ie,
    capture: null,
    charSet: null,
    checked: X,
    cite: null,
    className: ie,
    cols: w,
    colSpan: null,
    content: null,
    contentEditable: he,
    controls: X,
    controlsList: ie,
    coords: w | At,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: X,
    defer: X,
    dir: null,
    dirName: null,
    disabled: X,
    download: lr,
    draggable: he,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: X,
    formTarget: null,
    headers: ie,
    height: w,
    hidden: lr,
    high: w,
    href: null,
    hrefLang: null,
    htmlFor: ie,
    httpEquiv: ie,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: X,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: X,
    itemId: null,
    itemProp: ie,
    itemRef: ie,
    itemScope: X,
    itemType: ie,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: X,
    low: w,
    manifest: null,
    max: null,
    maxLength: w,
    media: null,
    method: null,
    min: null,
    minLength: w,
    multiple: X,
    muted: X,
    name: null,
    nonce: null,
    noModule: X,
    noValidate: X,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: X,
    optimum: w,
    pattern: null,
    ping: ie,
    placeholder: null,
    playsInline: X,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: X,
    referrerPolicy: null,
    rel: ie,
    required: X,
    reversed: X,
    rows: w,
    rowSpan: w,
    sandbox: ie,
    scope: null,
    scoped: X,
    seamless: X,
    selected: X,
    shadowRootClonable: X,
    shadowRootDelegatesFocus: X,
    shadowRootMode: null,
    shape: null,
    size: w,
    sizes: null,
    slot: null,
    span: w,
    spellCheck: he,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: w,
    step: null,
    style: null,
    tabIndex: w,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: X,
    useMap: null,
    value: he,
    width: w,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ie,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: w,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: w,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: X,
    // Lists. Use CSS to reduce space between items instead
    declare: X,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: w,
    // `<img>` and `<object>`
    leftMargin: w,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: w,
    // `<body>`
    marginWidth: w,
    // `<body>`
    noResize: X,
    // `<frame>`
    noHref: X,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: X,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: X,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: w,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: he,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: w,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: w,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: X,
    disableRemotePlayback: X,
    prefix: null,
    property: null,
    results: w,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Ta
}), ud = It({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Ne,
    accentHeight: w,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: w,
    amplitude: w,
    arabicForm: null,
    ascent: w,
    attributeName: null,
    attributeType: null,
    azimuth: w,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: w,
    by: null,
    calcMode: null,
    capHeight: w,
    className: ie,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: w,
    diffuseConstant: w,
    direction: null,
    display: null,
    dur: null,
    divisor: w,
    dominantBaseline: null,
    download: X,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: w,
    enableBackground: null,
    end: null,
    event: null,
    exponent: w,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: w,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: At,
    g2: At,
    glyphName: At,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: w,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: w,
    horizOriginX: w,
    horizOriginY: w,
    id: null,
    ideographic: w,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: w,
    k: w,
    k1: w,
    k2: w,
    k3: w,
    k4: w,
    kernelMatrix: Ne,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: w,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: w,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: w,
    overlineThickness: w,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: w,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ie,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: w,
    pointsAtY: w,
    pointsAtZ: w,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Ne,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Ne,
    rev: Ne,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Ne,
    requiredFeatures: Ne,
    requiredFonts: Ne,
    requiredFormats: Ne,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: w,
    specularExponent: w,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: w,
    strikethroughThickness: w,
    string: null,
    stroke: null,
    strokeDashArray: Ne,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: w,
    strokeOpacity: w,
    strokeWidth: null,
    style: null,
    surfaceScale: w,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Ne,
    tabIndex: w,
    tableValues: null,
    target: null,
    targetX: w,
    targetY: w,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Ne,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: w,
    underlineThickness: w,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: w,
    values: null,
    vAlphabetic: w,
    vMathematical: w,
    vectorEffect: null,
    vHanging: w,
    vIdeographic: w,
    version: null,
    vertAdvY: w,
    vertOriginX: w,
    vertOriginY: w,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: w,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: ga
}), ba = It({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), Aa = It({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Ta
}), _a = It({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), id = /[A-Z]/g, Uu = /-[a-z]/g, ad = /^data[-\w.:]+$/i;
function sd(e, t) {
  const n = Qt(t);
  let r = t, u = Se;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && ad.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(Uu, od);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!Uu.test(i)) {
        let a = i.replace(id, ld);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    u = Pr;
  }
  return new u(r, t);
}
function ld(e) {
  return "-" + e.toLowerCase();
}
function od(e) {
  return e.charAt(1).toUpperCase();
}
const cd = pa([Ea, rd, ba, Aa, _a], "html"), hd = pa([Ea, ud, ba, Aa, _a], "svg"), Hu = /[#.]/g;
function fd(e, t) {
  const n = e || "", r = {};
  let u = 0, i, a;
  for (; u < n.length; ) {
    Hu.lastIndex = u;
    const l = Hu.exec(n), o = n.slice(u, l ? l.index : n.length);
    o && (i ? i === "#" ? r.id = o : Array.isArray(r.className) ? r.className.push(o) : r.className = [o] : a = o, u += o.length), l && (i = l[0], u++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: a || t || "div",
    properties: r,
    children: []
  };
}
function Ca(e, t, n) {
  const r = n ? Ed(n) : void 0;
  function u(i, a, ...l) {
    let o;
    if (i == null) {
      o = { type: "root", children: [] };
      const c = (
        /** @type {Child} */
        a
      );
      l.unshift(c);
    } else {
      o = fd(i, t);
      const c = o.tagName.toLowerCase(), f = r ? r.get(c) : void 0;
      if (o.tagName = f || c, dd(a))
        l.unshift(a);
      else
        for (const [h, E] of Object.entries(a))
          md(e, o.properties, h, E);
    }
    for (const c of l)
      cr(o.children, c);
    return o.type === "element" && o.tagName === "template" && (o.content = { type: "root", children: o.children }, o.children = []), o;
  }
  return u;
}
function dd(e) {
  if (e === null || typeof e != "object" || Array.isArray(e))
    return !0;
  if (typeof e.type != "string") return !1;
  const t = (
    /** @type {Record<string, unknown>} */
    e
  ), n = Object.keys(e);
  for (const r of n) {
    const u = t[r];
    if (u && typeof u == "object") {
      if (!Array.isArray(u)) return !0;
      const i = (
        /** @type {ReadonlyArray<unknown>} */
        u
      );
      for (const a of i)
        if (typeof a != "number" && typeof a != "string")
          return !0;
    }
  }
  return !!("children" in e && Array.isArray(e.children));
}
function md(e, t, n, r) {
  const u = sd(e, n);
  let i;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r)) return;
      i = r;
    } else typeof r == "boolean" ? i = r : typeof r == "string" ? u.spaceSeparated ? i = Kr(r) : u.commaSeparated ? i = jr(r) : u.commaOrSpaceSeparated ? i = Kr(jr(r).join(" ")) : i = zu(u, u.property, r) : Array.isArray(r) ? i = [...r] : i = u.property === "style" ? pd(r) : String(r);
    if (Array.isArray(i)) {
      const a = [];
      for (const l of i)
        a.push(
          /** @type {number | string} */
          zu(u, u.property, l)
        );
      i = a;
    }
    u.property === "className" && Array.isArray(t.className) && (i = t.className.concat(
      /** @type {Array<number | string> | number | string} */
      i
    )), t[u.property] = i;
  }
}
function cr(e, t) {
  if (t != null) if (typeof t == "number" || typeof t == "string")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (const n of t)
      cr(e, n);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? cr(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function zu(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || Qt(n) === Qt(t)))
      return !0;
  }
  return n;
}
function pd(e) {
  const t = [];
  for (const [n, r] of Object.entries(e))
    t.push([n, r].join(": "));
  return t.join("; ");
}
function Ed(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e)
    t.set(n.toLowerCase(), n);
  return t;
}
const gd = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], Td = Ca(cd, "div"), bd = Ca(hd, "g", gd);
class en {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
en.prototype.normal = {};
en.prototype.property = {};
en.prototype.space = void 0;
function ka(e, t) {
  const n = {}, r = {};
  for (const u of e)
    Object.assign(n, u.property), Object.assign(r, u.normal);
  return new en(n, r, t);
}
function hr(e) {
  return e.toLowerCase();
}
class ye {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
ye.prototype.attribute = "";
ye.prototype.booleanish = !1;
ye.prototype.boolean = !1;
ye.prototype.commaOrSpaceSeparated = !1;
ye.prototype.commaSeparated = !1;
ye.prototype.defined = !1;
ye.prototype.mustUseProperty = !1;
ye.prototype.number = !1;
ye.prototype.overloadedBoolean = !1;
ye.prototype.property = "";
ye.prototype.spaceSeparated = !1;
ye.prototype.space = void 0;
let Ad = 0;
const G = ct(), fe = ct(), fr = ct(), M = ct(), ae = ct(), _t = ct(), Oe = ct();
function ct() {
  return 2 ** ++Ad;
}
const dr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: G,
  booleanish: fe,
  commaOrSpaceSeparated: Oe,
  commaSeparated: _t,
  number: M,
  overloadedBoolean: fr,
  spaceSeparated: ae
}, Symbol.toStringTag, { value: "Module" })), Xn = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(dr)
);
class wr extends ye {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, u) {
    let i = -1;
    if (super(t, n), Yu(this, "space", u), typeof r == "number")
      for (; ++i < Xn.length; ) {
        const a = Xn[i];
        Yu(this, Xn[i], (r & dr[a]) === dr[a]);
      }
  }
}
wr.prototype.defined = !0;
function Yu(e, t, n) {
  n && (e[t] = n);
}
function xt(e) {
  const t = {}, n = {};
  for (const [r, u] of Object.entries(e.properties)) {
    const i = new wr(
      r,
      e.transform(e.attributes || {}, r),
      u,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[hr(r)] = r, n[hr(i.attribute)] = r;
  }
  return new en(t, n, e.space);
}
const Sa = xt({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: fe,
    ariaAutoComplete: null,
    ariaBusy: fe,
    ariaChecked: fe,
    ariaColCount: M,
    ariaColIndex: M,
    ariaColSpan: M,
    ariaControls: ae,
    ariaCurrent: null,
    ariaDescribedBy: ae,
    ariaDetails: null,
    ariaDisabled: fe,
    ariaDropEffect: ae,
    ariaErrorMessage: null,
    ariaExpanded: fe,
    ariaFlowTo: ae,
    ariaGrabbed: fe,
    ariaHasPopup: null,
    ariaHidden: fe,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ae,
    ariaLevel: M,
    ariaLive: null,
    ariaModal: fe,
    ariaMultiLine: fe,
    ariaMultiSelectable: fe,
    ariaOrientation: null,
    ariaOwns: ae,
    ariaPlaceholder: null,
    ariaPosInSet: M,
    ariaPressed: fe,
    ariaReadOnly: fe,
    ariaRelevant: null,
    ariaRequired: fe,
    ariaRoleDescription: ae,
    ariaRowCount: M,
    ariaRowIndex: M,
    ariaRowSpan: M,
    ariaSelected: fe,
    ariaSetSize: M,
    ariaSort: null,
    ariaValueMax: M,
    ariaValueMin: M,
    ariaValueNow: M,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function ya(e, t) {
  return t in e ? e[t] : t;
}
function Ia(e, t) {
  return ya(e, t.toLowerCase());
}
const _d = xt({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: _t,
    acceptCharset: ae,
    accessKey: ae,
    action: null,
    allow: null,
    allowFullScreen: G,
    allowPaymentRequest: G,
    allowUserMedia: G,
    alt: null,
    as: null,
    async: G,
    autoCapitalize: null,
    autoComplete: ae,
    autoFocus: G,
    autoPlay: G,
    blocking: ae,
    capture: null,
    charSet: null,
    checked: G,
    cite: null,
    className: ae,
    cols: M,
    colSpan: null,
    content: null,
    contentEditable: fe,
    controls: G,
    controlsList: ae,
    coords: M | _t,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: G,
    defer: G,
    dir: null,
    dirName: null,
    disabled: G,
    download: fr,
    draggable: fe,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: G,
    formTarget: null,
    headers: ae,
    height: M,
    hidden: fr,
    high: M,
    href: null,
    hrefLang: null,
    htmlFor: ae,
    httpEquiv: ae,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: G,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: G,
    itemId: null,
    itemProp: ae,
    itemRef: ae,
    itemScope: G,
    itemType: ae,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: G,
    low: M,
    manifest: null,
    max: null,
    maxLength: M,
    media: null,
    method: null,
    min: null,
    minLength: M,
    multiple: G,
    muted: G,
    name: null,
    nonce: null,
    noModule: G,
    noValidate: G,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: G,
    optimum: M,
    pattern: null,
    ping: ae,
    placeholder: null,
    playsInline: G,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: G,
    referrerPolicy: null,
    rel: ae,
    required: G,
    reversed: G,
    rows: M,
    rowSpan: M,
    sandbox: ae,
    scope: null,
    scoped: G,
    seamless: G,
    selected: G,
    shadowRootClonable: G,
    shadowRootDelegatesFocus: G,
    shadowRootMode: null,
    shape: null,
    size: M,
    sizes: null,
    slot: null,
    span: M,
    spellCheck: fe,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: M,
    step: null,
    style: null,
    tabIndex: M,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: G,
    useMap: null,
    value: fe,
    width: M,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ae,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: M,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: M,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: G,
    // Lists. Use CSS to reduce space between items instead
    declare: G,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: M,
    // `<img>` and `<object>`
    leftMargin: M,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: M,
    // `<body>`
    marginWidth: M,
    // `<body>`
    noResize: G,
    // `<frame>`
    noHref: G,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: G,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: G,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: M,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: fe,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: M,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: M,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: G,
    disableRemotePlayback: G,
    prefix: null,
    property: null,
    results: M,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Ia
}), Cd = xt({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Oe,
    accentHeight: M,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: M,
    amplitude: M,
    arabicForm: null,
    ascent: M,
    attributeName: null,
    attributeType: null,
    azimuth: M,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: M,
    by: null,
    calcMode: null,
    capHeight: M,
    className: ae,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: M,
    diffuseConstant: M,
    direction: null,
    display: null,
    dur: null,
    divisor: M,
    dominantBaseline: null,
    download: G,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: M,
    enableBackground: null,
    end: null,
    event: null,
    exponent: M,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: M,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: _t,
    g2: _t,
    glyphName: _t,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: M,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: M,
    horizOriginX: M,
    horizOriginY: M,
    id: null,
    ideographic: M,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: M,
    k: M,
    k1: M,
    k2: M,
    k3: M,
    k4: M,
    kernelMatrix: Oe,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: M,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: M,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: M,
    overlineThickness: M,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: M,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ae,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: M,
    pointsAtY: M,
    pointsAtZ: M,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Oe,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Oe,
    rev: Oe,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Oe,
    requiredFeatures: Oe,
    requiredFonts: Oe,
    requiredFormats: Oe,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: M,
    specularExponent: M,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: M,
    strikethroughThickness: M,
    string: null,
    stroke: null,
    strokeDashArray: Oe,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: M,
    strokeOpacity: M,
    strokeWidth: null,
    style: null,
    surfaceScale: M,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Oe,
    tabIndex: M,
    tableValues: null,
    target: null,
    targetX: M,
    targetY: M,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Oe,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: M,
    underlineThickness: M,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: M,
    values: null,
    vAlphabetic: M,
    vMathematical: M,
    vectorEffect: null,
    vHanging: M,
    vIdeographic: M,
    version: null,
    vertAdvY: M,
    vertOriginX: M,
    vertOriginY: M,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: M,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: ya
}), xa = xt({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), Na = xt({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Ia
}), Oa = xt({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), kd = /[A-Z]/g, qu = /-[a-z]/g, Sd = /^data[-\w.:]+$/i;
function yd(e, t) {
  const n = hr(t);
  let r = t, u = ye;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && Sd.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(qu, xd);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!qu.test(i)) {
        let a = i.replace(kd, Id);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    u = wr;
  }
  return new u(r, t);
}
function Id(e) {
  return "-" + e.toLowerCase();
}
function xd(e) {
  return e.charAt(1).toUpperCase();
}
const La = ka([Sa, _d, xa, Na, Oa], "html"), Da = ka([Sa, Cd, xa, Na, Oa], "svg");
function Nd(e) {
  const t = String(e), n = [];
  return { toOffset: u, toPoint: r };
  function r(i) {
    if (typeof i == "number" && i > -1 && i <= t.length) {
      let a = 0;
      for (; ; ) {
        let l = n[a];
        if (l === void 0) {
          const o = Vu(t, n[a - 1]);
          l = o === -1 ? t.length + 1 : o + 1, n[a] = l;
        }
        if (l > i)
          return {
            line: a + 1,
            column: i - (a > 0 ? n[a - 1] : 0) + 1,
            offset: i
          };
        a++;
      }
    }
  }
  function u(i) {
    if (i && typeof i.line == "number" && typeof i.column == "number" && !Number.isNaN(i.line) && !Number.isNaN(i.column)) {
      for (; n.length < i.line; ) {
        const l = n[n.length - 1], o = Vu(t, l), c = o === -1 ? t.length + 1 : o + 1;
        if (l === c) break;
        n.push(c);
      }
      const a = (i.line > 1 ? n[i.line - 2] : 0) + i.column - 1;
      if (a < n[i.line - 1]) return a;
    }
  }
}
function Vu(e, t) {
  const n = e.indexOf("\r", t), r = e.indexOf(`
`, t);
  return r === -1 ? n : n === -1 || n + 1 === r ? r : n < r ? n : r;
}
const it = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, Ra = {}.hasOwnProperty, Od = Object.prototype;
function Ld(e, t) {
  const n = t || {};
  return Mr(
    {
      file: n.file || void 0,
      location: !1,
      schema: n.space === "svg" ? Da : La,
      verbose: n.verbose || !1
    },
    e
  );
}
function Mr(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const r = (
        /** @type {DefaultTreeAdapterMap['commentNode']} */
        t
      );
      return n = { type: "comment", value: r.data }, hn(e, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = (
        /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */
        t
      ), u = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: Pa(e, t.childNodes),
        data: { quirksMode: u }
      }, e.file && e.location) {
        const i = String(e.file), a = Nd(i), l = a.toPoint(0), o = a.toPoint(i.length);
        n.position = { start: l, end: o };
      }
      return n;
    }
    case "#documentType": {
      const r = (
        /** @type {DefaultTreeAdapterMap['documentType']} */
        t
      );
      return n = { type: "doctype" }, hn(e, r, n), n;
    }
    case "#text": {
      const r = (
        /** @type {DefaultTreeAdapterMap['textNode']} */
        t
      );
      return n = { type: "text", value: r.value }, hn(e, r, n), n;
    }
    // Element.
    default:
      return n = Dd(
        e,
        /** @type {DefaultTreeAdapterMap['element']} */
        t
      ), n;
  }
}
function Pa(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; ) {
    const u = (
      /** @type {RootContent} */
      Mr(e, t[n])
    );
    r.push(u);
  }
  return r;
}
function Dd(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === it.svg ? Da : La;
  let r = -1;
  const u = {};
  for (; ++r < t.attrs.length; ) {
    const l = t.attrs[r], o = (l.prefix ? l.prefix + ":" : "") + l.name;
    Ra.call(Od, o) || (u[o] = l.value);
  }
  const a = (e.schema.space === "svg" ? bd : Td)(t.tagName, u, Pa(e, t.childNodes));
  if (hn(e, t, a), a.tagName === "template") {
    const l = (
      /** @type {DefaultTreeAdapterMap['template']} */
      t
    ), o = l.sourceCodeLocation, c = o && o.startTag && Tt(o.startTag), f = o && o.endTag && Tt(o.endTag), h = (
      /** @type {Root} */
      Mr(e, l.content)
    );
    c && f && e.file && (h.position = { start: c.end, end: f.start }), a.content = h;
  }
  return e.schema = n, a;
}
function hn(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = Rd(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function Rd(e, t, n) {
  const r = Tt(n);
  if (t.type === "element") {
    const u = t.children[t.children.length - 1];
    if (r && !n.endTag && u && u.position && u.position.end && (r.end = Object.assign({}, u.position.end)), e.verbose) {
      const i = {};
      let a;
      if (n.attrs)
        for (a in n.attrs)
          Ra.call(n.attrs, a) && (i[yd(e.schema, a).property] = Tt(
            n.attrs[a]
          ));
      n.startTag;
      const l = Tt(n.startTag), o = n.endTag ? Tt(n.endTag) : void 0, c = { opening: l };
      o && (c.closing = o), c.properties = i, t.data = { position: c };
    }
  }
  return r;
}
function Tt(e) {
  const t = Wu({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = Wu({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function Wu(e) {
  return e.line && e.column ? e : void 0;
}
const Pd = {}, wd = {}.hasOwnProperty, wa = $i("type", { handlers: { root: Bd, element: zd, text: Ud, comment: Hd, doctype: vd } });
function Md(e, t) {
  const r = (t || Pd).space;
  return wa(e, r === "svg" ? Gt : Ei);
}
function Bd(e, t) {
  const n = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return n.childNodes = Br(e.children, n, t), Nt(e, n), n;
}
function Fd(e, t) {
  const n = { nodeName: "#document-fragment", childNodes: [] };
  return n.childNodes = Br(e.children, n, t), Nt(e, n), n;
}
function vd(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return Nt(e, t), t;
}
function Ud(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    parentNode: null
  };
  return Nt(e, t), t;
}
function Hd(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    parentNode: null
  };
  return Nt(e, t), t;
}
function zd(e, t) {
  const n = t;
  let r = n;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && n.space === "html" && (r = Gt);
  const u = [];
  let i;
  if (e.properties) {
    for (i in e.properties)
      if (i !== "children" && wd.call(e.properties, i)) {
        const o = Yd(
          r,
          i,
          e.properties[i]
        );
        o && u.push(o);
      }
  }
  const a = r.space, l = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: u,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: it[a],
    childNodes: [],
    parentNode: null
  };
  return l.childNodes = Br(e.children, l, r), Nt(e, l), e.tagName === "template" && e.content && (l.content = Fd(e.content, r)), l;
}
function Yd(e, t, n) {
  const r = pi(e, t);
  if (n === !1 || n === null || n === void 0 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean)
    return;
  Array.isArray(n) && (n = r.commaSeparated ? ai(n) : gi(n));
  const u = {
    name: r.attribute,
    value: n === !0 ? "" : String(n)
  };
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const i = u.name.indexOf(":");
    i < 0 ? u.prefix = "" : (u.name = u.name.slice(i + 1), u.prefix = r.attribute.slice(0, i)), u.namespace = it[r.space];
  }
  return u;
}
function Br(e, t, n) {
  let r = -1;
  const u = [];
  if (e)
    for (; ++r < e.length; ) {
      const i = wa(e[r], n);
      i.parentNode = t, u.push(i);
    }
  return u;
}
function Nt(e, t) {
  const n = e.position;
  n && n.start && n.end && (n.start.offset, n.end.offset, t.sourceCodeLocation = {
    startLine: n.start.line,
    startCol: n.start.column,
    startOffset: n.start.offset,
    endLine: n.end.line,
    endCol: n.end.column,
    endOffset: n.end.offset
  });
}
const qd = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], Vd = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), se = "�";
var d;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(d || (d = {}));
const Ce = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function Ma(e) {
  return e >= 55296 && e <= 57343;
}
function Wd(e) {
  return e >= 56320 && e <= 57343;
}
function jd(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function Ba(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function Fa(e) {
  return e >= 64976 && e <= 65007 || Vd.has(e);
}
var S;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(S || (S = {}));
const Qd = 65536;
class $d {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = Qd, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, n) {
    const { line: r, col: u, offset: i } = this, a = u + n, l = i + n;
    return {
      code: t,
      startLine: r,
      endLine: r,
      startCol: a,
      endCol: a,
      startOffset: l,
      endOffset: l
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (Wd(n))
        return this.pos++, this._addGap(), jd(t, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, d.EOF;
    return this._err(S.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, n) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, n) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (n)
      return this.html.startsWith(t, this.pos);
    for (let r = 0; r < t.length; r++)
      if ((this.html.charCodeAt(this.pos + r) | 32) !== t.charCodeAt(r))
        return !1;
    return !0;
  }
  peek(t) {
    const n = this.pos + t;
    if (n >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, d.EOF;
    const r = this.html.charCodeAt(n);
    return r === d.CARRIAGE_RETURN ? d.LINE_FEED : r;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, d.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === d.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, d.LINE_FEED) : t === d.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, Ma(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === d.LINE_FEED || t === d.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    Ba(t) ? this._err(S.controlCharacterInInputStream) : Fa(t) && this._err(S.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var K;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(K || (K = {}));
function va(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
}
const Xd = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), Gd = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function Kd(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = Gd.get(e)) !== null && t !== void 0 ? t : e;
}
var pe;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(pe || (pe = {}));
const Jd = 32;
var et;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(et || (et = {}));
function mr(e) {
  return e >= pe.ZERO && e <= pe.NINE;
}
function Zd(e) {
  return e >= pe.UPPER_A && e <= pe.UPPER_F || e >= pe.LOWER_A && e <= pe.LOWER_F;
}
function em(e) {
  return e >= pe.UPPER_A && e <= pe.UPPER_Z || e >= pe.LOWER_A && e <= pe.LOWER_Z || mr(e);
}
function tm(e) {
  return e === pe.EQUALS || em(e);
}
var me;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(me || (me = {}));
var $e;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})($e || ($e = {}));
class nm {
  constructor(t, n, r) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = r, this.state = me.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = $e.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = me.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, n) {
    switch (this.state) {
      case me.EntityStart:
        return t.charCodeAt(n) === pe.NUM ? (this.state = me.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = me.NamedEntity, this.stateNamedEntity(t, n));
      case me.NumericStart:
        return this.stateNumericStart(t, n);
      case me.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case me.NumericHex:
        return this.stateNumericHex(t, n);
      case me.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | Jd) === pe.LOWER_X ? (this.state = me.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = me.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, r, u) {
    if (n !== r) {
      const i = r - n;
      this.result = this.result * Math.pow(u, i) + Number.parseInt(t.substr(n, i), u), this.consumed += i;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const u = t.charCodeAt(n);
      if (mr(u) || Zd(u))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 16), this.emitNumericEntity(u, 3);
    }
    return this.addToNumericResult(t, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const u = t.charCodeAt(n);
      if (mr(u))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 10), this.emitNumericEntity(u, 2);
    }
    return this.addToNumericResult(t, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === pe.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === $e.Strict)
      return 0;
    return this.emitCodePoint(Kd(this.result), this.consumed), this.errors && (t !== pe.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, n) {
    const { decodeTree: r } = this;
    let u = r[this.treeIndex], i = (u & et.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const a = t.charCodeAt(n);
      if (this.treeIndex = rm(r, u, this.treeIndex + Math.max(1, i), a), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === $e.Attribute && // We shouldn't have consumed any characters after the entity,
        (i === 0 || // And there should be no invalid characters.
        tm(a)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (u = r[this.treeIndex], i = (u & et.VALUE_LENGTH) >> 14, i !== 0) {
        if (a === pe.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== $e.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: n, decodeTree: r } = this, u = (r[n] & et.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, u, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, n, r) {
    const { decodeTree: u } = this;
    return this.emitCodePoint(n === 1 ? u[t] & ~et.VALUE_LENGTH : u[t + 1], r), n === 3 && this.emitCodePoint(u[t + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case me.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== $e.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case me.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case me.NumericHex:
        return this.emitNumericEntity(0, 3);
      case me.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case me.EntityStart:
        return 0;
    }
  }
}
function rm(e, t, n, r) {
  const u = (t & et.BRANCH_LENGTH) >> 7, i = t & et.JUMP_TABLE;
  if (u === 0)
    return i !== 0 && r === i ? n : -1;
  if (i) {
    const o = r - i;
    return o < 0 || o >= u ? -1 : e[n + o] - 1;
  }
  let a = n, l = a + u - 1;
  for (; a <= l; ) {
    const o = a + l >>> 1, c = e[o];
    if (c < r)
      a = o + 1;
    else if (c > r)
      l = o - 1;
    else
      return e[o + u];
  }
  return -1;
}
var L;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(L || (L = {}));
var at;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(at || (at = {}));
var De;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(De || (De = {}));
var _;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(_ || (_ = {}));
var s;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(s || (s = {}));
const um = /* @__PURE__ */ new Map([
  [_.A, s.A],
  [_.ADDRESS, s.ADDRESS],
  [_.ANNOTATION_XML, s.ANNOTATION_XML],
  [_.APPLET, s.APPLET],
  [_.AREA, s.AREA],
  [_.ARTICLE, s.ARTICLE],
  [_.ASIDE, s.ASIDE],
  [_.B, s.B],
  [_.BASE, s.BASE],
  [_.BASEFONT, s.BASEFONT],
  [_.BGSOUND, s.BGSOUND],
  [_.BIG, s.BIG],
  [_.BLOCKQUOTE, s.BLOCKQUOTE],
  [_.BODY, s.BODY],
  [_.BR, s.BR],
  [_.BUTTON, s.BUTTON],
  [_.CAPTION, s.CAPTION],
  [_.CENTER, s.CENTER],
  [_.CODE, s.CODE],
  [_.COL, s.COL],
  [_.COLGROUP, s.COLGROUP],
  [_.DD, s.DD],
  [_.DESC, s.DESC],
  [_.DETAILS, s.DETAILS],
  [_.DIALOG, s.DIALOG],
  [_.DIR, s.DIR],
  [_.DIV, s.DIV],
  [_.DL, s.DL],
  [_.DT, s.DT],
  [_.EM, s.EM],
  [_.EMBED, s.EMBED],
  [_.FIELDSET, s.FIELDSET],
  [_.FIGCAPTION, s.FIGCAPTION],
  [_.FIGURE, s.FIGURE],
  [_.FONT, s.FONT],
  [_.FOOTER, s.FOOTER],
  [_.FOREIGN_OBJECT, s.FOREIGN_OBJECT],
  [_.FORM, s.FORM],
  [_.FRAME, s.FRAME],
  [_.FRAMESET, s.FRAMESET],
  [_.H1, s.H1],
  [_.H2, s.H2],
  [_.H3, s.H3],
  [_.H4, s.H4],
  [_.H5, s.H5],
  [_.H6, s.H6],
  [_.HEAD, s.HEAD],
  [_.HEADER, s.HEADER],
  [_.HGROUP, s.HGROUP],
  [_.HR, s.HR],
  [_.HTML, s.HTML],
  [_.I, s.I],
  [_.IMG, s.IMG],
  [_.IMAGE, s.IMAGE],
  [_.INPUT, s.INPUT],
  [_.IFRAME, s.IFRAME],
  [_.KEYGEN, s.KEYGEN],
  [_.LABEL, s.LABEL],
  [_.LI, s.LI],
  [_.LINK, s.LINK],
  [_.LISTING, s.LISTING],
  [_.MAIN, s.MAIN],
  [_.MALIGNMARK, s.MALIGNMARK],
  [_.MARQUEE, s.MARQUEE],
  [_.MATH, s.MATH],
  [_.MENU, s.MENU],
  [_.META, s.META],
  [_.MGLYPH, s.MGLYPH],
  [_.MI, s.MI],
  [_.MO, s.MO],
  [_.MN, s.MN],
  [_.MS, s.MS],
  [_.MTEXT, s.MTEXT],
  [_.NAV, s.NAV],
  [_.NOBR, s.NOBR],
  [_.NOFRAMES, s.NOFRAMES],
  [_.NOEMBED, s.NOEMBED],
  [_.NOSCRIPT, s.NOSCRIPT],
  [_.OBJECT, s.OBJECT],
  [_.OL, s.OL],
  [_.OPTGROUP, s.OPTGROUP],
  [_.OPTION, s.OPTION],
  [_.P, s.P],
  [_.PARAM, s.PARAM],
  [_.PLAINTEXT, s.PLAINTEXT],
  [_.PRE, s.PRE],
  [_.RB, s.RB],
  [_.RP, s.RP],
  [_.RT, s.RT],
  [_.RTC, s.RTC],
  [_.RUBY, s.RUBY],
  [_.S, s.S],
  [_.SCRIPT, s.SCRIPT],
  [_.SEARCH, s.SEARCH],
  [_.SECTION, s.SECTION],
  [_.SELECT, s.SELECT],
  [_.SOURCE, s.SOURCE],
  [_.SMALL, s.SMALL],
  [_.SPAN, s.SPAN],
  [_.STRIKE, s.STRIKE],
  [_.STRONG, s.STRONG],
  [_.STYLE, s.STYLE],
  [_.SUB, s.SUB],
  [_.SUMMARY, s.SUMMARY],
  [_.SUP, s.SUP],
  [_.TABLE, s.TABLE],
  [_.TBODY, s.TBODY],
  [_.TEMPLATE, s.TEMPLATE],
  [_.TEXTAREA, s.TEXTAREA],
  [_.TFOOT, s.TFOOT],
  [_.TD, s.TD],
  [_.TH, s.TH],
  [_.THEAD, s.THEAD],
  [_.TITLE, s.TITLE],
  [_.TR, s.TR],
  [_.TRACK, s.TRACK],
  [_.TT, s.TT],
  [_.U, s.U],
  [_.UL, s.UL],
  [_.SVG, s.SVG],
  [_.VAR, s.VAR],
  [_.WBR, s.WBR],
  [_.XMP, s.XMP]
]);
function Ot(e) {
  var t;
  return (t = um.get(e)) !== null && t !== void 0 ? t : s.UNKNOWN;
}
const D = s, im = {
  [L.HTML]: /* @__PURE__ */ new Set([
    D.ADDRESS,
    D.APPLET,
    D.AREA,
    D.ARTICLE,
    D.ASIDE,
    D.BASE,
    D.BASEFONT,
    D.BGSOUND,
    D.BLOCKQUOTE,
    D.BODY,
    D.BR,
    D.BUTTON,
    D.CAPTION,
    D.CENTER,
    D.COL,
    D.COLGROUP,
    D.DD,
    D.DETAILS,
    D.DIR,
    D.DIV,
    D.DL,
    D.DT,
    D.EMBED,
    D.FIELDSET,
    D.FIGCAPTION,
    D.FIGURE,
    D.FOOTER,
    D.FORM,
    D.FRAME,
    D.FRAMESET,
    D.H1,
    D.H2,
    D.H3,
    D.H4,
    D.H5,
    D.H6,
    D.HEAD,
    D.HEADER,
    D.HGROUP,
    D.HR,
    D.HTML,
    D.IFRAME,
    D.IMG,
    D.INPUT,
    D.LI,
    D.LINK,
    D.LISTING,
    D.MAIN,
    D.MARQUEE,
    D.MENU,
    D.META,
    D.NAV,
    D.NOEMBED,
    D.NOFRAMES,
    D.NOSCRIPT,
    D.OBJECT,
    D.OL,
    D.P,
    D.PARAM,
    D.PLAINTEXT,
    D.PRE,
    D.SCRIPT,
    D.SECTION,
    D.SELECT,
    D.SOURCE,
    D.STYLE,
    D.SUMMARY,
    D.TABLE,
    D.TBODY,
    D.TD,
    D.TEMPLATE,
    D.TEXTAREA,
    D.TFOOT,
    D.TH,
    D.THEAD,
    D.TITLE,
    D.TR,
    D.TRACK,
    D.UL,
    D.WBR,
    D.XMP
  ]),
  [L.MATHML]: /* @__PURE__ */ new Set([D.MI, D.MO, D.MN, D.MS, D.MTEXT, D.ANNOTATION_XML]),
  [L.SVG]: /* @__PURE__ */ new Set([D.TITLE, D.FOREIGN_OBJECT, D.DESC]),
  [L.XLINK]: /* @__PURE__ */ new Set(),
  [L.XML]: /* @__PURE__ */ new Set(),
  [L.XMLNS]: /* @__PURE__ */ new Set()
}, pr = /* @__PURE__ */ new Set([D.H1, D.H2, D.H3, D.H4, D.H5, D.H6]);
_.STYLE, _.SCRIPT, _.XMP, _.IFRAME, _.NOEMBED, _.NOFRAMES, _.PLAINTEXT;
var p;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(p || (p = {}));
const oe = {
  DATA: p.DATA,
  RCDATA: p.RCDATA,
  RAWTEXT: p.RAWTEXT,
  SCRIPT_DATA: p.SCRIPT_DATA,
  PLAINTEXT: p.PLAINTEXT,
  CDATA_SECTION: p.CDATA_SECTION
};
function am(e) {
  return e >= d.DIGIT_0 && e <= d.DIGIT_9;
}
function vt(e) {
  return e >= d.LATIN_CAPITAL_A && e <= d.LATIN_CAPITAL_Z;
}
function sm(e) {
  return e >= d.LATIN_SMALL_A && e <= d.LATIN_SMALL_Z;
}
function Je(e) {
  return sm(e) || vt(e);
}
function ju(e) {
  return Je(e) || am(e);
}
function on(e) {
  return e + 32;
}
function Ua(e) {
  return e === d.SPACE || e === d.LINE_FEED || e === d.TABULATION || e === d.FORM_FEED;
}
function Qu(e) {
  return Ua(e) || e === d.SOLIDUS || e === d.GREATER_THAN_SIGN;
}
function lm(e) {
  return e === d.NULL ? S.nullCharacterReference : e > 1114111 ? S.characterReferenceOutsideUnicodeRange : Ma(e) ? S.surrogateCharacterReference : Fa(e) ? S.noncharacterCharacterReference : Ba(e) || e === d.CARRIAGE_RETURN ? S.controlCharacterReference : null;
}
class om {
  constructor(t, n) {
    this.options = t, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = p.DATA, this.returnState = p.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new $d(n), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new nm(Xd, (r, u) => {
      this.preprocessor.pos = this.entityStartPos + u - 1, this._flushCodePointConsumedAsCharacterReference(r);
    }, n.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(S.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (r) => {
        this._err(S.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + r);
      },
      validateNumericCharacterReference: (r) => {
        const u = lm(r);
        u && this._err(u, 1);
      }
    } : void 0);
  }
  //Errors
  _err(t, n = 0) {
    var r, u;
    (u = (r = this.handler).onParseError) === null || u === void 0 || u.call(r, this.preprocessor.getError(t, n));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t == null || t());
  }
  write(t, n, r) {
    this.active = !0, this.preprocessor.write(t, n), this._runParsingLoop(), this.paused || r == null || r();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let n = 0; n < t; n++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, n) {
    return this.preprocessor.startsWith(t, n) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: K.START_TAG,
      tagName: "",
      tagID: s.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: K.END_TAG,
      tagName: "",
      tagID: s.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: K.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: K.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, n;
    const r = this.currentToken;
    if (va(r, this.currentAttr.name) === null) {
      if (r.attrs.push(this.currentAttr), r.location && this.currentLocation) {
        const u = (t = (n = r.location).attrs) !== null && t !== void 0 ? t : n.attrs = /* @__PURE__ */ Object.create(null);
        u[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(S.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = Ot(t.tagName), t.type === K.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(S.endTagWithAttributes), t.selfClosing && this._err(S.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case K.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case K.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case K.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: K.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, n) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += n;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    const n = Ua(t) ? K.WHITESPACE_CHARACTER : t === d.NULL ? K.NULL_CHARACTER : K.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(K.CHARACTER, t);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = p.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? $e.Attribute : $e.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === p.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === p.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === p.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case p.DATA: {
        this._stateData(t);
        break;
      }
      case p.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case p.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case p.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case p.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case p.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case p.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case p.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case p.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case p.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case p.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case p.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case p.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case p.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case p.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case p.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case p.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case p.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case p.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case p.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case p.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case p.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case p.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case p.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case p.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case p.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case p.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case p.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case p.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case p.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case p.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case p.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case p.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case p.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case p.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case p.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case p.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case p.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case p.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case p.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case p.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case p.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case p.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case p.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case p.COMMENT: {
        this._stateComment(t);
        break;
      }
      case p.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case p.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case p.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case p.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case p.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case p.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case p.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case p.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case p.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case p.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case p.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case p.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case p.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case p.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case p.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case p.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case p.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case p.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case p.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case p.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case p.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case p.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case p.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case p.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case p.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case p.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case p.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case p.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case d.LESS_THAN_SIGN: {
        this.state = p.TAG_OPEN;
        break;
      }
      case d.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case d.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case d.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case d.LESS_THAN_SIGN: {
        this.state = p.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case d.LESS_THAN_SIGN: {
        this.state = p.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case d.LESS_THAN_SIGN: {
        this.state = p.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (Je(t))
      this._createStartTagToken(), this.state = p.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case d.EXCLAMATION_MARK: {
          this.state = p.MARKUP_DECLARATION_OPEN;
          break;
        }
        case d.SOLIDUS: {
          this.state = p.END_TAG_OPEN;
          break;
        }
        case d.QUESTION_MARK: {
          this._err(S.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = p.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case d.EOF: {
          this._err(S.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(S.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = p.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (Je(t))
      this._createEndTagToken(), this.state = p.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case d.GREATER_THAN_SIGN: {
          this._err(S.missingEndTagName), this.state = p.DATA;
          break;
        }
        case d.EOF: {
          this._err(S.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(S.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = p.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED: {
        this.state = p.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case d.SOLIDUS: {
        this.state = p.SELF_CLOSING_START_TAG;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this.state = p.DATA, this.emitCurrentTagToken();
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), n.tagName += se;
        break;
      }
      case d.EOF: {
        this._err(S.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        n.tagName += String.fromCodePoint(vt(t) ? on(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === d.SOLIDUS ? this.state = p.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = p.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    Je(t) ? (this.state = p.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = p.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const n = this.currentToken;
    switch (n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = p.BEFORE_ATTRIBUTE_NAME, !1;
      case d.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = p.SELF_CLOSING_START_TAG, !1;
      case d.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = p.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = p.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === d.SOLIDUS ? this.state = p.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = p.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    Je(t) ? (this.state = p.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = p.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = p.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case d.SOLIDUS: {
        this.state = p.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case d.EXCLAMATION_MARK: {
        this.state = p.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = p.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    Je(t) ? (this.state = p.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = p.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = p.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === d.HYPHEN_MINUS ? (this.state = p.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = p.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === d.HYPHEN_MINUS ? (this.state = p.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = p.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case d.HYPHEN_MINUS: {
        this.state = p.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case d.LESS_THAN_SIGN: {
        this.state = p.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._err(S.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case d.HYPHEN_MINUS: {
        this.state = p.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case d.LESS_THAN_SIGN: {
        this.state = p.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this.state = p.SCRIPT_DATA_ESCAPED, this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._err(S.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = p.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case d.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case d.LESS_THAN_SIGN: {
        this.state = p.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this.state = p.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this.state = p.SCRIPT_DATA_ESCAPED, this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._err(S.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = p.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === d.SOLIDUS ? this.state = p.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : Je(t) ? (this._emitChars("<"), this.state = p.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = p.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    Je(t) ? (this.state = p.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = p.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = p.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(Ce.SCRIPT, !1) && Qu(this.preprocessor.peek(Ce.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < Ce.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = p.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case d.HYPHEN_MINUS: {
        this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case d.LESS_THAN_SIGN: {
        this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._err(S.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case d.HYPHEN_MINUS: {
        this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case d.LESS_THAN_SIGN: {
        this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._err(S.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case d.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case d.LESS_THAN_SIGN: {
        this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this.state = p.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(se);
        break;
      }
      case d.EOF: {
        this._err(S.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === d.SOLIDUS ? (this.state = p.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(Ce.SCRIPT, !1) && Qu(this.preprocessor.peek(Ce.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < Ce.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = p.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = p.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
        break;
      case d.SOLIDUS:
      case d.GREATER_THAN_SIGN:
      case d.EOF: {
        this.state = p.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case d.EQUALS_SIGN: {
        this._err(S.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = p.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = p.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
      case d.SOLIDUS:
      case d.GREATER_THAN_SIGN:
      case d.EOF: {
        this._leaveAttrName(), this.state = p.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case d.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = p.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case d.QUOTATION_MARK:
      case d.APOSTROPHE:
      case d.LESS_THAN_SIGN: {
        this._err(S.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this.currentAttr.name += se;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(vt(t) ? on(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
        break;
      case d.SOLIDUS: {
        this.state = p.SELF_CLOSING_START_TAG;
        break;
      }
      case d.EQUALS_SIGN: {
        this.state = p.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this.state = p.DATA, this.emitCurrentTagToken();
        break;
      }
      case d.EOF: {
        this._err(S.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = p.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
        break;
      case d.QUOTATION_MARK: {
        this.state = p.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case d.APOSTROPHE: {
        this.state = p.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.missingAttributeValue), this.state = p.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = p.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case d.QUOTATION_MARK: {
        this.state = p.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case d.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this.currentAttr.value += se;
        break;
      }
      case d.EOF: {
        this._err(S.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case d.APOSTROPHE: {
        this.state = p.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case d.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this.currentAttr.value += se;
        break;
      }
      case d.EOF: {
        this._err(S.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED: {
        this._leaveAttrValue(), this.state = p.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case d.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = p.DATA, this.emitCurrentTagToken();
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), this.currentAttr.value += se;
        break;
      }
      case d.QUOTATION_MARK:
      case d.APOSTROPHE:
      case d.LESS_THAN_SIGN:
      case d.EQUALS_SIGN:
      case d.GRAVE_ACCENT: {
        this._err(S.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case d.EOF: {
        this._err(S.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED: {
        this._leaveAttrValue(), this.state = p.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case d.SOLIDUS: {
        this._leaveAttrValue(), this.state = p.SELF_CLOSING_START_TAG;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = p.DATA, this.emitCurrentTagToken();
        break;
      }
      case d.EOF: {
        this._err(S.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.missingWhitespaceBetweenAttributes), this.state = p.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case d.GREATER_THAN_SIGN: {
        const n = this.currentToken;
        n.selfClosing = !0, this.state = p.DATA, this.emitCurrentTagToken();
        break;
      }
      case d.EOF: {
        this._err(S.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.unexpectedSolidusInTag), this.state = p.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const n = this.currentToken;
    switch (t) {
      case d.GREATER_THAN_SIGN: {
        this.state = p.DATA, this.emitCurrentComment(n);
        break;
      }
      case d.EOF: {
        this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), n.data += se;
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(Ce.DASH_DASH, !0) ? (this._createCommentToken(Ce.DASH_DASH.length + 1), this.state = p.COMMENT_START) : this._consumeSequenceIfMatch(Ce.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(Ce.DOCTYPE.length + 1), this.state = p.DOCTYPE) : this._consumeSequenceIfMatch(Ce.CDATA_START, !0) ? this.inForeignNode ? this.state = p.CDATA_SECTION : (this._err(S.cdataInHtmlContent), this._createCommentToken(Ce.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = p.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(S.incorrectlyOpenedComment), this._createCommentToken(2), this.state = p.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case d.HYPHEN_MINUS: {
        this.state = p.COMMENT_START_DASH;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.abruptClosingOfEmptyComment), this.state = p.DATA;
        const n = this.currentToken;
        this.emitCurrentComment(n);
        break;
      }
      default:
        this.state = p.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const n = this.currentToken;
    switch (t) {
      case d.HYPHEN_MINUS: {
        this.state = p.COMMENT_END;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.abruptClosingOfEmptyComment), this.state = p.DATA, this.emitCurrentComment(n);
        break;
      }
      case d.EOF: {
        this._err(S.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = p.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const n = this.currentToken;
    switch (t) {
      case d.HYPHEN_MINUS: {
        this.state = p.COMMENT_END_DASH;
        break;
      }
      case d.LESS_THAN_SIGN: {
        n.data += "<", this.state = p.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), n.data += se;
        break;
      }
      case d.EOF: {
        this._err(S.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const n = this.currentToken;
    switch (t) {
      case d.EXCLAMATION_MARK: {
        n.data += "!", this.state = p.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case d.LESS_THAN_SIGN: {
        n.data += "<";
        break;
      }
      default:
        this.state = p.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === d.HYPHEN_MINUS ? this.state = p.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = p.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === d.HYPHEN_MINUS ? this.state = p.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = p.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== d.GREATER_THAN_SIGN && t !== d.EOF && this._err(S.nestedComment), this.state = p.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const n = this.currentToken;
    switch (t) {
      case d.HYPHEN_MINUS: {
        this.state = p.COMMENT_END;
        break;
      }
      case d.EOF: {
        this._err(S.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = p.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const n = this.currentToken;
    switch (t) {
      case d.GREATER_THAN_SIGN: {
        this.state = p.DATA, this.emitCurrentComment(n);
        break;
      }
      case d.EXCLAMATION_MARK: {
        this.state = p.COMMENT_END_BANG;
        break;
      }
      case d.HYPHEN_MINUS: {
        n.data += "-";
        break;
      }
      case d.EOF: {
        this._err(S.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--", this.state = p.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const n = this.currentToken;
    switch (t) {
      case d.HYPHEN_MINUS: {
        n.data += "--!", this.state = p.COMMENT_END_DASH;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.incorrectlyClosedComment), this.state = p.DATA, this.emitCurrentComment(n);
        break;
      }
      case d.EOF: {
        this._err(S.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--!", this.state = p.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED: {
        this.state = p.BEFORE_DOCTYPE_NAME;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this.state = p.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), this._createDoctypeToken(null);
        const n = this.currentToken;
        n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.missingWhitespaceBeforeDoctypeName), this.state = p.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (vt(t))
      this._createDoctypeToken(String.fromCharCode(on(t))), this.state = p.DOCTYPE_NAME;
    else
      switch (t) {
        case d.SPACE:
        case d.LINE_FEED:
        case d.TABULATION:
        case d.FORM_FEED:
          break;
        case d.NULL: {
          this._err(S.unexpectedNullCharacter), this._createDoctypeToken(se), this.state = p.DOCTYPE_NAME;
          break;
        }
        case d.GREATER_THAN_SIGN: {
          this._err(S.missingDoctypeName), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = p.DATA;
          break;
        }
        case d.EOF: {
          this._err(S.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = p.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED: {
        this.state = p.AFTER_DOCTYPE_NAME;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this.state = p.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), n.name += se;
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.name += String.fromCodePoint(vt(t) ? on(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
        break;
      case d.GREATER_THAN_SIGN: {
        this.state = p.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(Ce.PUBLIC, !1) ? this.state = p.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(Ce.SYSTEM, !1) ? this.state = p.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(S.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = p.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED: {
        this.state = p.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case d.QUOTATION_MARK: {
        this._err(S.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = p.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case d.APOSTROPHE: {
        this._err(S.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = p.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = p.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = p.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
        break;
      case d.QUOTATION_MARK: {
        n.publicId = "", this.state = p.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case d.APOSTROPHE: {
        n.publicId = "", this.state = p.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = p.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = p.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case d.QUOTATION_MARK: {
        this.state = p.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), n.publicId += se;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = p.DATA;
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case d.APOSTROPHE: {
        this.state = p.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), n.publicId += se;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = p.DATA;
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED: {
        this.state = p.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this.state = p.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case d.QUOTATION_MARK: {
        this._err(S.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = p.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case d.APOSTROPHE: {
        this._err(S.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = p.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = p.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
        break;
      case d.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = p.DATA;
        break;
      }
      case d.QUOTATION_MARK: {
        n.systemId = "", this.state = p.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case d.APOSTROPHE: {
        n.systemId = "", this.state = p.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = p.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED: {
        this.state = p.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case d.QUOTATION_MARK: {
        this._err(S.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = p.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case d.APOSTROPHE: {
        this._err(S.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = p.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = p.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = p.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
        break;
      case d.QUOTATION_MARK: {
        n.systemId = "", this.state = p.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case d.APOSTROPHE: {
        n.systemId = "", this.state = p.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = p.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = p.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case d.QUOTATION_MARK: {
        this.state = p.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), n.systemId += se;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = p.DATA;
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case d.APOSTROPHE: {
        this.state = p.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter), n.systemId += se;
        break;
      }
      case d.GREATER_THAN_SIGN: {
        this._err(S.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = p.DATA;
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case d.SPACE:
      case d.LINE_FEED:
      case d.TABULATION:
      case d.FORM_FEED:
        break;
      case d.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = p.DATA;
        break;
      }
      case d.EOF: {
        this._err(S.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(S.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = p.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const n = this.currentToken;
    switch (t) {
      case d.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = p.DATA;
        break;
      }
      case d.NULL: {
        this._err(S.unexpectedNullCharacter);
        break;
      }
      case d.EOF: {
        this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case d.RIGHT_SQUARE_BRACKET: {
        this.state = p.CDATA_SECTION_BRACKET;
        break;
      }
      case d.EOF: {
        this._err(S.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === d.RIGHT_SQUARE_BRACKET ? this.state = p.CDATA_SECTION_END : (this._emitChars("]"), this.state = p.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case d.GREATER_THAN_SIGN: {
        this.state = p.DATA;
        break;
      }
      case d.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = p.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0)
      if (this.preprocessor.lastChunkWritten)
        t = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(d.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && ju(this.preprocessor.peek(1)) ? p.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    ju(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === d.SEMICOLON && this._err(S.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
}
const Ha = /* @__PURE__ */ new Set([s.DD, s.DT, s.LI, s.OPTGROUP, s.OPTION, s.P, s.RB, s.RP, s.RT, s.RTC]), $u = /* @__PURE__ */ new Set([
  ...Ha,
  s.CAPTION,
  s.COLGROUP,
  s.TBODY,
  s.TD,
  s.TFOOT,
  s.TH,
  s.THEAD,
  s.TR
]), gn = /* @__PURE__ */ new Set([
  s.APPLET,
  s.CAPTION,
  s.HTML,
  s.MARQUEE,
  s.OBJECT,
  s.TABLE,
  s.TD,
  s.TEMPLATE,
  s.TH
]), cm = /* @__PURE__ */ new Set([...gn, s.OL, s.UL]), hm = /* @__PURE__ */ new Set([...gn, s.BUTTON]), Xu = /* @__PURE__ */ new Set([s.ANNOTATION_XML, s.MI, s.MN, s.MO, s.MS, s.MTEXT]), Gu = /* @__PURE__ */ new Set([s.DESC, s.FOREIGN_OBJECT, s.TITLE]), fm = /* @__PURE__ */ new Set([s.TR, s.TEMPLATE, s.HTML]), dm = /* @__PURE__ */ new Set([s.TBODY, s.TFOOT, s.THEAD, s.TEMPLATE, s.HTML]), mm = /* @__PURE__ */ new Set([s.TABLE, s.TEMPLATE, s.HTML]), pm = /* @__PURE__ */ new Set([s.TD, s.TH]);
class Em {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, n, r) {
    this.treeAdapter = n, this.handler = r, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = s.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === s.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === L.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, n) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, n, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, n) {
    const r = this._indexOf(t);
    this.items[r] = n, r === this.stackTop && (this.current = n);
  }
  insertAfter(t, n, r) {
    const u = this._indexOf(t) + 1;
    this.items.splice(u, 0, n), this.tagIDs.splice(u, 0, r), this.stackTop++, u === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, u === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let n = this.stackTop + 1;
    do
      n = this.tagIDs.lastIndexOf(t, n - 1);
    while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== L.HTML);
    this.shortenToLength(Math.max(n, 0));
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const n = this._indexOf(t);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilPopped(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(Math.max(r, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(pr, L.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(pm, L.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, n) {
    for (let r = this.stackTop; r >= 0; r--)
      if (t.has(this.tagIDs[r]) && this.treeAdapter.getNamespaceURI(this.items[r]) === n)
        return r;
    return -1;
  }
  clearBackTo(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(r + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(mm, L.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(dm, L.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(fm, L.HTML);
  }
  remove(t) {
    const n = this._indexOf(t);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === s.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const n = this._indexOf(t) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === s.HTML;
  }
  //Element in scope
  hasInDynamicScope(t, n) {
    for (let r = this.stackTop; r >= 0; r--) {
      const u = this.tagIDs[r];
      switch (this.treeAdapter.getNamespaceURI(this.items[r])) {
        case L.HTML: {
          if (u === t)
            return !0;
          if (n.has(u))
            return !1;
          break;
        }
        case L.SVG: {
          if (Gu.has(u))
            return !1;
          break;
        }
        case L.MATHML: {
          if (Xu.has(u))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, gn);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, cm);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, hm);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.tagIDs[t];
      switch (this.treeAdapter.getNamespaceURI(this.items[t])) {
        case L.HTML: {
          if (pr.has(n))
            return !0;
          if (gn.has(n))
            return !1;
          break;
        }
        case L.SVG: {
          if (Gu.has(n))
            return !1;
          break;
        }
        case L.MATHML: {
          if (Xu.has(n))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === L.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case s.TABLE:
          case s.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === L.HTML)
        switch (this.tagIDs[t]) {
          case s.TBODY:
          case s.THEAD:
          case s.TFOOT:
            return !0;
          case s.TABLE:
          case s.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === L.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case s.OPTION:
          case s.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && Ha.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && $u.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== t && $u.has(this.currentTagId); )
      this.pop();
  }
}
const Gn = 3;
var ze;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(ze || (ze = {}));
const Ku = { type: ze.Marker };
class gm {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, n) {
    const r = [], u = n.length, i = this.treeAdapter.getTagName(t), a = this.treeAdapter.getNamespaceURI(t);
    for (let l = 0; l < this.entries.length; l++) {
      const o = this.entries[l];
      if (o.type === ze.Marker)
        break;
      const { element: c } = o;
      if (this.treeAdapter.getTagName(c) === i && this.treeAdapter.getNamespaceURI(c) === a) {
        const f = this.treeAdapter.getAttrList(c);
        f.length === u && r.push({ idx: l, attrs: f });
      }
    }
    return r;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < Gn)
      return;
    const n = this.treeAdapter.getAttrList(t), r = this._getNoahArkConditionCandidates(t, n);
    if (r.length < Gn)
      return;
    const u = new Map(n.map((a) => [a.name, a.value]));
    let i = 0;
    for (let a = 0; a < r.length; a++) {
      const l = r[a];
      l.attrs.every((o) => u.get(o.name) === o.value) && (i += 1, i >= Gn && this.entries.splice(l.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(Ku);
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: ze.Element,
      element: t,
      token: n
    });
  }
  insertElementAfterBookmark(t, n) {
    const r = this.entries.indexOf(this.bookmark);
    this.entries.splice(r, 0, {
      type: ze.Element,
      element: t,
      token: n
    });
  }
  removeEntry(t) {
    const n = this.entries.indexOf(t);
    n !== -1 && this.entries.splice(n, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(Ku);
    t === -1 ? this.entries.length = 0 : this.entries.splice(0, t + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const n = this.entries.find((r) => r.type === ze.Marker || this.treeAdapter.getTagName(r.element) === t);
    return n && n.type === ze.Element ? n : null;
  }
  getElementEntry(t) {
    return this.entries.find((n) => n.type === ze.Element && n.element === t);
  }
}
const Ze = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: De.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, t, n) {
    return {
      nodeName: e,
      tagName: e,
      attrs: n,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, t) {
    e.childNodes.push(t), t.parentNode = e;
  },
  insertBefore(e, t, n) {
    const r = e.childNodes.indexOf(n);
    e.childNodes.splice(r, 0, t), t.parentNode = e;
  },
  setTemplateContent(e, t) {
    e.content = t;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, t, n, r) {
    const u = e.childNodes.find((i) => i.nodeName === "#documentType");
    if (u)
      u.name = t, u.publicId = n, u.systemId = r;
    else {
      const i = {
        nodeName: "#documentType",
        name: t,
        publicId: n,
        systemId: r,
        parentNode: null
      };
      Ze.appendChild(e, i);
    }
  },
  setDocumentMode(e, t) {
    e.mode = t;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const t = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
  },
  insertText(e, t) {
    if (e.childNodes.length > 0) {
      const n = e.childNodes[e.childNodes.length - 1];
      if (Ze.isTextNode(n)) {
        n.value += t;
        return;
      }
    }
    Ze.appendChild(e, Ze.createTextNode(t));
  },
  insertTextBefore(e, t, n) {
    const r = e.childNodes[e.childNodes.indexOf(n) - 1];
    r && Ze.isTextNode(r) ? r.value += t : Ze.insertBefore(e, Ze.createTextNode(t), n);
  },
  adoptAttributes(e, t) {
    const n = new Set(e.attrs.map((r) => r.name));
    for (let r = 0; r < t.length; r++)
      n.has(t[r].name) || e.attrs.push(t[r]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...t };
  }
}, za = "html", Tm = "about:legacy-compat", bm = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", Ya = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], Am = [
  ...Ya,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], _m = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), qa = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], Cm = [
  ...qa,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function Ju(e, t) {
  return t.some((n) => e.startsWith(n));
}
function km(e) {
  return e.name === za && e.publicId === null && (e.systemId === null || e.systemId === Tm);
}
function Sm(e) {
  if (e.name !== za)
    return De.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === bm)
    return De.QUIRKS;
  let { publicId: n } = e;
  if (n !== null) {
    if (n = n.toLowerCase(), _m.has(n))
      return De.QUIRKS;
    let r = t === null ? Am : Ya;
    if (Ju(n, r))
      return De.QUIRKS;
    if (r = t === null ? qa : Cm, Ju(n, r))
      return De.LIMITED_QUIRKS;
  }
  return De.NO_QUIRKS;
}
const Zu = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, ym = "definitionurl", Im = "definitionURL", xm = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), Nm = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: L.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: L.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: L.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: L.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: L.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: L.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: L.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: L.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: L.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: L.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: L.XMLNS }]
]), Om = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), Lm = /* @__PURE__ */ new Set([
  s.B,
  s.BIG,
  s.BLOCKQUOTE,
  s.BODY,
  s.BR,
  s.CENTER,
  s.CODE,
  s.DD,
  s.DIV,
  s.DL,
  s.DT,
  s.EM,
  s.EMBED,
  s.H1,
  s.H2,
  s.H3,
  s.H4,
  s.H5,
  s.H6,
  s.HEAD,
  s.HR,
  s.I,
  s.IMG,
  s.LI,
  s.LISTING,
  s.MENU,
  s.META,
  s.NOBR,
  s.OL,
  s.P,
  s.PRE,
  s.RUBY,
  s.S,
  s.SMALL,
  s.SPAN,
  s.STRONG,
  s.STRIKE,
  s.SUB,
  s.SUP,
  s.TABLE,
  s.TT,
  s.U,
  s.UL,
  s.VAR
]);
function Dm(e) {
  const t = e.tagID;
  return t === s.FONT && e.attrs.some(({ name: r }) => r === at.COLOR || r === at.SIZE || r === at.FACE) || Lm.has(t);
}
function Va(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === ym) {
      e.attrs[t].name = Im;
      break;
    }
}
function Wa(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = xm.get(e.attrs[t].name);
    n != null && (e.attrs[t].name = n);
  }
}
function Fr(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = Nm.get(e.attrs[t].name);
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
}
function Rm(e) {
  const t = Om.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = Ot(e.tagName));
}
function Pm(e, t) {
  return t === L.MATHML && (e === s.MI || e === s.MO || e === s.MN || e === s.MS || e === s.MTEXT);
}
function wm(e, t, n) {
  if (t === L.MATHML && e === s.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === at.ENCODING) {
        const u = n[r].value.toLowerCase();
        return u === Zu.TEXT_HTML || u === Zu.APPLICATION_XML;
      }
  }
  return t === L.SVG && (e === s.FOREIGN_OBJECT || e === s.DESC || e === s.TITLE);
}
function Mm(e, t, n, r) {
  return (!r || r === L.HTML) && wm(e, t, n) || (!r || r === L.MATHML) && Pm(e, t);
}
const Bm = "hidden", Fm = 8, vm = 3;
var g;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(g || (g = {}));
const Um = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, ja = /* @__PURE__ */ new Set([s.TABLE, s.TBODY, s.TFOOT, s.THEAD, s.TR]), ei = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: Ze,
  onParseError: null
};
class ti {
  constructor(t, n, r = null, u = null) {
    this.fragmentContext = r, this.scriptHandler = u, this.currentToken = null, this.stopped = !1, this.insertionMode = g.INITIAL, this.originalInsertionMode = g.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...ei,
      ...t
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new om(this.options, this), this.activeFormattingElements = new gm(this.treeAdapter), this.fragmentContextID = r ? Ot(this.treeAdapter.getTagName(r)) : s.UNKNOWN, this._setContextModes(r ?? this.document, this.fragmentContextID), this.openElements = new Em(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, n) {
    const r = new this(n);
    return r.tokenizer.write(t, !0), r.document;
  }
  static getFragmentParser(t, n) {
    const r = {
      ...ei,
      ...n
    };
    t ?? (t = r.treeAdapter.createElement(_.TEMPLATE, L.HTML, []));
    const u = r.treeAdapter.createElement("documentmock", L.HTML, []), i = new this(r, u, t);
    return i.fragmentContextID === s.TEMPLATE && i.tmplInsertionModeStack.unshift(g.IN_TEMPLATE), i._initTokenizerForFragmentParsing(), i._insertFakeRootElement(), i._resetInsertionMode(), i._findFormInFragmentContext(), i;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, n), n;
  }
  //Errors
  /** @internal */
  _err(t, n, r) {
    var u;
    if (!this.onParseError)
      return;
    const i = (u = t.location) !== null && u !== void 0 ? u : Um, a = {
      code: n,
      startLine: i.startLine,
      startCol: i.startCol,
      startOffset: i.startOffset,
      endLine: r ? i.startLine : i.endLine,
      endCol: r ? i.startCol : i.endCol,
      endOffset: r ? i.startOffset : i.endOffset
    };
    this.onParseError(a);
  }
  //Stack events
  /** @internal */
  onItemPush(t, n, r) {
    var u, i;
    (i = (u = this.treeAdapter).onItemPush) === null || i === void 0 || i.call(u, t), r && this.openElements.stackTop > 0 && this._setContextModes(t, n);
  }
  /** @internal */
  onItemPop(t, n) {
    var r, u;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (u = (r = this.treeAdapter).onItemPop) === null || u === void 0 || u.call(r, t, this.openElements.current), n) {
      let i, a;
      this.openElements.stackTop === 0 && this.fragmentContext ? (i = this.fragmentContext, a = this.fragmentContextID) : { current: i, currentTagId: a } = this.openElements, this._setContextModes(i, a);
    }
  }
  _setContextModes(t, n) {
    const r = t === this.document || t && this.treeAdapter.getNamespaceURI(t) === L.HTML;
    this.currentNotInHTML = !r, this.tokenizer.inForeignNode = !r && t !== void 0 && n !== void 0 && !this._isIntegrationPoint(n, t);
  }
  /** @protected */
  _switchToTextParsing(t, n) {
    this._insertElement(t, L.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = g.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = g.TEXT, this.originalInsertionMode = g.IN_BODY, this.tokenizer.state = oe.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === _.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== L.HTML))
      switch (this.fragmentContextID) {
        case s.TITLE:
        case s.TEXTAREA: {
          this.tokenizer.state = oe.RCDATA;
          break;
        }
        case s.STYLE:
        case s.XMP:
        case s.IFRAME:
        case s.NOEMBED:
        case s.NOFRAMES:
        case s.NOSCRIPT: {
          this.tokenizer.state = oe.RAWTEXT;
          break;
        }
        case s.SCRIPT: {
          this.tokenizer.state = oe.SCRIPT_DATA;
          break;
        }
        case s.PLAINTEXT: {
          this.tokenizer.state = oe.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(t) {
    const n = t.name || "", r = t.publicId || "", u = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, r, u), t.location) {
      const a = this.treeAdapter.getChildNodes(this.document).find((l) => this.treeAdapter.isDocumentTypeNode(l));
      a && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
    }
  }
  /** @protected */
  _attachElementToTree(t, n) {
    if (this.options.sourceCodeLocationInfo) {
      const r = n && {
        ...n,
        startTag: n
      };
      this.treeAdapter.setNodeSourceCodeLocation(t, r);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const r = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(r ?? this.document, t);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location);
  }
  /** @protected */
  _insertElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location), this.openElements.push(r, t.tagID);
  }
  /** @protected */
  _insertFakeElement(t, n) {
    const r = this.treeAdapter.createElement(t, L.HTML, []);
    this._attachElementToTree(r, null), this.openElements.push(r, n);
  }
  /** @protected */
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, L.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n, t.location), this.openElements.push(n, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(_.HTML, L.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, s.HTML);
  }
  /** @protected */
  _appendCommentNode(t, n) {
    const r = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, r), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, t.location);
  }
  /** @protected */
  _insertCharacters(t) {
    let n, r;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: n, beforeElement: r } = this._findFosterParentingLocation(), r ? this.treeAdapter.insertTextBefore(n, t.chars, r) : this.treeAdapter.insertText(n, t.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, t.chars)), !t.location)
      return;
    const u = this.treeAdapter.getChildNodes(n), i = r ? u.lastIndexOf(r) : u.length, a = u[i - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(a)) {
      const { endLine: o, endCol: c, endOffset: f } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(a, { endLine: o, endCol: c, endOffset: f });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
  }
  /** @protected */
  _adoptNodes(t, n) {
    for (let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  /** @protected */
  _setEndLocation(t, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
      const r = n.location, u = this.treeAdapter.getTagName(t), i = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        n.type === K.END_TAG && u === n.tagName ? {
          endTag: { ...r },
          endLine: r.endLine,
          endCol: r.endCol,
          endOffset: r.endOffset
        } : {
          endLine: r.startLine,
          endCol: r.startCol,
          endOffset: r.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, i);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let n, r;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, r = this.fragmentContextID) : { current: n, currentTagId: r } = this.openElements, t.tagID === s.SVG && this.treeAdapter.getTagName(n) === _.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === L.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === s.MGLYPH || t.tagID === s.MALIGNMARK) && r !== void 0 && !this._isIntegrationPoint(r, n, L.HTML)
    );
  }
  /** @protected */
  _processToken(t) {
    switch (t.type) {
      case K.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case K.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case K.COMMENT: {
        this.onComment(t);
        break;
      }
      case K.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case K.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case K.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case K.EOF: {
        this.onEof(t);
        break;
      }
      case K.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(t, n, r) {
    const u = this.treeAdapter.getNamespaceURI(n), i = this.treeAdapter.getAttrList(n);
    return Mm(t, u, i, r);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const n = this.activeFormattingElements.entries.findIndex((u) => u.type === ze.Marker || this.openElements.contains(u.element)), r = n === -1 ? t - 1 : n - 1;
      for (let u = r; u >= 0; u--) {
        const i = this.activeFormattingElements.entries[u];
        this._insertElement(i.token, this.treeAdapter.getNamespaceURI(i.element)), i.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = g.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(s.P), this.openElements.popUntilTagNamePopped(s.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case s.TR: {
          this.insertionMode = g.IN_ROW;
          return;
        }
        case s.TBODY:
        case s.THEAD:
        case s.TFOOT: {
          this.insertionMode = g.IN_TABLE_BODY;
          return;
        }
        case s.CAPTION: {
          this.insertionMode = g.IN_CAPTION;
          return;
        }
        case s.COLGROUP: {
          this.insertionMode = g.IN_COLUMN_GROUP;
          return;
        }
        case s.TABLE: {
          this.insertionMode = g.IN_TABLE;
          return;
        }
        case s.BODY: {
          this.insertionMode = g.IN_BODY;
          return;
        }
        case s.FRAMESET: {
          this.insertionMode = g.IN_FRAMESET;
          return;
        }
        case s.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case s.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case s.HTML: {
          this.insertionMode = this.headElement ? g.AFTER_HEAD : g.BEFORE_HEAD;
          return;
        }
        case s.TD:
        case s.TH: {
          if (t > 0) {
            this.insertionMode = g.IN_CELL;
            return;
          }
          break;
        }
        case s.HEAD: {
          if (t > 0) {
            this.insertionMode = g.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = g.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const r = this.openElements.tagIDs[n];
        if (r === s.TEMPLATE)
          break;
        if (r === s.TABLE) {
          this.insertionMode = g.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = g.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(t) {
    return ja.has(t);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const n = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case s.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(n) === L.HTML)
            return { parent: this.treeAdapter.getTemplateContent(n), beforeElement: null };
          break;
        }
        case s.TABLE: {
          const r = this.treeAdapter.getParentNode(n);
          return r ? { parent: r, beforeElement: n } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(t, n) {
    const r = this.treeAdapter.getNamespaceURI(t);
    return im[r].has(n);
  }
  /** @internal */
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      p1(this, t);
      return;
    }
    switch (this.insertionMode) {
      case g.INITIAL: {
        Bt(this, t);
        break;
      }
      case g.BEFORE_HTML: {
        zt(this, t);
        break;
      }
      case g.BEFORE_HEAD: {
        Yt(this, t);
        break;
      }
      case g.IN_HEAD: {
        qt(this, t);
        break;
      }
      case g.IN_HEAD_NO_SCRIPT: {
        Vt(this, t);
        break;
      }
      case g.AFTER_HEAD: {
        Wt(this, t);
        break;
      }
      case g.IN_BODY:
      case g.IN_CAPTION:
      case g.IN_CELL:
      case g.IN_TEMPLATE: {
        $a(this, t);
        break;
      }
      case g.TEXT:
      case g.IN_SELECT:
      case g.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case g.IN_TABLE:
      case g.IN_TABLE_BODY:
      case g.IN_ROW: {
        Kn(this, t);
        break;
      }
      case g.IN_TABLE_TEXT: {
        es(this, t);
        break;
      }
      case g.IN_COLUMN_GROUP: {
        Tn(this, t);
        break;
      }
      case g.AFTER_BODY: {
        bn(this, t);
        break;
      }
      case g.AFTER_AFTER_BODY: {
        fn(this, t);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      m1(this, t);
      return;
    }
    switch (this.insertionMode) {
      case g.INITIAL: {
        Bt(this, t);
        break;
      }
      case g.BEFORE_HTML: {
        zt(this, t);
        break;
      }
      case g.BEFORE_HEAD: {
        Yt(this, t);
        break;
      }
      case g.IN_HEAD: {
        qt(this, t);
        break;
      }
      case g.IN_HEAD_NO_SCRIPT: {
        Vt(this, t);
        break;
      }
      case g.AFTER_HEAD: {
        Wt(this, t);
        break;
      }
      case g.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case g.IN_TABLE:
      case g.IN_TABLE_BODY:
      case g.IN_ROW: {
        Kn(this, t);
        break;
      }
      case g.IN_COLUMN_GROUP: {
        Tn(this, t);
        break;
      }
      case g.AFTER_BODY: {
        bn(this, t);
        break;
      }
      case g.AFTER_AFTER_BODY: {
        fn(this, t);
        break;
      }
    }
  }
  /** @internal */
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      Er(this, t);
      return;
    }
    switch (this.insertionMode) {
      case g.INITIAL:
      case g.BEFORE_HTML:
      case g.BEFORE_HEAD:
      case g.IN_HEAD:
      case g.IN_HEAD_NO_SCRIPT:
      case g.AFTER_HEAD:
      case g.IN_BODY:
      case g.IN_TABLE:
      case g.IN_CAPTION:
      case g.IN_COLUMN_GROUP:
      case g.IN_TABLE_BODY:
      case g.IN_ROW:
      case g.IN_CELL:
      case g.IN_SELECT:
      case g.IN_SELECT_IN_TABLE:
      case g.IN_TEMPLATE:
      case g.IN_FRAMESET:
      case g.AFTER_FRAMESET: {
        Er(this, t);
        break;
      }
      case g.IN_TABLE_TEXT: {
        Ft(this, t);
        break;
      }
      case g.AFTER_BODY: {
        jm(this, t);
        break;
      }
      case g.AFTER_AFTER_BODY:
      case g.AFTER_AFTER_FRAMESET: {
        Qm(this, t);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case g.INITIAL: {
        $m(this, t);
        break;
      }
      case g.BEFORE_HEAD:
      case g.IN_HEAD:
      case g.IN_HEAD_NO_SCRIPT:
      case g.AFTER_HEAD: {
        this._err(t, S.misplacedDoctype);
        break;
      }
      case g.IN_TABLE_TEXT: {
        Ft(this, t);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, S.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? E1(this, t) : this._startTagOutsideForeignContent(t);
  }
  /** @protected */
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case g.INITIAL: {
        Bt(this, t);
        break;
      }
      case g.BEFORE_HTML: {
        Xm(this, t);
        break;
      }
      case g.BEFORE_HEAD: {
        Km(this, t);
        break;
      }
      case g.IN_HEAD: {
        Ue(this, t);
        break;
      }
      case g.IN_HEAD_NO_SCRIPT: {
        ep(this, t);
        break;
      }
      case g.AFTER_HEAD: {
        np(this, t);
        break;
      }
      case g.IN_BODY: {
        Ae(this, t);
        break;
      }
      case g.IN_TABLE: {
        kt(this, t);
        break;
      }
      case g.IN_TABLE_TEXT: {
        Ft(this, t);
        break;
      }
      case g.IN_CAPTION: {
        Jp(this, t);
        break;
      }
      case g.IN_COLUMN_GROUP: {
        Hr(this, t);
        break;
      }
      case g.IN_TABLE_BODY: {
        On(this, t);
        break;
      }
      case g.IN_ROW: {
        Ln(this, t);
        break;
      }
      case g.IN_CELL: {
        t1(this, t);
        break;
      }
      case g.IN_SELECT: {
        rs(this, t);
        break;
      }
      case g.IN_SELECT_IN_TABLE: {
        r1(this, t);
        break;
      }
      case g.IN_TEMPLATE: {
        i1(this, t);
        break;
      }
      case g.AFTER_BODY: {
        s1(this, t);
        break;
      }
      case g.IN_FRAMESET: {
        l1(this, t);
        break;
      }
      case g.AFTER_FRAMESET: {
        c1(this, t);
        break;
      }
      case g.AFTER_AFTER_BODY: {
        f1(this, t);
        break;
      }
      case g.AFTER_AFTER_FRAMESET: {
        d1(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? g1(this, t) : this._endTagOutsideForeignContent(t);
  }
  /** @protected */
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case g.INITIAL: {
        Bt(this, t);
        break;
      }
      case g.BEFORE_HTML: {
        Gm(this, t);
        break;
      }
      case g.BEFORE_HEAD: {
        Jm(this, t);
        break;
      }
      case g.IN_HEAD: {
        Zm(this, t);
        break;
      }
      case g.IN_HEAD_NO_SCRIPT: {
        tp(this, t);
        break;
      }
      case g.AFTER_HEAD: {
        rp(this, t);
        break;
      }
      case g.IN_BODY: {
        Nn(this, t);
        break;
      }
      case g.TEXT: {
        Yp(this, t);
        break;
      }
      case g.IN_TABLE: {
        $t(this, t);
        break;
      }
      case g.IN_TABLE_TEXT: {
        Ft(this, t);
        break;
      }
      case g.IN_CAPTION: {
        Zp(this, t);
        break;
      }
      case g.IN_COLUMN_GROUP: {
        e1(this, t);
        break;
      }
      case g.IN_TABLE_BODY: {
        gr(this, t);
        break;
      }
      case g.IN_ROW: {
        ns(this, t);
        break;
      }
      case g.IN_CELL: {
        n1(this, t);
        break;
      }
      case g.IN_SELECT: {
        us(this, t);
        break;
      }
      case g.IN_SELECT_IN_TABLE: {
        u1(this, t);
        break;
      }
      case g.IN_TEMPLATE: {
        a1(this, t);
        break;
      }
      case g.AFTER_BODY: {
        as(this, t);
        break;
      }
      case g.IN_FRAMESET: {
        o1(this, t);
        break;
      }
      case g.AFTER_FRAMESET: {
        h1(this, t);
        break;
      }
      case g.AFTER_AFTER_BODY: {
        fn(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEof(t) {
    switch (this.insertionMode) {
      case g.INITIAL: {
        Bt(this, t);
        break;
      }
      case g.BEFORE_HTML: {
        zt(this, t);
        break;
      }
      case g.BEFORE_HEAD: {
        Yt(this, t);
        break;
      }
      case g.IN_HEAD: {
        qt(this, t);
        break;
      }
      case g.IN_HEAD_NO_SCRIPT: {
        Vt(this, t);
        break;
      }
      case g.AFTER_HEAD: {
        Wt(this, t);
        break;
      }
      case g.IN_BODY:
      case g.IN_TABLE:
      case g.IN_CAPTION:
      case g.IN_COLUMN_GROUP:
      case g.IN_TABLE_BODY:
      case g.IN_ROW:
      case g.IN_CELL:
      case g.IN_SELECT:
      case g.IN_SELECT_IN_TABLE: {
        Ja(this, t);
        break;
      }
      case g.TEXT: {
        qp(this, t);
        break;
      }
      case g.IN_TABLE_TEXT: {
        Ft(this, t);
        break;
      }
      case g.IN_TEMPLATE: {
        is(this, t);
        break;
      }
      case g.AFTER_BODY:
      case g.IN_FRAMESET:
      case g.AFTER_FRAMESET:
      case g.AFTER_AFTER_BODY:
      case g.AFTER_AFTER_FRAMESET: {
        Ur(this, t);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === d.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case g.IN_HEAD:
      case g.IN_HEAD_NO_SCRIPT:
      case g.AFTER_HEAD:
      case g.TEXT:
      case g.IN_COLUMN_GROUP:
      case g.IN_SELECT:
      case g.IN_SELECT_IN_TABLE:
      case g.IN_FRAMESET:
      case g.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case g.IN_BODY:
      case g.IN_CAPTION:
      case g.IN_CELL:
      case g.IN_TEMPLATE:
      case g.AFTER_BODY:
      case g.AFTER_AFTER_BODY:
      case g.AFTER_AFTER_FRAMESET: {
        Qa(this, t);
        break;
      }
      case g.IN_TABLE:
      case g.IN_TABLE_BODY:
      case g.IN_ROW: {
        Kn(this, t);
        break;
      }
      case g.IN_TABLE_TEXT: {
        Za(this, t);
        break;
      }
    }
  }
}
function Hm(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagID) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : Ka(e, t), n;
}
function zm(e, t) {
  let n = null, r = e.openElements.stackTop;
  for (; r >= 0; r--) {
    const u = e.openElements.items[r];
    if (u === t.element)
      break;
    e._isSpecialElement(u, e.openElements.tagIDs[r]) && (n = u);
  }
  return n || (e.openElements.shortenToLength(Math.max(r, 0)), e.activeFormattingElements.removeEntry(t)), n;
}
function Ym(e, t, n) {
  let r = t, u = e.openElements.getCommonAncestor(t);
  for (let i = 0, a = u; a !== n; i++, a = u) {
    u = e.openElements.getCommonAncestor(a);
    const l = e.activeFormattingElements.getElementEntry(a), o = l && i >= vm;
    !l || o ? (o && e.activeFormattingElements.removeEntry(l), e.openElements.remove(a)) : (a = qm(e, l), r === t && (e.activeFormattingElements.bookmark = l), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(a, r), r = a);
  }
  return r;
}
function qm(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, r), t.element = r, r;
}
function Vm(e, t, n) {
  const r = e.treeAdapter.getTagName(t), u = Ot(r);
  if (e._isElementCausesFosterParenting(u))
    e._fosterParentElement(n);
  else {
    const i = e.treeAdapter.getNamespaceURI(t);
    u === s.TEMPLATE && i === L.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function Wm(e, t, n) {
  const r = e.treeAdapter.getNamespaceURI(n.element), { token: u } = n, i = e.treeAdapter.createElement(u.tagName, r, u.attrs);
  e._adoptNodes(t, i), e.treeAdapter.appendChild(t, i), e.activeFormattingElements.insertElementAfterBookmark(i, u), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, i, u.tagID);
}
function vr(e, t) {
  for (let n = 0; n < Fm; n++) {
    const r = Hm(e, t);
    if (!r)
      break;
    const u = zm(e, r);
    if (!u)
      break;
    e.activeFormattingElements.bookmark = r;
    const i = Ym(e, u, r.element), a = e.openElements.getCommonAncestor(r.element);
    e.treeAdapter.detachNode(i), a && Vm(e, a, i), Wm(e, u, r);
  }
}
function Er(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function jm(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function Qm(e, t) {
  e._appendCommentNode(t, e.document);
}
function Ur(e, t) {
  if (e.stopped = !0, t.location) {
    const n = e.fragmentContext ? 0 : 2;
    for (let r = e.openElements.stackTop; r >= n; r--)
      e._setEndLocation(e.openElements.items[r], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const r = e.openElements.items[0], u = e.treeAdapter.getNodeSourceCodeLocation(r);
      if (u && !u.endTag && (e._setEndLocation(r, t), e.openElements.stackTop >= 1)) {
        const i = e.openElements.items[1], a = e.treeAdapter.getNodeSourceCodeLocation(i);
        a && !a.endTag && e._setEndLocation(i, t);
      }
    }
  }
}
function $m(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? De.QUIRKS : Sm(t);
  km(t) || e._err(t, S.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = g.BEFORE_HTML;
}
function Bt(e, t) {
  e._err(t, S.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, De.QUIRKS), e.insertionMode = g.BEFORE_HTML, e._processToken(t);
}
function Xm(e, t) {
  t.tagID === s.HTML ? (e._insertElement(t, L.HTML), e.insertionMode = g.BEFORE_HEAD) : zt(e, t);
}
function Gm(e, t) {
  const n = t.tagID;
  (n === s.HTML || n === s.HEAD || n === s.BODY || n === s.BR) && zt(e, t);
}
function zt(e, t) {
  e._insertFakeRootElement(), e.insertionMode = g.BEFORE_HEAD, e._processToken(t);
}
function Km(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      Ae(e, t);
      break;
    }
    case s.HEAD: {
      e._insertElement(t, L.HTML), e.headElement = e.openElements.current, e.insertionMode = g.IN_HEAD;
      break;
    }
    default:
      Yt(e, t);
  }
}
function Jm(e, t) {
  const n = t.tagID;
  n === s.HEAD || n === s.BODY || n === s.HTML || n === s.BR ? Yt(e, t) : e._err(t, S.endTagWithoutMatchingOpenElement);
}
function Yt(e, t) {
  e._insertFakeElement(_.HEAD, s.HEAD), e.headElement = e.openElements.current, e.insertionMode = g.IN_HEAD, e._processToken(t);
}
function Ue(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      Ae(e, t);
      break;
    }
    case s.BASE:
    case s.BASEFONT:
    case s.BGSOUND:
    case s.LINK:
    case s.META: {
      e._appendElement(t, L.HTML), t.ackSelfClosing = !0;
      break;
    }
    case s.TITLE: {
      e._switchToTextParsing(t, oe.RCDATA);
      break;
    }
    case s.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, oe.RAWTEXT) : (e._insertElement(t, L.HTML), e.insertionMode = g.IN_HEAD_NO_SCRIPT);
      break;
    }
    case s.NOFRAMES:
    case s.STYLE: {
      e._switchToTextParsing(t, oe.RAWTEXT);
      break;
    }
    case s.SCRIPT: {
      e._switchToTextParsing(t, oe.SCRIPT_DATA);
      break;
    }
    case s.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = g.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(g.IN_TEMPLATE);
      break;
    }
    case s.HEAD: {
      e._err(t, S.misplacedStartTagForHeadElement);
      break;
    }
    default:
      qt(e, t);
  }
}
function Zm(e, t) {
  switch (t.tagID) {
    case s.HEAD: {
      e.openElements.pop(), e.insertionMode = g.AFTER_HEAD;
      break;
    }
    case s.BODY:
    case s.BR:
    case s.HTML: {
      qt(e, t);
      break;
    }
    case s.TEMPLATE: {
      ht(e, t);
      break;
    }
    default:
      e._err(t, S.endTagWithoutMatchingOpenElement);
  }
}
function ht(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== s.TEMPLATE && e._err(t, S.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(s.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, S.endTagWithoutMatchingOpenElement);
}
function qt(e, t) {
  e.openElements.pop(), e.insertionMode = g.AFTER_HEAD, e._processToken(t);
}
function ep(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      Ae(e, t);
      break;
    }
    case s.BASEFONT:
    case s.BGSOUND:
    case s.HEAD:
    case s.LINK:
    case s.META:
    case s.NOFRAMES:
    case s.STYLE: {
      Ue(e, t);
      break;
    }
    case s.NOSCRIPT: {
      e._err(t, S.nestedNoscriptInHead);
      break;
    }
    default:
      Vt(e, t);
  }
}
function tp(e, t) {
  switch (t.tagID) {
    case s.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = g.IN_HEAD;
      break;
    }
    case s.BR: {
      Vt(e, t);
      break;
    }
    default:
      e._err(t, S.endTagWithoutMatchingOpenElement);
  }
}
function Vt(e, t) {
  const n = t.type === K.EOF ? S.openElementsLeftAfterEof : S.disallowedContentInNoscriptInHead;
  e._err(t, n), e.openElements.pop(), e.insertionMode = g.IN_HEAD, e._processToken(t);
}
function np(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      Ae(e, t);
      break;
    }
    case s.BODY: {
      e._insertElement(t, L.HTML), e.framesetOk = !1, e.insertionMode = g.IN_BODY;
      break;
    }
    case s.FRAMESET: {
      e._insertElement(t, L.HTML), e.insertionMode = g.IN_FRAMESET;
      break;
    }
    case s.BASE:
    case s.BASEFONT:
    case s.BGSOUND:
    case s.LINK:
    case s.META:
    case s.NOFRAMES:
    case s.SCRIPT:
    case s.STYLE:
    case s.TEMPLATE:
    case s.TITLE: {
      e._err(t, S.abandonedHeadElementChild), e.openElements.push(e.headElement, s.HEAD), Ue(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case s.HEAD: {
      e._err(t, S.misplacedStartTagForHeadElement);
      break;
    }
    default:
      Wt(e, t);
  }
}
function rp(e, t) {
  switch (t.tagID) {
    case s.BODY:
    case s.HTML:
    case s.BR: {
      Wt(e, t);
      break;
    }
    case s.TEMPLATE: {
      ht(e, t);
      break;
    }
    default:
      e._err(t, S.endTagWithoutMatchingOpenElement);
  }
}
function Wt(e, t) {
  e._insertFakeElement(_.BODY, s.BODY), e.insertionMode = g.IN_BODY, xn(e, t);
}
function xn(e, t) {
  switch (t.type) {
    case K.CHARACTER: {
      $a(e, t);
      break;
    }
    case K.WHITESPACE_CHARACTER: {
      Qa(e, t);
      break;
    }
    case K.COMMENT: {
      Er(e, t);
      break;
    }
    case K.START_TAG: {
      Ae(e, t);
      break;
    }
    case K.END_TAG: {
      Nn(e, t);
      break;
    }
    case K.EOF: {
      Ja(e, t);
      break;
    }
  }
}
function Qa(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function $a(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function up(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function ip(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function ap(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, L.HTML), e.insertionMode = g.IN_FRAMESET);
}
function sp(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, L.HTML);
}
function lp(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e.openElements.currentTagId !== void 0 && pr.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, L.HTML);
}
function op(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, L.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function cp(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, L.HTML), n || (e.formElement = e.openElements.current));
}
function hp(e, t) {
  e.framesetOk = !1;
  const n = t.tagID;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const u = e.openElements.tagIDs[r];
    if (n === s.LI && u === s.LI || (n === s.DD || n === s.DT) && (u === s.DD || u === s.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(u), e.openElements.popUntilTagNamePopped(u);
      break;
    }
    if (u !== s.ADDRESS && u !== s.DIV && u !== s.P && e._isSpecialElement(e.openElements.items[r], u))
      break;
  }
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, L.HTML);
}
function fp(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, L.HTML), e.tokenizer.state = oe.PLAINTEXT;
}
function dp(e, t) {
  e.openElements.hasInScope(s.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(s.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, L.HTML), e.framesetOk = !1;
}
function mp(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(_.A);
  n && (vr(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, L.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function pp(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, L.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Ep(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(s.NOBR) && (vr(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, L.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function gp(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, L.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function Tp(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== De.QUIRKS && e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, L.HTML), e.framesetOk = !1, e.insertionMode = g.IN_TABLE;
}
function Xa(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, L.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function Ga(e) {
  const t = va(e, at.TYPE);
  return t != null && t.toLowerCase() === Bm;
}
function bp(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, L.HTML), Ga(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function Ap(e, t) {
  e._appendElement(t, L.HTML), t.ackSelfClosing = !0;
}
function _p(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._appendElement(t, L.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function Cp(e, t) {
  t.tagName = _.IMG, t.tagID = s.IMG, Xa(e, t);
}
function kp(e, t) {
  e._insertElement(t, L.HTML), e.skipNextNewLine = !0, e.tokenizer.state = oe.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = g.TEXT;
}
function Sp(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, oe.RAWTEXT);
}
function yp(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, oe.RAWTEXT);
}
function ni(e, t) {
  e._switchToTextParsing(t, oe.RAWTEXT);
}
function Ip(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, L.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === g.IN_TABLE || e.insertionMode === g.IN_CAPTION || e.insertionMode === g.IN_TABLE_BODY || e.insertionMode === g.IN_ROW || e.insertionMode === g.IN_CELL ? g.IN_SELECT_IN_TABLE : g.IN_SELECT;
}
function xp(e, t) {
  e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, L.HTML);
}
function Np(e, t) {
  e.openElements.hasInScope(s.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, L.HTML);
}
function Op(e, t) {
  e.openElements.hasInScope(s.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(s.RTC), e._insertElement(t, L.HTML);
}
function Lp(e, t) {
  e._reconstructActiveFormattingElements(), Va(t), Fr(t), t.selfClosing ? e._appendElement(t, L.MATHML) : e._insertElement(t, L.MATHML), t.ackSelfClosing = !0;
}
function Dp(e, t) {
  e._reconstructActiveFormattingElements(), Wa(t), Fr(t), t.selfClosing ? e._appendElement(t, L.SVG) : e._insertElement(t, L.SVG), t.ackSelfClosing = !0;
}
function ri(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, L.HTML);
}
function Ae(e, t) {
  switch (t.tagID) {
    case s.I:
    case s.S:
    case s.B:
    case s.U:
    case s.EM:
    case s.TT:
    case s.BIG:
    case s.CODE:
    case s.FONT:
    case s.SMALL:
    case s.STRIKE:
    case s.STRONG: {
      pp(e, t);
      break;
    }
    case s.A: {
      mp(e, t);
      break;
    }
    case s.H1:
    case s.H2:
    case s.H3:
    case s.H4:
    case s.H5:
    case s.H6: {
      lp(e, t);
      break;
    }
    case s.P:
    case s.DL:
    case s.OL:
    case s.UL:
    case s.DIV:
    case s.DIR:
    case s.NAV:
    case s.MAIN:
    case s.MENU:
    case s.ASIDE:
    case s.CENTER:
    case s.FIGURE:
    case s.FOOTER:
    case s.HEADER:
    case s.HGROUP:
    case s.DIALOG:
    case s.DETAILS:
    case s.ADDRESS:
    case s.ARTICLE:
    case s.SEARCH:
    case s.SECTION:
    case s.SUMMARY:
    case s.FIELDSET:
    case s.BLOCKQUOTE:
    case s.FIGCAPTION: {
      sp(e, t);
      break;
    }
    case s.LI:
    case s.DD:
    case s.DT: {
      hp(e, t);
      break;
    }
    case s.BR:
    case s.IMG:
    case s.WBR:
    case s.AREA:
    case s.EMBED:
    case s.KEYGEN: {
      Xa(e, t);
      break;
    }
    case s.HR: {
      _p(e, t);
      break;
    }
    case s.RB:
    case s.RTC: {
      Np(e, t);
      break;
    }
    case s.RT:
    case s.RP: {
      Op(e, t);
      break;
    }
    case s.PRE:
    case s.LISTING: {
      op(e, t);
      break;
    }
    case s.XMP: {
      Sp(e, t);
      break;
    }
    case s.SVG: {
      Dp(e, t);
      break;
    }
    case s.HTML: {
      up(e, t);
      break;
    }
    case s.BASE:
    case s.LINK:
    case s.META:
    case s.STYLE:
    case s.TITLE:
    case s.SCRIPT:
    case s.BGSOUND:
    case s.BASEFONT:
    case s.TEMPLATE: {
      Ue(e, t);
      break;
    }
    case s.BODY: {
      ip(e, t);
      break;
    }
    case s.FORM: {
      cp(e, t);
      break;
    }
    case s.NOBR: {
      Ep(e, t);
      break;
    }
    case s.MATH: {
      Lp(e, t);
      break;
    }
    case s.TABLE: {
      Tp(e, t);
      break;
    }
    case s.INPUT: {
      bp(e, t);
      break;
    }
    case s.PARAM:
    case s.TRACK:
    case s.SOURCE: {
      Ap(e, t);
      break;
    }
    case s.IMAGE: {
      Cp(e, t);
      break;
    }
    case s.BUTTON: {
      dp(e, t);
      break;
    }
    case s.APPLET:
    case s.OBJECT:
    case s.MARQUEE: {
      gp(e, t);
      break;
    }
    case s.IFRAME: {
      yp(e, t);
      break;
    }
    case s.SELECT: {
      Ip(e, t);
      break;
    }
    case s.OPTION:
    case s.OPTGROUP: {
      xp(e, t);
      break;
    }
    case s.NOEMBED:
    case s.NOFRAMES: {
      ni(e, t);
      break;
    }
    case s.FRAMESET: {
      ap(e, t);
      break;
    }
    case s.TEXTAREA: {
      kp(e, t);
      break;
    }
    case s.NOSCRIPT: {
      e.options.scriptingEnabled ? ni(e, t) : ri(e, t);
      break;
    }
    case s.PLAINTEXT: {
      fp(e, t);
      break;
    }
    case s.COL:
    case s.TH:
    case s.TD:
    case s.TR:
    case s.HEAD:
    case s.FRAME:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
    case s.CAPTION:
    case s.COLGROUP:
      break;
    default:
      ri(e, t);
  }
}
function Rp(e, t) {
  if (e.openElements.hasInScope(s.BODY) && (e.insertionMode = g.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const n = e.openElements.tryPeekProperlyNestedBodyElement();
    n && e._setEndLocation(n, t);
  }
}
function Pp(e, t) {
  e.openElements.hasInScope(s.BODY) && (e.insertionMode = g.AFTER_BODY, as(e, t));
}
function wp(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function Mp(e) {
  const t = e.openElements.tmplCount > 0, { formElement: n } = e;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(s.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(s.FORM) : n && e.openElements.remove(n));
}
function Bp(e) {
  e.openElements.hasInButtonScope(s.P) || e._insertFakeElement(_.P, s.P), e._closePElement();
}
function Fp(e) {
  e.openElements.hasInListItemScope(s.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(s.LI), e.openElements.popUntilTagNamePopped(s.LI));
}
function vp(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function Up(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function Hp(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function zp(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(_.BR, s.BR), e.openElements.pop(), e.framesetOk = !1;
}
function Ka(e, t) {
  const n = t.tagName, r = t.tagID;
  for (let u = e.openElements.stackTop; u > 0; u--) {
    const i = e.openElements.items[u], a = e.openElements.tagIDs[u];
    if (r === a && (r !== s.UNKNOWN || e.treeAdapter.getTagName(i) === n)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.stackTop >= u && e.openElements.shortenToLength(u);
      break;
    }
    if (e._isSpecialElement(i, a))
      break;
  }
}
function Nn(e, t) {
  switch (t.tagID) {
    case s.A:
    case s.B:
    case s.I:
    case s.S:
    case s.U:
    case s.EM:
    case s.TT:
    case s.BIG:
    case s.CODE:
    case s.FONT:
    case s.NOBR:
    case s.SMALL:
    case s.STRIKE:
    case s.STRONG: {
      vr(e, t);
      break;
    }
    case s.P: {
      Bp(e);
      break;
    }
    case s.DL:
    case s.UL:
    case s.OL:
    case s.DIR:
    case s.DIV:
    case s.NAV:
    case s.PRE:
    case s.MAIN:
    case s.MENU:
    case s.ASIDE:
    case s.BUTTON:
    case s.CENTER:
    case s.FIGURE:
    case s.FOOTER:
    case s.HEADER:
    case s.HGROUP:
    case s.DIALOG:
    case s.ADDRESS:
    case s.ARTICLE:
    case s.DETAILS:
    case s.SEARCH:
    case s.SECTION:
    case s.SUMMARY:
    case s.LISTING:
    case s.FIELDSET:
    case s.BLOCKQUOTE:
    case s.FIGCAPTION: {
      wp(e, t);
      break;
    }
    case s.LI: {
      Fp(e);
      break;
    }
    case s.DD:
    case s.DT: {
      vp(e, t);
      break;
    }
    case s.H1:
    case s.H2:
    case s.H3:
    case s.H4:
    case s.H5:
    case s.H6: {
      Up(e);
      break;
    }
    case s.BR: {
      zp(e);
      break;
    }
    case s.BODY: {
      Rp(e, t);
      break;
    }
    case s.HTML: {
      Pp(e, t);
      break;
    }
    case s.FORM: {
      Mp(e);
      break;
    }
    case s.APPLET:
    case s.OBJECT:
    case s.MARQUEE: {
      Hp(e, t);
      break;
    }
    case s.TEMPLATE: {
      ht(e, t);
      break;
    }
    default:
      Ka(e, t);
  }
}
function Ja(e, t) {
  e.tmplInsertionModeStack.length > 0 ? is(e, t) : Ur(e, t);
}
function Yp(e, t) {
  var n;
  t.tagID === s.SCRIPT && ((n = e.scriptHandler) === null || n === void 0 || n.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function qp(e, t) {
  e._err(t, S.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function Kn(e, t) {
  if (e.openElements.currentTagId !== void 0 && ja.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = g.IN_TABLE_TEXT, t.type) {
      case K.CHARACTER: {
        es(e, t);
        break;
      }
      case K.WHITESPACE_CHARACTER: {
        Za(e, t);
        break;
      }
    }
  else
    tn(e, t);
}
function Vp(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, L.HTML), e.insertionMode = g.IN_CAPTION;
}
function Wp(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, L.HTML), e.insertionMode = g.IN_COLUMN_GROUP;
}
function jp(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(_.COLGROUP, s.COLGROUP), e.insertionMode = g.IN_COLUMN_GROUP, Hr(e, t);
}
function Qp(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, L.HTML), e.insertionMode = g.IN_TABLE_BODY;
}
function $p(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(_.TBODY, s.TBODY), e.insertionMode = g.IN_TABLE_BODY, On(e, t);
}
function Xp(e, t) {
  e.openElements.hasInTableScope(s.TABLE) && (e.openElements.popUntilTagNamePopped(s.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function Gp(e, t) {
  Ga(t) ? e._appendElement(t, L.HTML) : tn(e, t), t.ackSelfClosing = !0;
}
function Kp(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, L.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function kt(e, t) {
  switch (t.tagID) {
    case s.TD:
    case s.TH:
    case s.TR: {
      $p(e, t);
      break;
    }
    case s.STYLE:
    case s.SCRIPT:
    case s.TEMPLATE: {
      Ue(e, t);
      break;
    }
    case s.COL: {
      jp(e, t);
      break;
    }
    case s.FORM: {
      Kp(e, t);
      break;
    }
    case s.TABLE: {
      Xp(e, t);
      break;
    }
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      Qp(e, t);
      break;
    }
    case s.INPUT: {
      Gp(e, t);
      break;
    }
    case s.CAPTION: {
      Vp(e, t);
      break;
    }
    case s.COLGROUP: {
      Wp(e, t);
      break;
    }
    default:
      tn(e, t);
  }
}
function $t(e, t) {
  switch (t.tagID) {
    case s.TABLE: {
      e.openElements.hasInTableScope(s.TABLE) && (e.openElements.popUntilTagNamePopped(s.TABLE), e._resetInsertionMode());
      break;
    }
    case s.TEMPLATE: {
      ht(e, t);
      break;
    }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TBODY:
    case s.TD:
    case s.TFOOT:
    case s.TH:
    case s.THEAD:
    case s.TR:
      break;
    default:
      tn(e, t);
  }
}
function tn(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, xn(e, t), e.fosterParentingEnabled = n;
}
function Za(e, t) {
  e.pendingCharacterTokens.push(t);
}
function es(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function Ft(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      tn(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const ts = /* @__PURE__ */ new Set([s.CAPTION, s.COL, s.COLGROUP, s.TBODY, s.TD, s.TFOOT, s.TH, s.THEAD, s.TR]);
function Jp(e, t) {
  const n = t.tagID;
  ts.has(n) ? e.openElements.hasInTableScope(s.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(s.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = g.IN_TABLE, kt(e, t)) : Ae(e, t);
}
function Zp(e, t) {
  const n = t.tagID;
  switch (n) {
    case s.CAPTION:
    case s.TABLE: {
      e.openElements.hasInTableScope(s.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(s.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = g.IN_TABLE, n === s.TABLE && $t(e, t));
      break;
    }
    case s.BODY:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TBODY:
    case s.TD:
    case s.TFOOT:
    case s.TH:
    case s.THEAD:
    case s.TR:
      break;
    default:
      Nn(e, t);
  }
}
function Hr(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      Ae(e, t);
      break;
    }
    case s.COL: {
      e._appendElement(t, L.HTML), t.ackSelfClosing = !0;
      break;
    }
    case s.TEMPLATE: {
      Ue(e, t);
      break;
    }
    default:
      Tn(e, t);
  }
}
function e1(e, t) {
  switch (t.tagID) {
    case s.COLGROUP: {
      e.openElements.currentTagId === s.COLGROUP && (e.openElements.pop(), e.insertionMode = g.IN_TABLE);
      break;
    }
    case s.TEMPLATE: {
      ht(e, t);
      break;
    }
    case s.COL:
      break;
    default:
      Tn(e, t);
  }
}
function Tn(e, t) {
  e.openElements.currentTagId === s.COLGROUP && (e.openElements.pop(), e.insertionMode = g.IN_TABLE, e._processToken(t));
}
function On(e, t) {
  switch (t.tagID) {
    case s.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, L.HTML), e.insertionMode = g.IN_ROW;
      break;
    }
    case s.TH:
    case s.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(_.TR, s.TR), e.insertionMode = g.IN_ROW, Ln(e, t);
      break;
    }
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = g.IN_TABLE, kt(e, t));
      break;
    }
    default:
      kt(e, t);
  }
}
function gr(e, t) {
  const n = t.tagID;
  switch (t.tagID) {
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = g.IN_TABLE);
      break;
    }
    case s.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = g.IN_TABLE, $t(e, t));
      break;
    }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TD:
    case s.TH:
    case s.TR:
      break;
    default:
      $t(e, t);
  }
}
function Ln(e, t) {
  switch (t.tagID) {
    case s.TH:
    case s.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, L.HTML), e.insertionMode = g.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
    case s.TR: {
      e.openElements.hasInTableScope(s.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = g.IN_TABLE_BODY, On(e, t));
      break;
    }
    default:
      kt(e, t);
  }
}
function ns(e, t) {
  switch (t.tagID) {
    case s.TR: {
      e.openElements.hasInTableScope(s.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = g.IN_TABLE_BODY);
      break;
    }
    case s.TABLE: {
      e.openElements.hasInTableScope(s.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = g.IN_TABLE_BODY, gr(e, t));
      break;
    }
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(s.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = g.IN_TABLE_BODY, gr(e, t));
      break;
    }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TD:
    case s.TH:
      break;
    default:
      $t(e, t);
  }
}
function t1(e, t) {
  const n = t.tagID;
  ts.has(n) ? (e.openElements.hasInTableScope(s.TD) || e.openElements.hasInTableScope(s.TH)) && (e._closeTableCell(), Ln(e, t)) : Ae(e, t);
}
function n1(e, t) {
  const n = t.tagID;
  switch (n) {
    case s.TD:
    case s.TH: {
      e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = g.IN_ROW);
      break;
    }
    case s.TABLE:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
    case s.TR: {
      e.openElements.hasInTableScope(n) && (e._closeTableCell(), ns(e, t));
      break;
    }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
      break;
    default:
      Nn(e, t);
  }
}
function rs(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      Ae(e, t);
      break;
    }
    case s.OPTION: {
      e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e._insertElement(t, L.HTML);
      break;
    }
    case s.OPTGROUP: {
      e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e.openElements.currentTagId === s.OPTGROUP && e.openElements.pop(), e._insertElement(t, L.HTML);
      break;
    }
    case s.HR: {
      e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e.openElements.currentTagId === s.OPTGROUP && e.openElements.pop(), e._appendElement(t, L.HTML), t.ackSelfClosing = !0;
      break;
    }
    case s.INPUT:
    case s.KEYGEN:
    case s.TEXTAREA:
    case s.SELECT: {
      e.openElements.hasInSelectScope(s.SELECT) && (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode(), t.tagID !== s.SELECT && e._processStartTag(t));
      break;
    }
    case s.SCRIPT:
    case s.TEMPLATE: {
      Ue(e, t);
      break;
    }
  }
}
function us(e, t) {
  switch (t.tagID) {
    case s.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === s.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === s.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === s.OPTGROUP && e.openElements.pop();
      break;
    }
    case s.OPTION: {
      e.openElements.currentTagId === s.OPTION && e.openElements.pop();
      break;
    }
    case s.SELECT: {
      e.openElements.hasInSelectScope(s.SELECT) && (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode());
      break;
    }
    case s.TEMPLATE: {
      ht(e, t);
      break;
    }
  }
}
function r1(e, t) {
  const n = t.tagID;
  n === s.CAPTION || n === s.TABLE || n === s.TBODY || n === s.TFOOT || n === s.THEAD || n === s.TR || n === s.TD || n === s.TH ? (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : rs(e, t);
}
function u1(e, t) {
  const n = t.tagID;
  n === s.CAPTION || n === s.TABLE || n === s.TBODY || n === s.TFOOT || n === s.THEAD || n === s.TR || n === s.TD || n === s.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : us(e, t);
}
function i1(e, t) {
  switch (t.tagID) {
    // First, handle tags that can start without a mode change
    case s.BASE:
    case s.BASEFONT:
    case s.BGSOUND:
    case s.LINK:
    case s.META:
    case s.NOFRAMES:
    case s.SCRIPT:
    case s.STYLE:
    case s.TEMPLATE:
    case s.TITLE: {
      Ue(e, t);
      break;
    }
    // Re-process the token in the appropriate mode
    case s.CAPTION:
    case s.COLGROUP:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      e.tmplInsertionModeStack[0] = g.IN_TABLE, e.insertionMode = g.IN_TABLE, kt(e, t);
      break;
    }
    case s.COL: {
      e.tmplInsertionModeStack[0] = g.IN_COLUMN_GROUP, e.insertionMode = g.IN_COLUMN_GROUP, Hr(e, t);
      break;
    }
    case s.TR: {
      e.tmplInsertionModeStack[0] = g.IN_TABLE_BODY, e.insertionMode = g.IN_TABLE_BODY, On(e, t);
      break;
    }
    case s.TD:
    case s.TH: {
      e.tmplInsertionModeStack[0] = g.IN_ROW, e.insertionMode = g.IN_ROW, Ln(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = g.IN_BODY, e.insertionMode = g.IN_BODY, Ae(e, t);
  }
}
function a1(e, t) {
  t.tagID === s.TEMPLATE && ht(e, t);
}
function is(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(s.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : Ur(e, t);
}
function s1(e, t) {
  t.tagID === s.HTML ? Ae(e, t) : bn(e, t);
}
function as(e, t) {
  var n;
  if (t.tagID === s.HTML) {
    if (e.fragmentContext || (e.insertionMode = g.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === s.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const r = e.openElements.items[1];
      r && !(!((n = e.treeAdapter.getNodeSourceCodeLocation(r)) === null || n === void 0) && n.endTag) && e._setEndLocation(r, t);
    }
  } else
    bn(e, t);
}
function bn(e, t) {
  e.insertionMode = g.IN_BODY, xn(e, t);
}
function l1(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      Ae(e, t);
      break;
    }
    case s.FRAMESET: {
      e._insertElement(t, L.HTML);
      break;
    }
    case s.FRAME: {
      e._appendElement(t, L.HTML), t.ackSelfClosing = !0;
      break;
    }
    case s.NOFRAMES: {
      Ue(e, t);
      break;
    }
  }
}
function o1(e, t) {
  t.tagID === s.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== s.FRAMESET && (e.insertionMode = g.AFTER_FRAMESET));
}
function c1(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      Ae(e, t);
      break;
    }
    case s.NOFRAMES: {
      Ue(e, t);
      break;
    }
  }
}
function h1(e, t) {
  t.tagID === s.HTML && (e.insertionMode = g.AFTER_AFTER_FRAMESET);
}
function f1(e, t) {
  t.tagID === s.HTML ? Ae(e, t) : fn(e, t);
}
function fn(e, t) {
  e.insertionMode = g.IN_BODY, xn(e, t);
}
function d1(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      Ae(e, t);
      break;
    }
    case s.NOFRAMES: {
      Ue(e, t);
      break;
    }
  }
}
function m1(e, t) {
  t.chars = se, e._insertCharacters(t);
}
function p1(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function ss(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== L.HTML && e.openElements.currentTagId !== void 0 && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function E1(e, t) {
  if (Dm(t))
    ss(e), e._startTagOutsideForeignContent(t);
  else {
    const n = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(n);
    r === L.MATHML ? Va(t) : r === L.SVG && (Rm(t), Wa(t)), Fr(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
  }
}
function g1(e, t) {
  if (t.tagID === s.P || t.tagID === s.BR) {
    ss(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const r = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(r) === L.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const u = e.treeAdapter.getTagName(r);
    if (u.toLowerCase() === t.tagName) {
      t.tagName = u, e.openElements.shortenToLength(n);
      break;
    }
  }
}
_.AREA, _.BASE, _.BASEFONT, _.BGSOUND, _.BR, _.COL, _.EMBED, _.FRAME, _.HR, _.IMG, _.INPUT, _.KEYGEN, _.LINK, _.META, _.PARAM, _.SOURCE, _.TRACK, _.WBR;
const T1 = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, b1 = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), ui = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function ls(e, t) {
  const n = O1(e), r = $i("type", {
    handlers: { root: A1, element: _1, text: C1, comment: cs, doctype: k1, raw: y1 },
    unknown: I1
  }), u = {
    parser: n ? new ti(ui) : ti.getFragmentParser(void 0, ui),
    handle(l) {
      r(l, u);
    },
    stitches: !1,
    options: t || {}
  };
  r(e, u), Lt(u, Ye());
  const i = n ? u.parser.document : u.parser.getFragment(), a = Ld(i, {
    // To do: support `space`?
    file: u.options.file
  });
  return u.stitches && In(a, "comment", function(l, o, c) {
    const f = (
      /** @type {Stitch} */
      /** @type {unknown} */
      l
    );
    if (f.value.stitch && c && o !== void 0) {
      const h = c.children;
      return h[o] = f.value.stitch, o;
    }
  }), a.type === "root" && a.children.length === 1 && a.children[0].type === e.type ? a.children[0] : a;
}
function os(e, t) {
  let n = -1;
  if (e)
    for (; ++n < e.length; )
      t.handle(e[n]);
}
function A1(e, t) {
  os(e.children, t);
}
function _1(e, t) {
  x1(e, t), os(e.children, t), N1(e, t);
}
function C1(e, t) {
  t.parser.tokenizer.state > 4 && (t.parser.tokenizer.state = 0);
  const n = {
    type: K.CHARACTER,
    chars: e.value,
    location: nn(e)
  };
  Lt(t, Ye(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function k1(e, t) {
  const n = {
    type: K.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: nn(e)
  };
  Lt(t, Ye(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function S1(e, t) {
  t.stitches = !0;
  const n = L1(e);
  if ("children" in e && "children" in n) {
    const r = (
      /** @type {Root} */
      ls({ type: "root", children: e.children }, t.options)
    );
    n.children = r.children;
  }
  cs({ type: "comment", value: { stitch: n } }, t);
}
function cs(e, t) {
  const n = e.value, r = {
    type: K.COMMENT,
    data: n,
    location: nn(e)
  };
  Lt(t, Ye(e)), t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken);
}
function y1(e, t) {
  if (t.parser.tokenizer.preprocessor.html = "", t.parser.tokenizer.preprocessor.pos = -1, t.parser.tokenizer.preprocessor.lastGapPos = -2, t.parser.tokenizer.preprocessor.gapStack = [], t.parser.tokenizer.preprocessor.skipNextNewLine = !1, t.parser.tokenizer.preprocessor.lastChunkWritten = !1, t.parser.tokenizer.preprocessor.endOfChunkHit = !1, t.parser.tokenizer.preprocessor.isEol = !1, hs(t, Ye(e)), t.parser.tokenizer.write(
    t.options.tagfilter ? e.value.replace(T1, "&lt;$1$2") : e.value,
    !1
  ), t.parser.tokenizer._runParsingLoop(), t.parser.tokenizer.state === 72 || // @ts-expect-error: removed.
  t.parser.tokenizer.state === 78) {
    t.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const n = t.parser.tokenizer._consume();
    t.parser.tokenizer._callState(n);
  }
}
function I1(e, t) {
  const n = (
    /** @type {Nodes} */
    e
  );
  if (t.options.passThrough && t.options.passThrough.includes(n.type))
    S1(n, t);
  else {
    let r = "";
    throw b1.has(n.type) && (r = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + n.type + "` node" + r);
  }
}
function Lt(e, t) {
  hs(e, t);
  const n = e.parser.tokenizer.currentCharacterToken;
  n && n.location && (n.location.endLine = e.parser.tokenizer.preprocessor.line, n.location.endCol = e.parser.tokenizer.preprocessor.col + 1, n.location.endOffset = e.parser.tokenizer.preprocessor.offset + 1, e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken)), e.parser.tokenizer.paused = !1, e.parser.tokenizer.inLoop = !1, e.parser.tokenizer.active = !1, e.parser.tokenizer.returnState = oe.DATA, e.parser.tokenizer.charRefCode = -1, e.parser.tokenizer.consumedAfterSnapshot = -1, e.parser.tokenizer.currentLocation = null, e.parser.tokenizer.currentCharacterToken = null, e.parser.tokenizer.currentToken = null, e.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function hs(e, t) {
  if (t && t.offset !== void 0) {
    const n = {
      startLine: t.line,
      startCol: t.column,
      startOffset: t.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    e.parser.tokenizer.preprocessor.lineStartPos = -t.column + 1, e.parser.tokenizer.preprocessor.droppedBufferSize = t.offset, e.parser.tokenizer.preprocessor.line = t.line, e.parser.tokenizer.currentLocation = n;
  }
}
function x1(e, t) {
  const n = e.tagName.toLowerCase();
  if (t.parser.tokenizer.state === oe.PLAINTEXT) return;
  Lt(t, Ye(e));
  const r = t.parser.openElements.current;
  let u = "namespaceURI" in r ? r.namespaceURI : it.html;
  u === it.html && n === "svg" && (u = it.svg);
  const i = Md(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...e, children: [] },
    { space: u === it.svg ? "svg" : "html" }
  ), a = {
    type: K.START_TAG,
    tagName: n,
    tagID: Ot(n),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    // Always element.
    /* c8 ignore next */
    attrs: "attrs" in i ? i.attrs : [],
    location: nn(e)
  };
  t.parser.currentToken = a, t.parser._processToken(t.parser.currentToken), t.parser.tokenizer.lastStartTagName = n;
}
function N1(e, t) {
  const n = e.tagName.toLowerCase();
  if (!t.parser.tokenizer.inForeignNode && qd.includes(n) || t.parser.tokenizer.state === oe.PLAINTEXT) return;
  Lt(t, An(e));
  const r = {
    type: K.END_TAG,
    tagName: n,
    tagID: Ot(n),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: nn(e)
  };
  t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken), // Current element is closed.
  n === t.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (t.parser.tokenizer.state === oe.RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
  t.parser.tokenizer.state === oe.RAWTEXT || // `<script>`
  t.parser.tokenizer.state === oe.SCRIPT_DATA) && (t.parser.tokenizer.state = oe.DATA);
}
function O1(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName.toLowerCase() === "html"));
}
function nn(e) {
  const t = Ye(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, n = An(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
function L1(e) {
  return "children" in e ? Ct({ ...e, children: [] }) : Ct(e);
}
function D1(e) {
  return function(t, n) {
    return (
      /** @type {Root} */
      ls(t, { ...e, file: n })
    );
  };
}
const R1 = {
  allowEmbeddedHtml: !0,
  components: {},
  linkOrdinanceClaused: !0
};
function Y1(e, t) {
  if (!e) return;
  const {
    allowEmbeddedHtml: n,
    components: r,
    linkOrdinanceClaused: u,
    ordinanceLink: i,
    reportColors: a
  } = {
    ...R1,
    ...t
  };
  if (u && i) {
    const l = /\b(\d{2,}\.\d{2,})\.?((?:-(?:s\d*|\d+(?:\.\d+)*))*)\b/gi;
    e = e.replace(l, (o, c, f) => {
      const h = c + f;
      return `[${h}](${i.replace("{{}}", h)})`;
    });
  }
  return e = e.replaceAll(/```markdown/g, ""), e = e.replaceAll(/```$/g, ""), /* @__PURE__ */ le(
    P0,
    {
      className: "prose dark:prose-invert prose-p:leading-relaxed prose-pre:p-0 break-words",
      rehypePlugins: n ? [D1] : [],
      remarkPlugins: [Vf, td],
      components: {
        p({ children: l }) {
          return /* @__PURE__ */ le("p", { className: "text-bodymd whitespace-pre-wrap [&:not(blockquote_*)]:mb-2", children: l });
        },
        blockquote({ children: l }) {
          return /* @__PURE__ */ le(
            "blockquote",
            {
              "data-md-blockquote": !0,
              className: ks(
                "text-bodymd mb-3 max-h-[250px] overflow-y-auto border-l-4 bg-white/50 px-5 py-3",
                {
                  [(a == null ? void 0 : a.border) || ""]: !!a
                }
              ),
              children: l
            }
          );
        },
        h1({ children: l }) {
          return /* @__PURE__ */ le("p", { children: /* @__PURE__ */ le("span", { className: "text-heading3xl font-bold", children: l }) });
        },
        h2({ children: l }) {
          return /* @__PURE__ */ le("h2", { className: "text-heading2xl mb-2 mt-4 font-semibold", children: l });
        },
        h3({ children: l }) {
          return /* @__PURE__ */ le("p", { children: /* @__PURE__ */ le("span", { className: "text-headingxl font-bold", children: l }) });
        },
        h4({ children: l }) {
          return /* @__PURE__ */ le("p", { children: /* @__PURE__ */ le("span", { className: "text-bodylg font-bold", children: l }) });
        },
        ol({ children: l }) {
          return /* @__PURE__ */ le("ol", { className: "text-bodymd [&:not(blockquote_*)]:mb-3 ml-6 list-outside list-decimal", children: l });
        },
        ul({ children: l }) {
          return /* @__PURE__ */ le("ul", { className: "text-bodymd [&:not(blockquote_*)]:mb-3 ml-6 list-outside list-disc", children: l });
        },
        li({ children: l }) {
          return /* @__PURE__ */ le("li", { className: "mt-1", children: /* @__PURE__ */ le("span", { className: "relative", children: l }) });
        },
        a({ node: l, ...o }) {
          var f;
          if (!l) return null;
          let c;
          try {
            c = new URL(((f = l.properties.href) == null ? void 0 : f.toString()) || "");
          } catch (h) {
            return console.error(h), null;
          }
          return /* @__PURE__ */ le(
            "a",
            {
              ...o,
              "aria-label": o.children ? void 0 : "Link to " + c.href,
              className: "text-textLink hover:text-textLinkHover underline",
              href: c.href,
              rel: "noopener noreferrer",
              target: "_blank",
              tabIndex: 0
            }
          );
        },
        table({ children: l }) {
          return /* @__PURE__ */ le("table", { className: "border-interactiveBorder rounded-xs mb-3 w-full table-fixed border", children: l });
        },
        thead({ children: l }) {
          return /* @__PURE__ */ le("thead", { className: "border-interactiveBorder bg-interfaceBgDefault border-b", children: l });
        },
        tr({ children: l }) {
          return /* @__PURE__ */ le("tr", { className: "not-last:border-interfaceBorder not-last:border-b", children: l });
        },
        th({ children: l }) {
          return /* @__PURE__ */ le("th", { className: "border-interfaceBorder text-bodymd not-last:border-r px-3 py-2", children: l });
        },
        td({ children: l }) {
          return /* @__PURE__ */ le("td", { className: "border-interfaceBorder text-bodymd bg-textWhite not-last:border-r p-3 align-top", children: l });
        },
        ...r
      },
      children: e
    }
  );
}
function q1(e) {
  return Ss(e);
}
export {
  Y1 as c,
  q1 as f
};
//# sourceMappingURL=react-D7zVIf_f.js.map
